// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: bilge/api.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { RestError } from "../common/error";
import { Struct } from "../google/protobuf/struct";
import { Timestamp } from "../google/protobuf/timestamp";
import {
  CablingPlanStatus,
  cablingPlanStatusFromJSON,
  cablingPlanStatusToJSON,
  DesignNodeData,
  RuleExecutionException,
} from "../models/cabling";
import { ChatPlatform, chatPlatformFromJSON, chatPlatformToJSON } from "../models/chatbot";
import { DiscoveredDevice } from "../models/claim";
import {
  AirflowType,
  airflowTypeFromJSON,
  airflowTypeToJSON,
  CableType,
  cableTypeFromJSON,
  cableTypeToJSON,
  FabricTopology,
  fabricTopologyFromJSON,
  fabricTopologyToJSON,
  NodeRole,
  nodeRoleFromJSON,
  nodeRoleToJSON,
  NodeType,
  nodeTypeFromJSON,
  nodeTypeToJSON,
} from "../models/fabric";
import { CablingConnection as CablingConnection1, FabricDesign } from "../models/fabric_design";
import {
  AdminState,
  adminStateFromJSON,
  adminStateToJSON,
  OsType,
  osTypeFromJSON,
  osTypeToJSON,
} from "../models/global";

export const protobufPackage = "bilge";

/** ChatbotFeatureFlagState defines the API state of a chatbot feature flag. */
export enum ChatbotFeatureFlagState {
  /** CHATBOT_FEATURE_FLAG_STATE_UNSPECIFIED - Unspecified means "no change" when used in update requests. */
  CHATBOT_FEATURE_FLAG_STATE_UNSPECIFIED = 0,
  /** CHATBOT_FEATURE_FLAG_STATE_ENABLED - Enabled means the feature flag is on. */
  CHATBOT_FEATURE_FLAG_STATE_ENABLED = 1,
  /** CHATBOT_FEATURE_FLAG_STATE_DISABLED - Disabled means the feature flag is off. */
  CHATBOT_FEATURE_FLAG_STATE_DISABLED = 2,
  UNRECOGNIZED = -1,
}

export function chatbotFeatureFlagStateFromJSON(object: any): ChatbotFeatureFlagState {
  switch (object) {
    case 0:
    case "CHATBOT_FEATURE_FLAG_STATE_UNSPECIFIED":
      return ChatbotFeatureFlagState.CHATBOT_FEATURE_FLAG_STATE_UNSPECIFIED;
    case 1:
    case "CHATBOT_FEATURE_FLAG_STATE_ENABLED":
      return ChatbotFeatureFlagState.CHATBOT_FEATURE_FLAG_STATE_ENABLED;
    case 2:
    case "CHATBOT_FEATURE_FLAG_STATE_DISABLED":
      return ChatbotFeatureFlagState.CHATBOT_FEATURE_FLAG_STATE_DISABLED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChatbotFeatureFlagState.UNRECOGNIZED;
  }
}

export function chatbotFeatureFlagStateToJSON(object: ChatbotFeatureFlagState): string {
  switch (object) {
    case ChatbotFeatureFlagState.CHATBOT_FEATURE_FLAG_STATE_UNSPECIFIED:
      return "CHATBOT_FEATURE_FLAG_STATE_UNSPECIFIED";
    case ChatbotFeatureFlagState.CHATBOT_FEATURE_FLAG_STATE_ENABLED:
      return "CHATBOT_FEATURE_FLAG_STATE_ENABLED";
    case ChatbotFeatureFlagState.CHATBOT_FEATURE_FLAG_STATE_DISABLED:
      return "CHATBOT_FEATURE_FLAG_STATE_DISABLED";
    case ChatbotFeatureFlagState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Run CLI commands */
export enum CommandAction {
  ACTION_UNSPECIFIED = 0,
  EXPAND = 1,
  EXPOUND = 2,
  COMPLETE = 3,
  EXECUTE = 4,
  UNRECOGNIZED = -1,
}

export function commandActionFromJSON(object: any): CommandAction {
  switch (object) {
    case 0:
    case "ACTION_UNSPECIFIED":
      return CommandAction.ACTION_UNSPECIFIED;
    case 1:
    case "EXPAND":
      return CommandAction.EXPAND;
    case 2:
    case "EXPOUND":
      return CommandAction.EXPOUND;
    case 3:
    case "COMPLETE":
      return CommandAction.COMPLETE;
    case 4:
    case "EXECUTE":
      return CommandAction.EXECUTE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CommandAction.UNRECOGNIZED;
  }
}

export function commandActionToJSON(object: CommandAction): string {
  switch (object) {
    case CommandAction.ACTION_UNSPECIFIED:
      return "ACTION_UNSPECIFIED";
    case CommandAction.EXPAND:
      return "EXPAND";
    case CommandAction.EXPOUND:
      return "EXPOUND";
    case CommandAction.COMPLETE:
      return "COMPLETE";
    case CommandAction.EXECUTE:
      return "EXECUTE";
    case CommandAction.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ResultFormat {
  RESULT_FORMAT_UNSPECIFIED = 0,
  TEXT = 1,
  JSON = 2,
  HTML = 3,
  MARKDOWN = 4,
  CSV = 5,
  UNRECOGNIZED = -1,
}

export function resultFormatFromJSON(object: any): ResultFormat {
  switch (object) {
    case 0:
    case "RESULT_FORMAT_UNSPECIFIED":
      return ResultFormat.RESULT_FORMAT_UNSPECIFIED;
    case 1:
    case "TEXT":
      return ResultFormat.TEXT;
    case 2:
    case "JSON":
      return ResultFormat.JSON;
    case 3:
    case "HTML":
      return ResultFormat.HTML;
    case 4:
    case "MARKDOWN":
      return ResultFormat.MARKDOWN;
    case 5:
    case "CSV":
      return ResultFormat.CSV;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ResultFormat.UNRECOGNIZED;
  }
}

export function resultFormatToJSON(object: ResultFormat): string {
  switch (object) {
    case ResultFormat.RESULT_FORMAT_UNSPECIFIED:
      return "RESULT_FORMAT_UNSPECIFIED";
    case ResultFormat.TEXT:
      return "TEXT";
    case ResultFormat.JSON:
      return "JSON";
    case ResultFormat.HTML:
      return "HTML";
    case ResultFormat.MARKDOWN:
      return "MARKDOWN";
    case ResultFormat.CSV:
      return "CSV";
    case ResultFormat.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum CliParam {
  CLI_PARAM_UNSPECIFIED = 0,
  NODE_ID = 1,
  LINECARD = 2,
  PORT = 3,
  BREAKOUT = 4,
  UNRECOGNIZED = -1,
}

export function cliParamFromJSON(object: any): CliParam {
  switch (object) {
    case 0:
    case "CLI_PARAM_UNSPECIFIED":
      return CliParam.CLI_PARAM_UNSPECIFIED;
    case 1:
    case "NODE_ID":
      return CliParam.NODE_ID;
    case 2:
    case "LINECARD":
      return CliParam.LINECARD;
    case 3:
    case "PORT":
      return CliParam.PORT;
    case 4:
    case "BREAKOUT":
      return CliParam.BREAKOUT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CliParam.UNRECOGNIZED;
  }
}

export function cliParamToJSON(object: CliParam): string {
  switch (object) {
    case CliParam.CLI_PARAM_UNSPECIFIED:
      return "CLI_PARAM_UNSPECIFIED";
    case CliParam.NODE_ID:
      return "NODE_ID";
    case CliParam.LINECARD:
      return "LINECARD";
    case CliParam.PORT:
      return "PORT";
    case CliParam.BREAKOUT:
      return "BREAKOUT";
    case CliParam.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum CablingDeviceType {
  CABLING_DEVICE_UNSPECIFIED = 0,
  CARIB = 1,
  SIREN = 2,
  UNRECOGNIZED = -1,
}

export function cablingDeviceTypeFromJSON(object: any): CablingDeviceType {
  switch (object) {
    case 0:
    case "CABLING_DEVICE_UNSPECIFIED":
      return CablingDeviceType.CABLING_DEVICE_UNSPECIFIED;
    case 1:
    case "CARIB":
      return CablingDeviceType.CARIB;
    case 2:
    case "SIREN":
      return CablingDeviceType.SIREN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CablingDeviceType.UNRECOGNIZED;
  }
}

export function cablingDeviceTypeToJSON(object: CablingDeviceType): string {
  switch (object) {
    case CablingDeviceType.CABLING_DEVICE_UNSPECIFIED:
      return "CABLING_DEVICE_UNSPECIFIED";
    case CablingDeviceType.CARIB:
      return "CARIB";
    case CablingDeviceType.SIREN:
      return "SIREN";
    case CablingDeviceType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum FabricImageSortField {
  FABRIC_IMAGE_SORT_FIELD_UNSPECIFIED = 0,
  EXPIRE_AT = 1,
  RELEASE_AT = 2,
  UNRECOGNIZED = -1,
}

export function fabricImageSortFieldFromJSON(object: any): FabricImageSortField {
  switch (object) {
    case 0:
    case "FABRIC_IMAGE_SORT_FIELD_UNSPECIFIED":
      return FabricImageSortField.FABRIC_IMAGE_SORT_FIELD_UNSPECIFIED;
    case 1:
    case "EXPIRE_AT":
      return FabricImageSortField.EXPIRE_AT;
    case 2:
    case "RELEASE_AT":
      return FabricImageSortField.RELEASE_AT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FabricImageSortField.UNRECOGNIZED;
  }
}

export function fabricImageSortFieldToJSON(object: FabricImageSortField): string {
  switch (object) {
    case FabricImageSortField.FABRIC_IMAGE_SORT_FIELD_UNSPECIFIED:
      return "FABRIC_IMAGE_SORT_FIELD_UNSPECIFIED";
    case FabricImageSortField.EXPIRE_AT:
      return "EXPIRE_AT";
    case FabricImageSortField.RELEASE_AT:
      return "RELEASE_AT";
    case FabricImageSortField.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * EnvStatus defines an enumeration of hardware operational states.
 *
 * INTERNAL
 *
 * This is identical to EnvStatus in schema.proto
 */
export enum EnvStatus {
  ENV_STATUS_UNSPECIFIED = 0,
  /** OK - The fan is operating as expected. */
  OK = 1,
  /** NOT_OK - The fan has a critical error. */
  NOT_OK = 2,
  /** WARNING - The fan has a potential issue. */
  WARNING = 3,
  /** NOT_PRESENT - The fan status is unknown. */
  NOT_PRESENT = 4,
  UNRECOGNIZED = -1,
}

export function envStatusFromJSON(object: any): EnvStatus {
  switch (object) {
    case 0:
    case "ENV_STATUS_UNSPECIFIED":
      return EnvStatus.ENV_STATUS_UNSPECIFIED;
    case 1:
    case "OK":
      return EnvStatus.OK;
    case 2:
    case "NOT_OK":
      return EnvStatus.NOT_OK;
    case 3:
    case "WARNING":
      return EnvStatus.WARNING;
    case 4:
    case "NOT_PRESENT":
      return EnvStatus.NOT_PRESENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EnvStatus.UNRECOGNIZED;
  }
}

export function envStatusToJSON(object: EnvStatus): string {
  switch (object) {
    case EnvStatus.ENV_STATUS_UNSPECIFIED:
      return "ENV_STATUS_UNSPECIFIED";
    case EnvStatus.OK:
      return "OK";
    case EnvStatus.NOT_OK:
      return "NOT_OK";
    case EnvStatus.WARNING:
      return "WARNING";
    case EnvStatus.NOT_PRESENT:
      return "NOT_PRESENT";
    case EnvStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * EnvLedStatus defines an enumeration of LED states.
 *
 * INTERNAL
 *
 * This is identical to EnvLedStatus in schema.proto
 */
export enum EnvLedStatus {
  ENV_LED_STATUS_UNSPECIFIED = 0,
  GREEN = 1,
  RED = 2,
  OFF = 3,
  UNRECOGNIZED = -1,
}

export function envLedStatusFromJSON(object: any): EnvLedStatus {
  switch (object) {
    case 0:
    case "ENV_LED_STATUS_UNSPECIFIED":
      return EnvLedStatus.ENV_LED_STATUS_UNSPECIFIED;
    case 1:
    case "GREEN":
      return EnvLedStatus.GREEN;
    case 2:
    case "RED":
      return EnvLedStatus.RED;
    case 3:
    case "OFF":
      return EnvLedStatus.OFF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EnvLedStatus.UNRECOGNIZED;
  }
}

export function envLedStatusToJSON(object: EnvLedStatus): string {
  switch (object) {
    case EnvLedStatus.ENV_LED_STATUS_UNSPECIFIED:
      return "ENV_LED_STATUS_UNSPECIFIED";
    case EnvLedStatus.GREEN:
      return "GREEN";
    case EnvLedStatus.RED:
      return "RED";
    case EnvLedStatus.OFF:
      return "OFF";
    case EnvLedStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * FanDirection defines an enumeration of airflow directions for of Fan.
 *
 * INTERNAL
 *
 * The airflow direction is relative to the port-side. This is identical to FanDirection in schema.proto
 */
export enum FanDirection {
  FAN_DIRECTION_UNSPECIFIED = 0,
  INTAKE = 1,
  EXHAUST = 2,
  UNRECOGNIZED = -1,
}

export function fanDirectionFromJSON(object: any): FanDirection {
  switch (object) {
    case 0:
    case "FAN_DIRECTION_UNSPECIFIED":
      return FanDirection.FAN_DIRECTION_UNSPECIFIED;
    case 1:
    case "INTAKE":
      return FanDirection.INTAKE;
    case 2:
    case "EXHAUST":
      return FanDirection.EXHAUST;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FanDirection.UNRECOGNIZED;
  }
}

export function fanDirectionToJSON(object: FanDirection): string {
  switch (object) {
    case FanDirection.FAN_DIRECTION_UNSPECIFIED:
      return "FAN_DIRECTION_UNSPECIFIED";
    case FanDirection.INTAKE:
      return "INTAKE";
    case FanDirection.EXHAUST:
      return "EXHAUST";
    case FanDirection.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum QsfpDuplex {
  QSFP_DUPLEX_UNSPECIFIED = 0,
  FULL = 1,
  HALF = 2,
  UNRECOGNIZED = -1,
}

export function qsfpDuplexFromJSON(object: any): QsfpDuplex {
  switch (object) {
    case 0:
    case "QSFP_DUPLEX_UNSPECIFIED":
      return QsfpDuplex.QSFP_DUPLEX_UNSPECIFIED;
    case 1:
    case "FULL":
      return QsfpDuplex.FULL;
    case 2:
    case "HALF":
      return QsfpDuplex.HALF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QsfpDuplex.UNRECOGNIZED;
  }
}

export function qsfpDuplexToJSON(object: QsfpDuplex): string {
  switch (object) {
    case QsfpDuplex.QSFP_DUPLEX_UNSPECIFIED:
      return "QSFP_DUPLEX_UNSPECIFIED";
    case QsfpDuplex.FULL:
      return "FULL";
    case QsfpDuplex.HALF:
      return "HALF";
    case QsfpDuplex.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum QsfpAutoNegotiation {
  QSFP_AUTO_NEGOTIATION_UNSPECIFIED = 0,
  QSFP_AUTO_NEGOTIATION_ON = 1,
  QSFP_AUTO_NEGOTIATION_OFF = 2,
  UNRECOGNIZED = -1,
}

export function qsfpAutoNegotiationFromJSON(object: any): QsfpAutoNegotiation {
  switch (object) {
    case 0:
    case "QSFP_AUTO_NEGOTIATION_UNSPECIFIED":
      return QsfpAutoNegotiation.QSFP_AUTO_NEGOTIATION_UNSPECIFIED;
    case 1:
    case "QSFP_AUTO_NEGOTIATION_ON":
      return QsfpAutoNegotiation.QSFP_AUTO_NEGOTIATION_ON;
    case 2:
    case "QSFP_AUTO_NEGOTIATION_OFF":
      return QsfpAutoNegotiation.QSFP_AUTO_NEGOTIATION_OFF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QsfpAutoNegotiation.UNRECOGNIZED;
  }
}

export function qsfpAutoNegotiationToJSON(object: QsfpAutoNegotiation): string {
  switch (object) {
    case QsfpAutoNegotiation.QSFP_AUTO_NEGOTIATION_UNSPECIFIED:
      return "QSFP_AUTO_NEGOTIATION_UNSPECIFIED";
    case QsfpAutoNegotiation.QSFP_AUTO_NEGOTIATION_ON:
      return "QSFP_AUTO_NEGOTIATION_ON";
    case QsfpAutoNegotiation.QSFP_AUTO_NEGOTIATION_OFF:
      return "QSFP_AUTO_NEGOTIATION_OFF";
    case QsfpAutoNegotiation.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum QsfpAdvertisedAutoNegotiation {
  QSFP_ADVERTISED_AUTO_NEGOTIATION_UNSPECIFIED = 0,
  QSFP_ADVERTISED_AUTO_NEGOTIATION_YES = 1,
  QSFP_ADVERTISED_AUTO_NEGOTIATION_NO = 2,
  UNRECOGNIZED = -1,
}

export function qsfpAdvertisedAutoNegotiationFromJSON(object: any): QsfpAdvertisedAutoNegotiation {
  switch (object) {
    case 0:
    case "QSFP_ADVERTISED_AUTO_NEGOTIATION_UNSPECIFIED":
      return QsfpAdvertisedAutoNegotiation.QSFP_ADVERTISED_AUTO_NEGOTIATION_UNSPECIFIED;
    case 1:
    case "QSFP_ADVERTISED_AUTO_NEGOTIATION_YES":
      return QsfpAdvertisedAutoNegotiation.QSFP_ADVERTISED_AUTO_NEGOTIATION_YES;
    case 2:
    case "QSFP_ADVERTISED_AUTO_NEGOTIATION_NO":
      return QsfpAdvertisedAutoNegotiation.QSFP_ADVERTISED_AUTO_NEGOTIATION_NO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QsfpAdvertisedAutoNegotiation.UNRECOGNIZED;
  }
}

export function qsfpAdvertisedAutoNegotiationToJSON(object: QsfpAdvertisedAutoNegotiation): string {
  switch (object) {
    case QsfpAdvertisedAutoNegotiation.QSFP_ADVERTISED_AUTO_NEGOTIATION_UNSPECIFIED:
      return "QSFP_ADVERTISED_AUTO_NEGOTIATION_UNSPECIFIED";
    case QsfpAdvertisedAutoNegotiation.QSFP_ADVERTISED_AUTO_NEGOTIATION_YES:
      return "QSFP_ADVERTISED_AUTO_NEGOTIATION_YES";
    case QsfpAdvertisedAutoNegotiation.QSFP_ADVERTISED_AUTO_NEGOTIATION_NO:
      return "QSFP_ADVERTISED_AUTO_NEGOTIATION_NO";
    case QsfpAdvertisedAutoNegotiation.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum QsfpTransceiver {
  QSFP_TRANSCEIVER_UNSPECIFIED = 0,
  QSFP_TRANSCEIVER_INTERNAL = 1,
  QSFP_TRANSCEIVER_EXTERNAL = 2,
  UNRECOGNIZED = -1,
}

export function qsfpTransceiverFromJSON(object: any): QsfpTransceiver {
  switch (object) {
    case 0:
    case "QSFP_TRANSCEIVER_UNSPECIFIED":
      return QsfpTransceiver.QSFP_TRANSCEIVER_UNSPECIFIED;
    case 1:
    case "QSFP_TRANSCEIVER_INTERNAL":
      return QsfpTransceiver.QSFP_TRANSCEIVER_INTERNAL;
    case 2:
    case "QSFP_TRANSCEIVER_EXTERNAL":
      return QsfpTransceiver.QSFP_TRANSCEIVER_EXTERNAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QsfpTransceiver.UNRECOGNIZED;
  }
}

export function qsfpTransceiverToJSON(object: QsfpTransceiver): string {
  switch (object) {
    case QsfpTransceiver.QSFP_TRANSCEIVER_UNSPECIFIED:
      return "QSFP_TRANSCEIVER_UNSPECIFIED";
    case QsfpTransceiver.QSFP_TRANSCEIVER_INTERNAL:
      return "QSFP_TRANSCEIVER_INTERNAL";
    case QsfpTransceiver.QSFP_TRANSCEIVER_EXTERNAL:
      return "QSFP_TRANSCEIVER_EXTERNAL";
    case QsfpTransceiver.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum QsfpTransceiverModule {
  QSFP_TRANSCEIVER_MODULE_UNSPECIFIED = 0,
  COPPER = 1,
  FIBER = 2,
  FIBER_400GBASE_DR4 = 3,
  FIBER_400GBASE_FR4 = 4,
  FIBER_400GBASE_SR8 = 5,
  FIBER_400GBASE_LR8 = 6,
  UNRECOGNIZED = -1,
}

export function qsfpTransceiverModuleFromJSON(object: any): QsfpTransceiverModule {
  switch (object) {
    case 0:
    case "QSFP_TRANSCEIVER_MODULE_UNSPECIFIED":
      return QsfpTransceiverModule.QSFP_TRANSCEIVER_MODULE_UNSPECIFIED;
    case 1:
    case "COPPER":
      return QsfpTransceiverModule.COPPER;
    case 2:
    case "FIBER":
      return QsfpTransceiverModule.FIBER;
    case 3:
    case "FIBER_400GBASE_DR4":
      return QsfpTransceiverModule.FIBER_400GBASE_DR4;
    case 4:
    case "FIBER_400GBASE_FR4":
      return QsfpTransceiverModule.FIBER_400GBASE_FR4;
    case 5:
    case "FIBER_400GBASE_SR8":
      return QsfpTransceiverModule.FIBER_400GBASE_SR8;
    case 6:
    case "FIBER_400GBASE_LR8":
      return QsfpTransceiverModule.FIBER_400GBASE_LR8;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QsfpTransceiverModule.UNRECOGNIZED;
  }
}

export function qsfpTransceiverModuleToJSON(object: QsfpTransceiverModule): string {
  switch (object) {
    case QsfpTransceiverModule.QSFP_TRANSCEIVER_MODULE_UNSPECIFIED:
      return "QSFP_TRANSCEIVER_MODULE_UNSPECIFIED";
    case QsfpTransceiverModule.COPPER:
      return "COPPER";
    case QsfpTransceiverModule.FIBER:
      return "FIBER";
    case QsfpTransceiverModule.FIBER_400GBASE_DR4:
      return "FIBER_400GBASE_DR4";
    case QsfpTransceiverModule.FIBER_400GBASE_FR4:
      return "FIBER_400GBASE_FR4";
    case QsfpTransceiverModule.FIBER_400GBASE_SR8:
      return "FIBER_400GBASE_SR8";
    case QsfpTransceiverModule.FIBER_400GBASE_LR8:
      return "FIBER_400GBASE_LR8";
    case QsfpTransceiverModule.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum NeighborType {
  UNKNOWN_NEIGHBOR_TYPE = 0,
  /** DRAKE_FABRIC - Our neighbor is a Tortuga node and part of the same fabric */
  DRAKE_FABRIC = 1,
  /** DRAKE_NOT_FABRIC - Our neighbor is a Tortuga node but not part of our fabric */
  DRAKE_NOT_FABRIC = 2,
  UNRECOGNIZED = -1,
}

export function neighborTypeFromJSON(object: any): NeighborType {
  switch (object) {
    case 0:
    case "UNKNOWN_NEIGHBOR_TYPE":
      return NeighborType.UNKNOWN_NEIGHBOR_TYPE;
    case 1:
    case "DRAKE_FABRIC":
      return NeighborType.DRAKE_FABRIC;
    case 2:
    case "DRAKE_NOT_FABRIC":
      return NeighborType.DRAKE_NOT_FABRIC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NeighborType.UNRECOGNIZED;
  }
}

export function neighborTypeToJSON(object: NeighborType): string {
  switch (object) {
    case NeighborType.UNKNOWN_NEIGHBOR_TYPE:
      return "UNKNOWN_NEIGHBOR_TYPE";
    case NeighborType.DRAKE_FABRIC:
      return "DRAKE_FABRIC";
    case NeighborType.DRAKE_NOT_FABRIC:
      return "DRAKE_NOT_FABRIC";
    case NeighborType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum FecType {
  FEC_TYPE_UNSPECIFIED = 0,
  FEC_TYPE_NONE = 1,
  FEC_TYPE_RS = 2,
  FEC_TYPE_FC = 3,
  FEC_TYPE_BASER = 4,
  UNRECOGNIZED = -1,
}

export function fecTypeFromJSON(object: any): FecType {
  switch (object) {
    case 0:
    case "FEC_TYPE_UNSPECIFIED":
      return FecType.FEC_TYPE_UNSPECIFIED;
    case 1:
    case "FEC_TYPE_NONE":
      return FecType.FEC_TYPE_NONE;
    case 2:
    case "FEC_TYPE_RS":
      return FecType.FEC_TYPE_RS;
    case 3:
    case "FEC_TYPE_FC":
      return FecType.FEC_TYPE_FC;
    case 4:
    case "FEC_TYPE_BASER":
      return FecType.FEC_TYPE_BASER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FecType.UNRECOGNIZED;
  }
}

export function fecTypeToJSON(object: FecType): string {
  switch (object) {
    case FecType.FEC_TYPE_UNSPECIFIED:
      return "FEC_TYPE_UNSPECIFIED";
    case FecType.FEC_TYPE_NONE:
      return "FEC_TYPE_NONE";
    case FecType.FEC_TYPE_RS:
      return "FEC_TYPE_RS";
    case FecType.FEC_TYPE_FC:
      return "FEC_TYPE_FC";
    case FecType.FEC_TYPE_BASER:
      return "FEC_TYPE_BASER";
    case FecType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** DeterminationStatus indicates the outcome for a device during topology discovery. */
export enum DeterminationStatus {
  DETERMINATION_STATUS_UNSPECIFIED = 0,
  DETERMINATION_STATUS_INCLUDED = 1,
  DETERMINATION_STATUS_EXCLUDED = 2,
  DETERMINATION_STATUS_MISSING = 3,
  DETERMINATION_STATUS_LLDP = 4,
  UNRECOGNIZED = -1,
}

export function determinationStatusFromJSON(object: any): DeterminationStatus {
  switch (object) {
    case 0:
    case "DETERMINATION_STATUS_UNSPECIFIED":
      return DeterminationStatus.DETERMINATION_STATUS_UNSPECIFIED;
    case 1:
    case "DETERMINATION_STATUS_INCLUDED":
      return DeterminationStatus.DETERMINATION_STATUS_INCLUDED;
    case 2:
    case "DETERMINATION_STATUS_EXCLUDED":
      return DeterminationStatus.DETERMINATION_STATUS_EXCLUDED;
    case 3:
    case "DETERMINATION_STATUS_MISSING":
      return DeterminationStatus.DETERMINATION_STATUS_MISSING;
    case 4:
    case "DETERMINATION_STATUS_LLDP":
      return DeterminationStatus.DETERMINATION_STATUS_LLDP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DeterminationStatus.UNRECOGNIZED;
  }
}

export function determinationStatusToJSON(object: DeterminationStatus): string {
  switch (object) {
    case DeterminationStatus.DETERMINATION_STATUS_UNSPECIFIED:
      return "DETERMINATION_STATUS_UNSPECIFIED";
    case DeterminationStatus.DETERMINATION_STATUS_INCLUDED:
      return "DETERMINATION_STATUS_INCLUDED";
    case DeterminationStatus.DETERMINATION_STATUS_EXCLUDED:
      return "DETERMINATION_STATUS_EXCLUDED";
    case DeterminationStatus.DETERMINATION_STATUS_MISSING:
      return "DETERMINATION_STATUS_MISSING";
    case DeterminationStatus.DETERMINATION_STATUS_LLDP:
      return "DETERMINATION_STATUS_LLDP";
    case DeterminationStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** DeterminationPhase identifies the pipeline stage that produced a determination. */
export enum DeterminationPhase {
  DETERMINATION_PHASE_UNSPECIFIED = 0,
  DETERMINATION_PHASE_EXCLUSION = 1,
  DETERMINATION_PHASE_INVENTORY_WINNOWING = 2,
  DETERMINATION_PHASE_MISSING_DEVICE = 3,
  DETERMINATION_PHASE_LLDP_NEIGHBOR = 4,
  DETERMINATION_PHASE_TIER_ASSIGNMENT = 5,
  UNRECOGNIZED = -1,
}

export function determinationPhaseFromJSON(object: any): DeterminationPhase {
  switch (object) {
    case 0:
    case "DETERMINATION_PHASE_UNSPECIFIED":
      return DeterminationPhase.DETERMINATION_PHASE_UNSPECIFIED;
    case 1:
    case "DETERMINATION_PHASE_EXCLUSION":
      return DeterminationPhase.DETERMINATION_PHASE_EXCLUSION;
    case 2:
    case "DETERMINATION_PHASE_INVENTORY_WINNOWING":
      return DeterminationPhase.DETERMINATION_PHASE_INVENTORY_WINNOWING;
    case 3:
    case "DETERMINATION_PHASE_MISSING_DEVICE":
      return DeterminationPhase.DETERMINATION_PHASE_MISSING_DEVICE;
    case 4:
    case "DETERMINATION_PHASE_LLDP_NEIGHBOR":
      return DeterminationPhase.DETERMINATION_PHASE_LLDP_NEIGHBOR;
    case 5:
    case "DETERMINATION_PHASE_TIER_ASSIGNMENT":
      return DeterminationPhase.DETERMINATION_PHASE_TIER_ASSIGNMENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DeterminationPhase.UNRECOGNIZED;
  }
}

export function determinationPhaseToJSON(object: DeterminationPhase): string {
  switch (object) {
    case DeterminationPhase.DETERMINATION_PHASE_UNSPECIFIED:
      return "DETERMINATION_PHASE_UNSPECIFIED";
    case DeterminationPhase.DETERMINATION_PHASE_EXCLUSION:
      return "DETERMINATION_PHASE_EXCLUSION";
    case DeterminationPhase.DETERMINATION_PHASE_INVENTORY_WINNOWING:
      return "DETERMINATION_PHASE_INVENTORY_WINNOWING";
    case DeterminationPhase.DETERMINATION_PHASE_MISSING_DEVICE:
      return "DETERMINATION_PHASE_MISSING_DEVICE";
    case DeterminationPhase.DETERMINATION_PHASE_LLDP_NEIGHBOR:
      return "DETERMINATION_PHASE_LLDP_NEIGHBOR";
    case DeterminationPhase.DETERMINATION_PHASE_TIER_ASSIGNMENT:
      return "DETERMINATION_PHASE_TIER_ASSIGNMENT";
    case DeterminationPhase.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * GetCandidateInfoWithPasscodeRequest validates the totp passcode and retrieves the remote chat user
 * account candidate information associated with the passcode.
 */
export interface GetCandidateInfoWithPasscodeRequest {
  /** Time based one time passcode generated by the chatbot app to validate the linked account request */
  passcode: string;
}

/** GetCandidateInfoWithPasscodeResponse is the response to GetCandidateInfoWithTotpRequest. */
export interface GetCandidateInfoWithPasscodeResponse {
  candidate: LinkedAccountCandidate | undefined;
}

/**
 * LinkedAccountCandidate encapsulates the information about a remote chatbot user account candidate. The actual candidate information
 * is chat platform specific. It is associated with a passcode. For example, for Discord, the remote candidate account is represented by a guild id and channel id.
 * GetCandidateInfoWithTotpResponse returns a LinkedAccountCandidate as content.
 */
export interface LinkedAccountCandidate {
  /** Time based one time passcode generated by the chatbot app to validate the linked account request. */
  passcode: string;
  /** Chat platform of the remote chat user account. */
  chatPlatform: ChatPlatform;
  /** Discord user account info. */
  discordAccount:
    | DiscordAccount
    | undefined;
  /** Webex user account info */
  webexAccount: WebexAccount | undefined;
}

/** SetLinkedAccountRequest creates a new linked account. */
export interface SetLinkedAccountRequest {
  /** Time based one time password generated by the chatbot app to validate the linked account request. */
  passcode: string;
  /** Local virtual username with "BOTS" provider to be linked with a remote account candidate. */
  userName: string;
  /**
   * Target admin state of the target linked account. The valid values are ENABLED and DISABLED.
   * The default value UNSPECIFIED will result in an invalid state error.
   */
  adminState: AdminState;
}

/** SetLinkedAccountResponse is the response of SetLinkedAccountRequest */
export interface SetLinkedAccountResponse {
  linkedAccount: LinkedAccount | undefined;
}

/** DeleteLinkedAccountRequest changes an existing linked account admin state to DELETED. */
export interface DeleteLinkedAccountRequest {
  /** Identifier of the linked account to be marked as DELETED. */
  accountId: string;
}

/** UpdateLinkedAccountRequest updates an existing linked account identified with an account id. */
export interface UpdateLinkedAccountRequest {
  /** Identifier of the target linked account record to be updated. */
  accountId: string;
  /**
   * Target admin state of the target linked account. The valid values are ENABLED and DISABLED.
   * The default value UNSPECIFIED will result in an invalid state error.
   */
  adminState: AdminState;
}

/** UpdateLinkedAccountResponse is the response of UpdateLinkedAccountRequest. */
export interface UpdateLinkedAccountResponse {
  linkedAccount: LinkedAccount | undefined;
}

/** GetLinkedAccountRequest retrieves a list of linked account. */
export interface GetLinkedAccountsRequest {
  /** Collects the linked accounts for the specified chat platform. If unspecified, returns all linked accounts for that org. */
  chatPlatform: ChatPlatform;
}

/** GetLinkedAccountsResponse is the response of GetLinkedAccountsRequest. It includes a list of LinkedAccount records. */
export interface GetLinkedAccountsResponse {
  linkedAccounts: LinkedAccount[];
}

/** ChatbotFeatureFlags stores organization-scoped chatbot feature flags exposed to the UI. */
export interface ChatbotFeatureFlags {
  /**
   * Controls whether multi-step tool-calling is enabled for the organization.
   * In update requests, UNSPECIFIED leaves the existing value unchanged.
   */
  multiStepToolCalling: ChatbotFeatureFlagState;
}

/** GetChatbotFeatureFlagsRequest retrieves the chatbot feature flag settings for an organization. */
export interface GetChatbotFeatureFlagsRequest {
}

/** ChatbotFeatureFlagsResponse is the response for chatbot feature flag requests. */
export interface ChatbotFeatureFlagsResponse {
  featureFlags: ChatbotFeatureFlags | undefined;
}

/** UpdateChatbotFeatureFlagsRequest updates the chatbot feature flag settings for an organization. */
export interface UpdateChatbotFeatureFlagsRequest {
  featureFlags: ChatbotFeatureFlags | undefined;
}

/** LinkedAccount associates a remote chatbot user account with a local user and tenant. */
export interface LinkedAccount {
  /** Account id of the linked account. */
  accountId: string;
  /** Local virtual username with "BOTS" provider to be linked with a remote account candidate. */
  userName: string;
  /** Admin state of the linked account. */
  adminState: AdminState;
  /** Chat platform the remote chat user account belongs to. */
  chatPlatform: ChatPlatform;
  /** Discord user account info. */
  discordAccount:
    | DiscordAccount
    | undefined;
  /** Webex user account info */
  webexAccount: WebexAccount | undefined;
}

/** DiscordAccount represents a remote Discord user account. */
export interface DiscordAccount {
  /** Discord server id. */
  guildId: string;
  /** Discord server name. */
  guildName: string;
  /** Discord channel id. */
  channelId: string;
  /** Discord channel name. */
  channelName: string;
}

export interface WebexAccount {
  spaceId: string;
  spaceName: string;
}

export interface SlackAccount {
  workspaceId: string;
  workspaceName: string;
  channelId: string;
  channelName: string;
}

/**
 * Invitation represents a chatbot distribution pointer for a particular platform. The end user can use
 * the invitation entry to add the chatbot to a chat space.
 * The actual nature of the invitation entry varies from platform to platform. For Discord, it's a URL. For Webex, it's
 * the bot username in the form of an email address.
 */
export interface Invitation {
  /** Platform of the bot */
  chatPlatform: ChatPlatform;
  /** Bot invitation link or in case of webex bot, bot username (email) */
  entry: string;
}

/** GetInvitationsRequest defines the request to retrieve chatbot invitation entries for all supported chat platforms */
export interface GetInvitationsRequest {
}

/** GetInvitationsResponse defines the response to GetInvitationsRequest. It contains a set of the chatbot invitation entries */
export interface GetInvitationsResponse {
  invitations: Invitation[];
}

export interface CliCommandParams {
  /** The parameter name. */
  cliParam: CliParam;
  /** The parameter value. */
  value: string;
}

export interface CliCommandRequest {
  /** The CLI command to run. */
  command: string;
  /**
   * The action to perform on the command.
   * can be expand, expound, complete, execute.
   * The default action is execute.
   */
  action: CommandAction;
  /** The fabric id that the the CLI command is is scoped to for */
  fabricId: string;
  /**
   * The rendering method for the CLI output.
   * The Rendering format can be specified as text, json, html, markdown, or csv.
   * The default format is text when no rendering format is specified.
   * csv format is only applicable to the results field and when the action is "execute".
   * Additionally, csv format is only considered for cli commands that specify the keyword "table".
   * csv format specified for any command that does not specify the cli keyword table, will be ignored and will default to text mode.
   */
  resultFormat: ResultFormat;
  /**
   * UI cursor position for the command line.
   * Used for computing the UI cusor position for command completions and returned in the response.
   */
  cursorPos: number;
  /** The initial command to return with the response when execution request is completed. */
  initialCommand: string;
  /** The device id to scope the CLI command to. */
  deviceId: string;
}

export interface StopCliCommandRequest {
  /** The device id to scope the CLI command to. */
  deviceId: string;
  /** live tool command session id */
  sessionId: string;
}

/**
 * CliCommandOutput represents the output of a CLI command.
 * The CLI command output varies based on the command and the action.
 * The output may contain a token, help string, and the actual command output.
 */
export interface CliCommandCompletion {
  /** optional field. Not populated for Execute action. */
  keyword: string;
  /** optional field, only populated for expound action. */
  helpString: string;
}

export interface CliCommandResponse {
  /** action that was run: expand, expound, complete, execute */
  cmdAction: CommandAction;
  /** cli command that was run */
  command: string;
  /**
   * optional field. only populated for execute action. contains the data fetched from a threadlist
   * contents of the results field are base64 encoded
   */
  executionResults: string;
  /**
   * command_completions field contains possible completions for actions such as expound, expand and complete.
   * It is not populated for execute action.
   */
  commandCompletions: CliCommandCompletion[];
  /**
   * format for the execution_results and completions fields: can be text, json, html, markdown, or csv.
   * the execution_results field contents are in csv format, only if the request specified result_format as csv and execution_results returned is in a tabular format.
   */
  resultFormat: ResultFormat;
  /**
   * UI cursor position in the command string.
   * cursor_pos represents the character index in the command string where the cursor should be placed.
   */
  cursorPos: number;
  /** Indicates if the command is a valid command and can be executed at the current cursor position. */
  validCommand: boolean;
  /**
   * the longest_common_substring field contains the unambiguous portion of a substring for the command completion.
   * in case of an unambiguous match for the string, the command_completions field is nil,
   * an the longest_common_substring field contains the matching string and no error is returned.
   * in case of an ambiguous match for the substring, longest_common_substring field contains the unambiguous portion of the substring,
   * and the command_completions field contains the list of possible substrings needed to make the longest_common_substring unambiguous and no error is returned.
   * In case of no match for the substring, an error is returned and the longest_common_substring field is nil and command_completions fields are nil.
   * when the substring being matched is empty, the longest_common_substring field is nil and the command_completions field contains the list of all possible completions.
   */
  longestCommonSubstring: string;
  error: string;
  /** live tool command session id */
  sessionId: string;
  deviceId: string;
}

export interface CablingRemotePort {
  nodeId: string;
  port: CablingPort | undefined;
}

export interface CablingPort {
  /** 1-based linecard index */
  lineCard: number;
  /** 1-based port index */
  port: number;
  /** 0 for no-breakout, otherwise 1-based */
  breakout: number;
  /** Speed of the port in Gbps */
  portSpeed: number;
  /** Max speed of the port in Gbps */
  portMaxSpeed: number;
  /** Expected cable type for this port */
  expectedCableType: CableType;
  /** Speed of the cable in Gbps in use for this port */
  cableSpeed: number;
  /** Type of the cable in use for this port */
  cableType: number;
}

export interface CablingConnection {
  from: CablingPort | undefined;
  to: CablingRemotePort | undefined;
}

export interface CablingDevice {
  deviceType: CablingDeviceType;
  /** Node ID for this device slot (UUID) */
  nodeId: string;
  /** List of ports to use for fabric to fabric connections */
  FabricPorts: CablingPort[];
  /** List of backup ports that could be used for fabric to fabric connections if need be but would require role change to fabric */
  AdditionalPorts: CablingPort[];
  /** In request used to indicate pre-existing cabling, in the response used to indicate the cabling solution */
  connections: CablingConnection[];
  /** Device ID for this device slot (MAC address) */
  deviceId: string;
}

export interface CablingRequest {
  fabricId: string;
  leafs: CablingDevice[];
  /** For full mesh on leafs, omit spines */
  spines: CablingDevice[];
  /** Integer value specifying how many links should be made between each device */
  order: number;
  dryRun: boolean;
  failFast: boolean;
  includeCablingPlan: boolean;
  /** The fabric design to evaluate */
  design:
    | FabricDesign
    | undefined;
  /** @deprecated */
  orgId: string;
  nodeData: DesignNodeData[];
  excludeObservedStateDataInResponse: boolean;
}

export interface CablingResponse {
  leafs: CablingDevice[];
  spines: CablingDevice[];
  connections: CablingConnection1[];
  execStatus: CablingPlanStatus;
  exceptions: RuleExecutionException[];
  observedConnections: CablingConnection1[];
}

/** Message to get a list of target images for the device image update */
export interface GetImageTargetsRequest {
  /** The lookback window in days */
  lookbackDays: number;
  /** The image release types */
  releaseTypes: string[];
  /** The field for sorting the returning target image list */
  sortField: FabricImageSortField;
  /** The fabricId or name of the fabric intended for the image update */
  fabricId: string;
}

/** Message to provide the list of target images */
export interface GetImageTargetsResponse {
  /** The latest release image info */
  latest:
    | ReleaseImageInfo
    | undefined;
  /** The list of the images updated in the past lookback_days */
  fabricImages: FabricImageInfo[];
  /** The list of the available images other than the latest released in the past lookback_days */
  otherImages: ReleaseImageInfo[];
}

/** Message to provide the image information that has been applied to a fabric */
export interface FabricImageInfo {
  /** The fabric id */
  fabricId: string;
  /** The fabric name */
  fabricName: string;
  /** The image release tag */
  tag: string;
  /** The time when this image is applied to the fabric */
  releaseAt:
    | Date
    | undefined;
  /** The expected image expire time */
  expireAt:
    | Date
    | undefined;
  /** The release document link */
  docLink: string;
}

/** Message to provide the switch group image configuration */
export interface SwitchGroupImageInfo {
  /** The fabric id */
  fabricId: string;
  /** The switch group id */
  switchGroupId: string;
  /** The switch group name */
  name: string;
  /** The switch group short name */
  shortName: string;
  /** The current target image release tag if configured */
  targetTag: string;
  /** The planned deploy time */
  deployAt:
    | Date
    | undefined;
  /** The expected image expire time */
  expireAt:
    | Date
    | undefined;
  /** The platform of the switch group (e.g. N9K-C93108TC-FX3) */
  boundPlatform: string;
  /** Available NXOS images for the switch group's platform */
  images: ReleaseImageInfo[];
}

/** Message to provide information of a release image */
export interface ReleaseImageInfo {
  /** The image release tag */
  tag: string;
  /** The image release time */
  releaseAt:
    | Date
    | undefined;
  /** The expected image expire time */
  expireAt:
    | Date
    | undefined;
  /** The release document link */
  docLink: string;
}

/** Message to get switch group image targets for a fabric */
export interface GetSwitchGroupImageTargetsRequest {
  /** The fabricId or name of the fabric (required) */
  fabricId: string;
  /** The switch group ids (optional, filters to specific switch groups) */
  switchGroupIds: string[];
  /** The image release types */
  releaseTypes: string[];
  /** The lookback window in days */
  lookbackDays: number;
}

/** Message to provide the switch group image targets */
export interface GetSwitchGroupImageTargetsResponse {
  /** The list of switch group image configurations */
  switchGroupImages: SwitchGroupImageInfo[];
}

/** All devices that belong to an org */
export interface GetDevicesForOrgRequest {
}

/** The response to a request for a list of devices. */
export interface GetDevicesForOrgResponse {
  /** A list of devices. */
  devices: Device[];
  /** For large data sets an error may be embedded in the response. */
  error: RestError | undefined;
}

/**
 * A Device is a physical device such as a Cisco 6000 switch managed by Cisco Nexus Hyperfabric
 * that can be bound to a node in a fabric.
 */
export interface Device {
  /** The device identifier of the device. */
  deviceId: string;
  /** The unique identifier of the node to which the device is bound. */
  nodeId: string;
  /** The serial number of the device. */
  serialNumber: string;
  /** The model name of the device. */
  modelName: string;
  /** The unique identifier of the fabric of the node to which the device is bound. */
  fabricId: string;
  /** A list of roles associated with the node to which the device is bound. */
  roles: NodeRole[];
  /** The name of the device. */
  name: string;
  /** The type of the node to which the device is bound. */
  nodeType: NodeType;
  /** The name of the fabric that the devices belongs to. */
  fabricName: string;
  /** The timestamp at which the device was claimed. */
  claimedAt: Date | undefined;
}

/** GetDiscoveredDeviceRequest defines the request of getting discovered device for spider claim */
export interface GetDiscoveredDevicesRequest {
}

/** GetDiscoveredDeviceResponse defines the response of getting discovered device for spider claim */
export interface GetDiscoveredDevicesResponse {
  devices: DiscoveredDevice[];
}

/** Fan encapsulates information related to fans, similar to schema.proto but including device_id instead of the schema path id */
export interface Fan {
  /** The id of the device for the fan. */
  deviceId: string;
  /** The Fan speed as a percentage of the maximum rated speed. */
  speed: number;
  /** The name of the Fan. */
  name: string;
  /** The operational status of the Fan. */
  status: EnvStatus;
  /** The state of the status LED of the Fan. */
  ledStatus: EnvLedStatus;
  /** The tray or drawer to which the Fan belongs to. */
  drawer: string;
  /**
   * The time the data was last collected in
   * [RFC3339](https://datatracker.ietf.org/doc/html/rfc3339#section-5.8) format
   * (e.g. `YYYY-MM-DDTHH:MM:SSZ`).
   */
  collectedAt:
    | Date
    | undefined;
  /** The port-side airflow direction of the Fan. */
  direction: FanDirection;
  /** The serial number of the Fan. */
  serial: string;
  /** The model name of the Fan. */
  model: string;
}

/** A PSU represents an hardware power supply unit of a Device. */
export interface Psu {
  /** The id of the device for the fan. */
  deviceId: string;
  /** The power usage of the PSU. */
  watts: number;
  /** The fan speed as a percentage of the maximum rated speed */
  fanSpeed: number;
  /** The name of the PSU. */
  name: string;
  /** The operational status of the PSU. */
  status: EnvStatus;
  /** The state of the status LED of the PSU. */
  ledStatus: EnvLedStatus;
  /** The model name of the PSU. */
  model: string;
  /** The serial number of the PSU. */
  serial: string;
  /** The input voltage of the PSU in volts (V). */
  voltage: number;
  /** The input current of the PSU in amperes (A). */
  current: number;
}

/** Information about a pluggable transceiver connected to a switch */
export interface QsfpInfo {
  /** the id of the device for the QSFP. */
  deviceId: string;
  /** access point selection hostnames */
  activeApselHostlane1: boolean;
  activeApselHostlane2: boolean;
  activeApselHostlane3: boolean;
  activeApselHostlane4: boolean;
  activeApselHostlane5: boolean;
  activeApselHostlane6: boolean;
  activeApselHostlane7: boolean;
  activeApselHostlane8: boolean;
  /** the QSFP active firmware */
  activeFirmware: string;
  /** This will likely be truncated but that is fine. */
  applicationAdvertisement: string;
  /** the QSFP cable length */
  cableLength: number;
  /** the QSFP cable type */
  cableType: string;
  /** the common management interface specification version */
  cmisRev: number;
  /** the QSFP connector */
  connector: string;
  /** the digital optical monitoring capability */
  domCapability: string;
  encoding: string;
  /** the external identifier of the QSFP */
  extIdentifier: string;
  /** the external rate selection compliance of the QSFP */
  extRateselectCompliance: string;
  /** the QSFP hardware specification */
  hardwareRev: number;
  /** the QSFP host electrical interface */
  hostElectricalInterface: string;
  /** the QSFP host lane assignment option */
  hostLaneAssignmentOption: number;
  /** number of host lanes of the QSFP */
  hostLaneCount: number;
  /** the QSFP inactive firmware */
  inactiveFirmware: string;
  /** Whether or not the QSFP is replaceable */
  isReplaceable: boolean;
  /** the QSFP manufacturer */
  manufacturer: string;
  /** the media interface code of the QSFP */
  mediaInterfaceCode: string;
  /** the media interface technology of the QSFP */
  mediaInterfaceTechnology: string;
  /** the media lane assignment option of the QSFP */
  mediaLaneAssignmentOption: number;
  /** the QSFP number of media lanes */
  mediaLaneCount: number;
  /** the model name of the QSFP */
  model: string;
  /** QSFP nominal bit rate */
  nominalBitRate: number;
  /** the serial number of the QSFP */
  serial: string;
  /** the QSFP specification compliance */
  specificationCompliance: string;
  /** the QSFP max laser frequency: in Gbaud/s */
  supportedMaxLaserFreq: number;
  /** the QSFP max tx power: in dBm */
  supportedMaxTxPower: number;
  /** the QSFP min laser frequency: in Gbaud/s */
  supportedMinLaserFreq: number;
  /** the QSFP min tx power: in dBm */
  supportedMinTxPower: number;
  /** the type of QSFP */
  type: string;
  /** the vendor date timestamp UTC */
  vendorDate:
    | Date
    | undefined;
  /** the three octets of the MAC address that identify the vendor of the QSFP */
  vendorOui: string;
  /** the vendors revision of the QSFP */
  vendorRev: string;
  /** the QSFP transceiver module type */
  transceiverModule: QsfpTransceiverModule;
  /** the QSFP product identification */
  pid: string;
  /** the name of the QSFP physical interface */
  interfaceName: string;
  /** the QSFP neighbor type */
  neighborType: NeighborType;
  /** collected at timestamp: in UTC */
  collectedAt:
    | Date
    | undefined;
  /** the QSFP duplex */
  duplex: QsfpDuplex;
  /** the QSFP advertised auto negotiation */
  advertisedAutoNegotiation: QsfpAdvertisedAutoNegotiation;
  /** the QSFP transceiver type (internal/external) */
  transceiver: QsfpTransceiver;
  /** the QSFP physical address */
  phyAd: number;
  /** the WakeOnLAN network message */
  wakeOn: string;
  /** the advertised fec type */
  advertisedFec: FecType;
  /** the advertised pause fram use */
  advertisedPauseFrameUse: string;
  /** the QSFP auto negotiation type */
  autoNegotiation: QsfpAutoNegotiation;
  /** the QSFP port alias */
  portAlias: string;
  /** the QSFP lot number */
  lot: string;
}

export interface GetAllFansRequest {
}

export interface GetAllFansResponse {
  fans: Fan[];
}

export interface GetAllPsusRequest {
}

export interface GetAllPsusResponse {
  psus: Psu[];
}

export interface GetAllPluggablesRequest {
}

export interface GetAllPluggablesResponse {
  pluggables: QsfpInfo[];
}

export interface InventoryCount {
  name: string;
  count: number;
}

/** GetInventoryCountsRequest defines the request of getting the counts of inventory items for org */
export interface GetInventoryCountsRequest {
}

export interface GetInventoryCountsResponse {
  fanCounts: InventoryCount[];
  psuCounts: InventoryCount[];
  pluggableCounts: InventoryCount[];
}

export interface StreamOrgDataRequest {
}

/**
 * GetFabricConfigDiffRequest defines a request message to get the line-by-line diff between
 * running and candidate configurations for a specific fabric.
 */
export interface GetFabricConfigDiffRequest {
  /** The fabric identifier. */
  fabricId: string;
  /** Exclude the tenants configuration from the diff. */
  noTenants: boolean;
}

/** The response containing the line-by-line diff between running and candidate configurations. */
export interface GetFabricConfigDiffResponse {
  /** The fabric identifier. */
  fabricId: string;
  /** The actual diff content in the unified format. */
  diffContent: string;
}

/**
 * GetDciConfigDiffRequest defines a request message to get the line-by-line diff between
 * running and edit configurations for a specific DCI.
 */
export interface GetDciConfigDiffRequest {
  /** The DCI identifier. */
  dciId: string;
}

/**
 * The GetDciConfigDiffResponse containing the line-by-line diff between running and edit configurations
 * for a DCI.
 */
export interface GetDciConfigDiffResponse {
  /** The DCI identifier. */
  dciId: string;
  /** The actual diff content in the unified format. */
  diffContent: string;
}

/**
 * GetFabricConfigRevisionDiffRequest defines a request message to get the line-by-line diff between two config
 * revisions for a fabric
 */
export interface GetFabricConfigRevisionDiffRequest {
  /** The fabric identifier or name */
  fabricId: string;
  /** The revision id selected to compare */
  revisionId: string;
  /** optional revision id to diff from, if absent, diff from the current running config */
  fromRevisionId: string;
}

/** GetFabricConfigRevisionDiffResponse contains the line-by-line diff between two config revisions for a fabric. */
export interface GetFabricConfigRevisionDiffResponse {
  /** The fabric identifier. */
  fabricId: string;
  /** The actual diff content in the unified format. */
  diffContent: string;
}

/**
 * JsonRpcRequest wraps a JSON-RPC 2.0 request payload for MCP server communication.
 * The marshaler detects the "jsonrpc" key in the raw JSON body and wraps it into this message.
 */
export interface JsonRpcRequest {
  /** The complete JSON-RPC request payload as a flexible Struct. */
  payload: { [key: string]: any } | undefined;
}

/** JsonRpcResponse wraps a JSON-RPC 2.0 response payload for MCP server communication. */
export interface JsonRpcResponse {
  /** The complete JSON-RPC response payload as a flexible Struct. */
  payload: { [key: string]: any } | undefined;
}

/**
 * DiscoverTopologyRequest initiates or refines LLDP topology discovery for unbound, monitored devices.
 * The algorithm always runs fresh from telemetry. Optional fields act as explicit overrides
 * applied at the appropriate step — no previous state is needed.
 * On first call send an empty request. On subsequent calls, add overrides to refine results.
 */
export interface DiscoverTopologyRequest {
  /** Device IDs (MAC addresses) to exclude from discovery. */
  excludeDeviceIds: string[];
  /** Per-cluster overrides for topology type and/or tier count. */
  clusterOverrides: ClusterOverride[];
  /** Per-device role overrides. */
  deviceOverrides: DeviceOverride[];
  /**
   * Hostname-based role patterns. Each entry maps a regex to a role.
   * Applied in order — first matching pattern wins. Evaluated after explicit device_overrides.
   */
  hostnameRoleHints: HostnameRoleHint[];
}

/** ClusterOverride provides per-cluster overrides applied during topology discovery. */
export interface ClusterOverride {
  /** Cluster ID from a previous DiscoverTopologyResponse. */
  clusterId: string;
  /**
   * Forces the algorithm to use this topology type instead of auto-detecting.
   * MESH and SPINE_LEAF are supported; use tier_count to distinguish multi-tier variants.
   */
  topologyType: FabricTopology;
  /**
   * Expected number of tiers (2 = standard spine-leaf, 3+ = multi-tier).
   * Only meaningful when topology type is SPINE_LEAF.
   */
  tierCount: number;
}

/** DeviceOverride provides per-device overrides applied during topology discovery. */
export interface DeviceOverride {
  /** Device ID (MAC address). */
  deviceId: string;
  /** Role to assign to this device, overriding automatic role assignment. */
  role: NodeRole;
}

/**
 * HostnameRoleHint maps a hostname regex pattern to a node role.
 * Used in DiscoverTopologyRequest to automatically assign roles based on device hostnames.
 */
export interface HostnameRoleHint {
  /** Regular expression pattern matched against device hostnames. */
  pattern: string;
  /** Role to assign when the pattern matches. */
  role: NodeRole;
}

/** DiscoverTopologyResponse contains the results of LLDP topology discovery. */
export interface DiscoverTopologyResponse {
  /**
   * The discovered clusters. Each is an independent connected component of LLDP-linked devices.
   * A cluster is NOT necessarily a fabric: AI cluster topologies produce multiple clusters
   * that the user groups into a single fabric.
   */
  clusters: TopologyCluster[];
  /** LLDP neighbors that could not be resolved to any known or missing device. */
  unknownNeighbors: TopologyUnknownNeighbor[];
  /** External BGP sessions that triggered border device detection. */
  borderLinks: TopologyBorderLink[];
  /** Per-device determination messages explaining algorithm decisions. */
  determinations: TopologyDetermination[];
}

/**
 * TopologyCluster represents a single discovered cluster (connected component).
 * The response may contain multiple clusters when the org's parking lot has devices
 * from independent networks (no LLDP links between them).
 */
export interface TopologyCluster {
  /** Deterministic cluster ID derived from the lowest MAC address in the cluster. */
  clusterId: string;
  /** The detected topology type (MESH, SPINE_LEAF, etc). */
  topologyType: FabricTopology;
  /** The tiers that make up this cluster, ordered top-down. */
  tiers: TopologyTier[];
  /**
   * The AS numbers observed across devices in this cluster (from BgpNeighborInfoType).
   * Typically one value for a single-AS cluster; multiple if the cluster spans AS boundaries.
   */
  asNumbers: number[];
  /** Connectivity rules between switch groups in this cluster. */
  connectivityRules: TopologyConnectivityRule[];
  /** Devices detected via LLDP but not present in the org (agent not installed or not claimed). */
  missingDevices: TopologyMissingDevice[];
  /** LLDP neighbors resolved to devices already bound to an existing fabric. */
  fabricLinks: TopologyFabricLink[];
}

/** TopologyTier represents a tier in the discovered topology (e.g. spine tier, leaf tier). */
export interface TopologyTier {
  /** Tier name, auto-generated (e.g. "Spine Tier", "Leaf Tier"). */
  name: string;
  /** Role assigned to devices in this tier. */
  role: NodeRole;
  /** Position of this tier (0 = top). */
  position: number;
  /** Switch groups within this tier, ordered left-to-right. */
  switchGroups: TopologySwitchGroup[];
}

/** TopologySwitchGroup represents a group of devices sharing the same model within a tier. */
export interface TopologySwitchGroup {
  /** Auto-generated name based on model (e.g. "N9K-C9336C-FX2 Group"). */
  name: string;
  /** Position within the tier (0-based, left-to-right). */
  position: number;
  /** The device model shared by all devices in this group (matches Device.model_name). */
  modelName: string;
  /**
   * Device IDs (MAC addresses) in this group, ordered deterministically.
   * UI can join on device_id with GetDevicesForOrg for full device details.
   */
  deviceIds: string[];
  /** Sub-groups by hardware properties (airflow direction, PSU model). */
  hardwareSets: TopologyHardwareSet[];
  /** OS type shared by devices in this group. */
  osType: OsType;
}

/** TopologyHardwareSet groups devices within a switch group by shared hardware properties. */
export interface TopologyHardwareSet {
  /** PSU model name shared by devices in this set. */
  psuModel: string;
  /** Airflow direction shared by devices in this set. */
  airflow: AirflowType;
  /** Device IDs (MAC addresses) in this hardware set. */
  deviceIds: string[];
}

/** TopologyConnectivityRule describes the link pattern between two switch groups. */
export interface TopologyConnectivityRule {
  /** Source switch group name. */
  srcGroup: string;
  /** Destination switch group name. */
  dstGroup: string;
  /** Number of links between each device pair across the two groups. */
  linksPerPair: number;
}

/** TopologyMissingDevice represents a device seen via LLDP but not claimed in the org. */
export interface TopologyMissingDevice {
  /** MAC address of the missing device (also appears in tier/group device_ids). */
  deviceId: string;
  /** Original LLDP remote device ID string. */
  remoteId: string;
  /** Device IDs of monitored devices that see this missing device via LLDP. */
  reportedBy: string[];
  /** Hardware model inferred from the connection pattern, may be empty. */
  inferredModel: string;
  /** LLDP System Name TLV from the remote peer, may be empty. */
  remoteSysName: string;
}

/** TopologyFabricLink represents an LLDP neighbor resolved to a device in an existing fabric. */
export interface TopologyFabricLink {
  /** Device ID of the fabric-bound neighbor. */
  remoteDeviceId: string;
  /** Fabric ID the neighbor belongs to. */
  fabricId: string;
  /** Device IDs of discovery-target devices that see this fabric neighbor via LLDP. */
  reportedBy: string[];
}

/** TopologyUnknownNeighbor represents an LLDP neighbor that could not be resolved. */
export interface TopologyUnknownNeighbor {
  /** Remote device identifier from LLDP. */
  remoteDeviceId: string;
  /** Remote system name from LLDP System Name TLV. */
  remoteSysName: string;
  /** Device IDs of the monitored devices that reported this neighbor via LLDP. */
  seenByDeviceIds: string[];
  /** Remote system description from LLDP System Description TLV. */
  remoteSysDescription: string;
}

/** TopologyBorderLink represents an external BGP session that triggered border detection. */
export interface TopologyBorderLink {
  /** Device ID of the border device. */
  localDeviceId: string;
  /** Local AS number. */
  localAs: number;
  /** Remote AS number. */
  remoteAs: number;
  /** Hostname of the external peer. */
  peerHostname: string;
}

/** TopologyDetermination records a per-device decision made during topology discovery. */
export interface TopologyDetermination {
  /** Device MAC address. */
  deviceId: string;
  /** Device hostname. */
  hostname: string;
  /** Determination outcome. */
  status: DeterminationStatus;
  /** Human-readable explanation of the decision. */
  message: string;
  /** Pipeline phase that produced this determination. */
  phase: DeterminationPhase;
  /** Switch group the device was assigned to (backfilled after grouping). */
  switchGroup: string;
  /** Binding order within the switch group (1-indexed, 0 = unset). */
  bindingOrder: number;
  /** Device IDs that reported this device via LLDP (only set when status is MISSING). */
  missingReportedBy: string[];
}

function createBaseGetCandidateInfoWithPasscodeRequest(): GetCandidateInfoWithPasscodeRequest {
  return { passcode: "" };
}

export const GetCandidateInfoWithPasscodeRequest: MessageFns<GetCandidateInfoWithPasscodeRequest> = {
  encode(message: GetCandidateInfoWithPasscodeRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.passcode !== "") {
      writer.uint32(10).string(message.passcode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCandidateInfoWithPasscodeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCandidateInfoWithPasscodeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.passcode = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCandidateInfoWithPasscodeRequest {
    return { passcode: isSet(object.passcode) ? globalThis.String(object.passcode) : "" };
  },

  toJSON(message: GetCandidateInfoWithPasscodeRequest): unknown {
    const obj: any = {};
    if (message.passcode !== "") {
      obj.passcode = message.passcode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCandidateInfoWithPasscodeRequest>, I>>(
    base?: I,
  ): GetCandidateInfoWithPasscodeRequest {
    return GetCandidateInfoWithPasscodeRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCandidateInfoWithPasscodeRequest>, I>>(
    object: I,
  ): GetCandidateInfoWithPasscodeRequest {
    const message = createBaseGetCandidateInfoWithPasscodeRequest();
    message.passcode = object.passcode ?? "";
    return message;
  },
};

function createBaseGetCandidateInfoWithPasscodeResponse(): GetCandidateInfoWithPasscodeResponse {
  return { candidate: undefined };
}

export const GetCandidateInfoWithPasscodeResponse: MessageFns<GetCandidateInfoWithPasscodeResponse> = {
  encode(message: GetCandidateInfoWithPasscodeResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.candidate !== undefined) {
      LinkedAccountCandidate.encode(message.candidate, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCandidateInfoWithPasscodeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCandidateInfoWithPasscodeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.candidate = LinkedAccountCandidate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCandidateInfoWithPasscodeResponse {
    return { candidate: isSet(object.candidate) ? LinkedAccountCandidate.fromJSON(object.candidate) : undefined };
  },

  toJSON(message: GetCandidateInfoWithPasscodeResponse): unknown {
    const obj: any = {};
    if (message.candidate !== undefined) {
      obj.candidate = LinkedAccountCandidate.toJSON(message.candidate);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCandidateInfoWithPasscodeResponse>, I>>(
    base?: I,
  ): GetCandidateInfoWithPasscodeResponse {
    return GetCandidateInfoWithPasscodeResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCandidateInfoWithPasscodeResponse>, I>>(
    object: I,
  ): GetCandidateInfoWithPasscodeResponse {
    const message = createBaseGetCandidateInfoWithPasscodeResponse();
    message.candidate = (object.candidate !== undefined && object.candidate !== null)
      ? LinkedAccountCandidate.fromPartial(object.candidate)
      : undefined;
    return message;
  },
};

function createBaseLinkedAccountCandidate(): LinkedAccountCandidate {
  return { passcode: "", chatPlatform: 0, discordAccount: undefined, webexAccount: undefined };
}

export const LinkedAccountCandidate: MessageFns<LinkedAccountCandidate> = {
  encode(message: LinkedAccountCandidate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.passcode !== "") {
      writer.uint32(10).string(message.passcode);
    }
    if (message.chatPlatform !== 0) {
      writer.uint32(16).int32(message.chatPlatform);
    }
    if (message.discordAccount !== undefined) {
      DiscordAccount.encode(message.discordAccount, writer.uint32(26).fork()).join();
    }
    if (message.webexAccount !== undefined) {
      WebexAccount.encode(message.webexAccount, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LinkedAccountCandidate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLinkedAccountCandidate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.passcode = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.chatPlatform = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.discordAccount = DiscordAccount.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.webexAccount = WebexAccount.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LinkedAccountCandidate {
    return {
      passcode: isSet(object.passcode) ? globalThis.String(object.passcode) : "",
      chatPlatform: isSet(object.chatPlatform) ? chatPlatformFromJSON(object.chatPlatform) : 0,
      discordAccount: isSet(object.discordAccount) ? DiscordAccount.fromJSON(object.discordAccount) : undefined,
      webexAccount: isSet(object.webexAccount) ? WebexAccount.fromJSON(object.webexAccount) : undefined,
    };
  },

  toJSON(message: LinkedAccountCandidate): unknown {
    const obj: any = {};
    if (message.passcode !== "") {
      obj.passcode = message.passcode;
    }
    if (message.chatPlatform !== 0) {
      obj.chatPlatform = chatPlatformToJSON(message.chatPlatform);
    }
    if (message.discordAccount !== undefined) {
      obj.discordAccount = DiscordAccount.toJSON(message.discordAccount);
    }
    if (message.webexAccount !== undefined) {
      obj.webexAccount = WebexAccount.toJSON(message.webexAccount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LinkedAccountCandidate>, I>>(base?: I): LinkedAccountCandidate {
    return LinkedAccountCandidate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LinkedAccountCandidate>, I>>(object: I): LinkedAccountCandidate {
    const message = createBaseLinkedAccountCandidate();
    message.passcode = object.passcode ?? "";
    message.chatPlatform = object.chatPlatform ?? 0;
    message.discordAccount = (object.discordAccount !== undefined && object.discordAccount !== null)
      ? DiscordAccount.fromPartial(object.discordAccount)
      : undefined;
    message.webexAccount = (object.webexAccount !== undefined && object.webexAccount !== null)
      ? WebexAccount.fromPartial(object.webexAccount)
      : undefined;
    return message;
  },
};

function createBaseSetLinkedAccountRequest(): SetLinkedAccountRequest {
  return { passcode: "", userName: "", adminState: 0 };
}

export const SetLinkedAccountRequest: MessageFns<SetLinkedAccountRequest> = {
  encode(message: SetLinkedAccountRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.passcode !== "") {
      writer.uint32(10).string(message.passcode);
    }
    if (message.userName !== "") {
      writer.uint32(26).string(message.userName);
    }
    if (message.adminState !== 0) {
      writer.uint32(32).int32(message.adminState);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetLinkedAccountRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetLinkedAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.passcode = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.userName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.adminState = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetLinkedAccountRequest {
    return {
      passcode: isSet(object.passcode) ? globalThis.String(object.passcode) : "",
      userName: isSet(object.userName) ? globalThis.String(object.userName) : "",
      adminState: isSet(object.adminState) ? adminStateFromJSON(object.adminState) : 0,
    };
  },

  toJSON(message: SetLinkedAccountRequest): unknown {
    const obj: any = {};
    if (message.passcode !== "") {
      obj.passcode = message.passcode;
    }
    if (message.userName !== "") {
      obj.userName = message.userName;
    }
    if (message.adminState !== 0) {
      obj.adminState = adminStateToJSON(message.adminState);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetLinkedAccountRequest>, I>>(base?: I): SetLinkedAccountRequest {
    return SetLinkedAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetLinkedAccountRequest>, I>>(object: I): SetLinkedAccountRequest {
    const message = createBaseSetLinkedAccountRequest();
    message.passcode = object.passcode ?? "";
    message.userName = object.userName ?? "";
    message.adminState = object.adminState ?? 0;
    return message;
  },
};

function createBaseSetLinkedAccountResponse(): SetLinkedAccountResponse {
  return { linkedAccount: undefined };
}

export const SetLinkedAccountResponse: MessageFns<SetLinkedAccountResponse> = {
  encode(message: SetLinkedAccountResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.linkedAccount !== undefined) {
      LinkedAccount.encode(message.linkedAccount, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetLinkedAccountResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetLinkedAccountResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.linkedAccount = LinkedAccount.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetLinkedAccountResponse {
    return { linkedAccount: isSet(object.linkedAccount) ? LinkedAccount.fromJSON(object.linkedAccount) : undefined };
  },

  toJSON(message: SetLinkedAccountResponse): unknown {
    const obj: any = {};
    if (message.linkedAccount !== undefined) {
      obj.linkedAccount = LinkedAccount.toJSON(message.linkedAccount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetLinkedAccountResponse>, I>>(base?: I): SetLinkedAccountResponse {
    return SetLinkedAccountResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetLinkedAccountResponse>, I>>(object: I): SetLinkedAccountResponse {
    const message = createBaseSetLinkedAccountResponse();
    message.linkedAccount = (object.linkedAccount !== undefined && object.linkedAccount !== null)
      ? LinkedAccount.fromPartial(object.linkedAccount)
      : undefined;
    return message;
  },
};

function createBaseDeleteLinkedAccountRequest(): DeleteLinkedAccountRequest {
  return { accountId: "" };
}

export const DeleteLinkedAccountRequest: MessageFns<DeleteLinkedAccountRequest> = {
  encode(message: DeleteLinkedAccountRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteLinkedAccountRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteLinkedAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteLinkedAccountRequest {
    return { accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "" };
  },

  toJSON(message: DeleteLinkedAccountRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteLinkedAccountRequest>, I>>(base?: I): DeleteLinkedAccountRequest {
    return DeleteLinkedAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteLinkedAccountRequest>, I>>(object: I): DeleteLinkedAccountRequest {
    const message = createBaseDeleteLinkedAccountRequest();
    message.accountId = object.accountId ?? "";
    return message;
  },
};

function createBaseUpdateLinkedAccountRequest(): UpdateLinkedAccountRequest {
  return { accountId: "", adminState: 0 };
}

export const UpdateLinkedAccountRequest: MessageFns<UpdateLinkedAccountRequest> = {
  encode(message: UpdateLinkedAccountRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.adminState !== 0) {
      writer.uint32(16).int32(message.adminState);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateLinkedAccountRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateLinkedAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.adminState = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateLinkedAccountRequest {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      adminState: isSet(object.adminState) ? adminStateFromJSON(object.adminState) : 0,
    };
  },

  toJSON(message: UpdateLinkedAccountRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.adminState !== 0) {
      obj.adminState = adminStateToJSON(message.adminState);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateLinkedAccountRequest>, I>>(base?: I): UpdateLinkedAccountRequest {
    return UpdateLinkedAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateLinkedAccountRequest>, I>>(object: I): UpdateLinkedAccountRequest {
    const message = createBaseUpdateLinkedAccountRequest();
    message.accountId = object.accountId ?? "";
    message.adminState = object.adminState ?? 0;
    return message;
  },
};

function createBaseUpdateLinkedAccountResponse(): UpdateLinkedAccountResponse {
  return { linkedAccount: undefined };
}

export const UpdateLinkedAccountResponse: MessageFns<UpdateLinkedAccountResponse> = {
  encode(message: UpdateLinkedAccountResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.linkedAccount !== undefined) {
      LinkedAccount.encode(message.linkedAccount, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateLinkedAccountResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateLinkedAccountResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.linkedAccount = LinkedAccount.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateLinkedAccountResponse {
    return { linkedAccount: isSet(object.linkedAccount) ? LinkedAccount.fromJSON(object.linkedAccount) : undefined };
  },

  toJSON(message: UpdateLinkedAccountResponse): unknown {
    const obj: any = {};
    if (message.linkedAccount !== undefined) {
      obj.linkedAccount = LinkedAccount.toJSON(message.linkedAccount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateLinkedAccountResponse>, I>>(base?: I): UpdateLinkedAccountResponse {
    return UpdateLinkedAccountResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateLinkedAccountResponse>, I>>(object: I): UpdateLinkedAccountResponse {
    const message = createBaseUpdateLinkedAccountResponse();
    message.linkedAccount = (object.linkedAccount !== undefined && object.linkedAccount !== null)
      ? LinkedAccount.fromPartial(object.linkedAccount)
      : undefined;
    return message;
  },
};

function createBaseGetLinkedAccountsRequest(): GetLinkedAccountsRequest {
  return { chatPlatform: 0 };
}

export const GetLinkedAccountsRequest: MessageFns<GetLinkedAccountsRequest> = {
  encode(message: GetLinkedAccountsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatPlatform !== 0) {
      writer.uint32(8).int32(message.chatPlatform);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetLinkedAccountsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetLinkedAccountsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.chatPlatform = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetLinkedAccountsRequest {
    return { chatPlatform: isSet(object.chatPlatform) ? chatPlatformFromJSON(object.chatPlatform) : 0 };
  },

  toJSON(message: GetLinkedAccountsRequest): unknown {
    const obj: any = {};
    if (message.chatPlatform !== 0) {
      obj.chatPlatform = chatPlatformToJSON(message.chatPlatform);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetLinkedAccountsRequest>, I>>(base?: I): GetLinkedAccountsRequest {
    return GetLinkedAccountsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetLinkedAccountsRequest>, I>>(object: I): GetLinkedAccountsRequest {
    const message = createBaseGetLinkedAccountsRequest();
    message.chatPlatform = object.chatPlatform ?? 0;
    return message;
  },
};

function createBaseGetLinkedAccountsResponse(): GetLinkedAccountsResponse {
  return { linkedAccounts: [] };
}

export const GetLinkedAccountsResponse: MessageFns<GetLinkedAccountsResponse> = {
  encode(message: GetLinkedAccountsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.linkedAccounts) {
      LinkedAccount.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetLinkedAccountsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetLinkedAccountsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.linkedAccounts.push(LinkedAccount.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetLinkedAccountsResponse {
    return {
      linkedAccounts: globalThis.Array.isArray(object?.linkedAccounts)
        ? object.linkedAccounts.map((e: any) => LinkedAccount.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetLinkedAccountsResponse): unknown {
    const obj: any = {};
    if (message.linkedAccounts?.length) {
      obj.linkedAccounts = message.linkedAccounts.map((e) => LinkedAccount.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetLinkedAccountsResponse>, I>>(base?: I): GetLinkedAccountsResponse {
    return GetLinkedAccountsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetLinkedAccountsResponse>, I>>(object: I): GetLinkedAccountsResponse {
    const message = createBaseGetLinkedAccountsResponse();
    message.linkedAccounts = object.linkedAccounts?.map((e) => LinkedAccount.fromPartial(e)) || [];
    return message;
  },
};

function createBaseChatbotFeatureFlags(): ChatbotFeatureFlags {
  return { multiStepToolCalling: 0 };
}

export const ChatbotFeatureFlags: MessageFns<ChatbotFeatureFlags> = {
  encode(message: ChatbotFeatureFlags, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.multiStepToolCalling !== 0) {
      writer.uint32(8).int32(message.multiStepToolCalling);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatbotFeatureFlags {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatbotFeatureFlags();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.multiStepToolCalling = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatbotFeatureFlags {
    return {
      multiStepToolCalling: isSet(object.multiStepToolCalling)
        ? chatbotFeatureFlagStateFromJSON(object.multiStepToolCalling)
        : 0,
    };
  },

  toJSON(message: ChatbotFeatureFlags): unknown {
    const obj: any = {};
    if (message.multiStepToolCalling !== 0) {
      obj.multiStepToolCalling = chatbotFeatureFlagStateToJSON(message.multiStepToolCalling);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatbotFeatureFlags>, I>>(base?: I): ChatbotFeatureFlags {
    return ChatbotFeatureFlags.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatbotFeatureFlags>, I>>(object: I): ChatbotFeatureFlags {
    const message = createBaseChatbotFeatureFlags();
    message.multiStepToolCalling = object.multiStepToolCalling ?? 0;
    return message;
  },
};

function createBaseGetChatbotFeatureFlagsRequest(): GetChatbotFeatureFlagsRequest {
  return {};
}

export const GetChatbotFeatureFlagsRequest: MessageFns<GetChatbotFeatureFlagsRequest> = {
  encode(_: GetChatbotFeatureFlagsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetChatbotFeatureFlagsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetChatbotFeatureFlagsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetChatbotFeatureFlagsRequest {
    return {};
  },

  toJSON(_: GetChatbotFeatureFlagsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetChatbotFeatureFlagsRequest>, I>>(base?: I): GetChatbotFeatureFlagsRequest {
    return GetChatbotFeatureFlagsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetChatbotFeatureFlagsRequest>, I>>(_: I): GetChatbotFeatureFlagsRequest {
    const message = createBaseGetChatbotFeatureFlagsRequest();
    return message;
  },
};

function createBaseChatbotFeatureFlagsResponse(): ChatbotFeatureFlagsResponse {
  return { featureFlags: undefined };
}

export const ChatbotFeatureFlagsResponse: MessageFns<ChatbotFeatureFlagsResponse> = {
  encode(message: ChatbotFeatureFlagsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.featureFlags !== undefined) {
      ChatbotFeatureFlags.encode(message.featureFlags, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatbotFeatureFlagsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatbotFeatureFlagsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.featureFlags = ChatbotFeatureFlags.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatbotFeatureFlagsResponse {
    return { featureFlags: isSet(object.featureFlags) ? ChatbotFeatureFlags.fromJSON(object.featureFlags) : undefined };
  },

  toJSON(message: ChatbotFeatureFlagsResponse): unknown {
    const obj: any = {};
    if (message.featureFlags !== undefined) {
      obj.featureFlags = ChatbotFeatureFlags.toJSON(message.featureFlags);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatbotFeatureFlagsResponse>, I>>(base?: I): ChatbotFeatureFlagsResponse {
    return ChatbotFeatureFlagsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatbotFeatureFlagsResponse>, I>>(object: I): ChatbotFeatureFlagsResponse {
    const message = createBaseChatbotFeatureFlagsResponse();
    message.featureFlags = (object.featureFlags !== undefined && object.featureFlags !== null)
      ? ChatbotFeatureFlags.fromPartial(object.featureFlags)
      : undefined;
    return message;
  },
};

function createBaseUpdateChatbotFeatureFlagsRequest(): UpdateChatbotFeatureFlagsRequest {
  return { featureFlags: undefined };
}

export const UpdateChatbotFeatureFlagsRequest: MessageFns<UpdateChatbotFeatureFlagsRequest> = {
  encode(message: UpdateChatbotFeatureFlagsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.featureFlags !== undefined) {
      ChatbotFeatureFlags.encode(message.featureFlags, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateChatbotFeatureFlagsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateChatbotFeatureFlagsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.featureFlags = ChatbotFeatureFlags.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateChatbotFeatureFlagsRequest {
    return { featureFlags: isSet(object.featureFlags) ? ChatbotFeatureFlags.fromJSON(object.featureFlags) : undefined };
  },

  toJSON(message: UpdateChatbotFeatureFlagsRequest): unknown {
    const obj: any = {};
    if (message.featureFlags !== undefined) {
      obj.featureFlags = ChatbotFeatureFlags.toJSON(message.featureFlags);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateChatbotFeatureFlagsRequest>, I>>(
    base?: I,
  ): UpdateChatbotFeatureFlagsRequest {
    return UpdateChatbotFeatureFlagsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateChatbotFeatureFlagsRequest>, I>>(
    object: I,
  ): UpdateChatbotFeatureFlagsRequest {
    const message = createBaseUpdateChatbotFeatureFlagsRequest();
    message.featureFlags = (object.featureFlags !== undefined && object.featureFlags !== null)
      ? ChatbotFeatureFlags.fromPartial(object.featureFlags)
      : undefined;
    return message;
  },
};

function createBaseLinkedAccount(): LinkedAccount {
  return {
    accountId: "",
    userName: "",
    adminState: 0,
    chatPlatform: 0,
    discordAccount: undefined,
    webexAccount: undefined,
  };
}

export const LinkedAccount: MessageFns<LinkedAccount> = {
  encode(message: LinkedAccount, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.userName !== "") {
      writer.uint32(50).string(message.userName);
    }
    if (message.adminState !== 0) {
      writer.uint32(56).int32(message.adminState);
    }
    if (message.chatPlatform !== 0) {
      writer.uint32(64).int32(message.chatPlatform);
    }
    if (message.discordAccount !== undefined) {
      DiscordAccount.encode(message.discordAccount, writer.uint32(74).fork()).join();
    }
    if (message.webexAccount !== undefined) {
      WebexAccount.encode(message.webexAccount, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LinkedAccount {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLinkedAccount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.userName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.adminState = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.chatPlatform = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.discordAccount = DiscordAccount.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.webexAccount = WebexAccount.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LinkedAccount {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      userName: isSet(object.userName) ? globalThis.String(object.userName) : "",
      adminState: isSet(object.adminState) ? adminStateFromJSON(object.adminState) : 0,
      chatPlatform: isSet(object.chatPlatform) ? chatPlatformFromJSON(object.chatPlatform) : 0,
      discordAccount: isSet(object.discordAccount) ? DiscordAccount.fromJSON(object.discordAccount) : undefined,
      webexAccount: isSet(object.webexAccount) ? WebexAccount.fromJSON(object.webexAccount) : undefined,
    };
  },

  toJSON(message: LinkedAccount): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.userName !== "") {
      obj.userName = message.userName;
    }
    if (message.adminState !== 0) {
      obj.adminState = adminStateToJSON(message.adminState);
    }
    if (message.chatPlatform !== 0) {
      obj.chatPlatform = chatPlatformToJSON(message.chatPlatform);
    }
    if (message.discordAccount !== undefined) {
      obj.discordAccount = DiscordAccount.toJSON(message.discordAccount);
    }
    if (message.webexAccount !== undefined) {
      obj.webexAccount = WebexAccount.toJSON(message.webexAccount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LinkedAccount>, I>>(base?: I): LinkedAccount {
    return LinkedAccount.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LinkedAccount>, I>>(object: I): LinkedAccount {
    const message = createBaseLinkedAccount();
    message.accountId = object.accountId ?? "";
    message.userName = object.userName ?? "";
    message.adminState = object.adminState ?? 0;
    message.chatPlatform = object.chatPlatform ?? 0;
    message.discordAccount = (object.discordAccount !== undefined && object.discordAccount !== null)
      ? DiscordAccount.fromPartial(object.discordAccount)
      : undefined;
    message.webexAccount = (object.webexAccount !== undefined && object.webexAccount !== null)
      ? WebexAccount.fromPartial(object.webexAccount)
      : undefined;
    return message;
  },
};

function createBaseDiscordAccount(): DiscordAccount {
  return { guildId: "", guildName: "", channelId: "", channelName: "" };
}

export const DiscordAccount: MessageFns<DiscordAccount> = {
  encode(message: DiscordAccount, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.guildId !== "") {
      writer.uint32(10).string(message.guildId);
    }
    if (message.guildName !== "") {
      writer.uint32(18).string(message.guildName);
    }
    if (message.channelId !== "") {
      writer.uint32(26).string(message.channelId);
    }
    if (message.channelName !== "") {
      writer.uint32(34).string(message.channelName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DiscordAccount {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDiscordAccount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.guildId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.guildName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.channelId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.channelName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DiscordAccount {
    return {
      guildId: isSet(object.guildId) ? globalThis.String(object.guildId) : "",
      guildName: isSet(object.guildName) ? globalThis.String(object.guildName) : "",
      channelId: isSet(object.channelId) ? globalThis.String(object.channelId) : "",
      channelName: isSet(object.channelName) ? globalThis.String(object.channelName) : "",
    };
  },

  toJSON(message: DiscordAccount): unknown {
    const obj: any = {};
    if (message.guildId !== "") {
      obj.guildId = message.guildId;
    }
    if (message.guildName !== "") {
      obj.guildName = message.guildName;
    }
    if (message.channelId !== "") {
      obj.channelId = message.channelId;
    }
    if (message.channelName !== "") {
      obj.channelName = message.channelName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DiscordAccount>, I>>(base?: I): DiscordAccount {
    return DiscordAccount.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DiscordAccount>, I>>(object: I): DiscordAccount {
    const message = createBaseDiscordAccount();
    message.guildId = object.guildId ?? "";
    message.guildName = object.guildName ?? "";
    message.channelId = object.channelId ?? "";
    message.channelName = object.channelName ?? "";
    return message;
  },
};

function createBaseWebexAccount(): WebexAccount {
  return { spaceId: "", spaceName: "" };
}

export const WebexAccount: MessageFns<WebexAccount> = {
  encode(message: WebexAccount, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceId !== "") {
      writer.uint32(10).string(message.spaceId);
    }
    if (message.spaceName !== "") {
      writer.uint32(18).string(message.spaceName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WebexAccount {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebexAccount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebexAccount {
    return {
      spaceId: isSet(object.spaceId) ? globalThis.String(object.spaceId) : "",
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
    };
  },

  toJSON(message: WebexAccount): unknown {
    const obj: any = {};
    if (message.spaceId !== "") {
      obj.spaceId = message.spaceId;
    }
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebexAccount>, I>>(base?: I): WebexAccount {
    return WebexAccount.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebexAccount>, I>>(object: I): WebexAccount {
    const message = createBaseWebexAccount();
    message.spaceId = object.spaceId ?? "";
    message.spaceName = object.spaceName ?? "";
    return message;
  },
};

function createBaseSlackAccount(): SlackAccount {
  return { workspaceId: "", workspaceName: "", channelId: "", channelName: "" };
}

export const SlackAccount: MessageFns<SlackAccount> = {
  encode(message: SlackAccount, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.workspaceId !== "") {
      writer.uint32(10).string(message.workspaceId);
    }
    if (message.workspaceName !== "") {
      writer.uint32(18).string(message.workspaceName);
    }
    if (message.channelId !== "") {
      writer.uint32(26).string(message.channelId);
    }
    if (message.channelName !== "") {
      writer.uint32(34).string(message.channelName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SlackAccount {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSlackAccount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.workspaceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.workspaceName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.channelId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.channelName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SlackAccount {
    return {
      workspaceId: isSet(object.workspaceId) ? globalThis.String(object.workspaceId) : "",
      workspaceName: isSet(object.workspaceName) ? globalThis.String(object.workspaceName) : "",
      channelId: isSet(object.channelId) ? globalThis.String(object.channelId) : "",
      channelName: isSet(object.channelName) ? globalThis.String(object.channelName) : "",
    };
  },

  toJSON(message: SlackAccount): unknown {
    const obj: any = {};
    if (message.workspaceId !== "") {
      obj.workspaceId = message.workspaceId;
    }
    if (message.workspaceName !== "") {
      obj.workspaceName = message.workspaceName;
    }
    if (message.channelId !== "") {
      obj.channelId = message.channelId;
    }
    if (message.channelName !== "") {
      obj.channelName = message.channelName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SlackAccount>, I>>(base?: I): SlackAccount {
    return SlackAccount.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SlackAccount>, I>>(object: I): SlackAccount {
    const message = createBaseSlackAccount();
    message.workspaceId = object.workspaceId ?? "";
    message.workspaceName = object.workspaceName ?? "";
    message.channelId = object.channelId ?? "";
    message.channelName = object.channelName ?? "";
    return message;
  },
};

function createBaseInvitation(): Invitation {
  return { chatPlatform: 0, entry: "" };
}

export const Invitation: MessageFns<Invitation> = {
  encode(message: Invitation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatPlatform !== 0) {
      writer.uint32(8).int32(message.chatPlatform);
    }
    if (message.entry !== "") {
      writer.uint32(18).string(message.entry);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Invitation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInvitation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.chatPlatform = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.entry = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Invitation {
    return {
      chatPlatform: isSet(object.chatPlatform) ? chatPlatformFromJSON(object.chatPlatform) : 0,
      entry: isSet(object.entry) ? globalThis.String(object.entry) : "",
    };
  },

  toJSON(message: Invitation): unknown {
    const obj: any = {};
    if (message.chatPlatform !== 0) {
      obj.chatPlatform = chatPlatformToJSON(message.chatPlatform);
    }
    if (message.entry !== "") {
      obj.entry = message.entry;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Invitation>, I>>(base?: I): Invitation {
    return Invitation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Invitation>, I>>(object: I): Invitation {
    const message = createBaseInvitation();
    message.chatPlatform = object.chatPlatform ?? 0;
    message.entry = object.entry ?? "";
    return message;
  },
};

function createBaseGetInvitationsRequest(): GetInvitationsRequest {
  return {};
}

export const GetInvitationsRequest: MessageFns<GetInvitationsRequest> = {
  encode(_: GetInvitationsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetInvitationsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetInvitationsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetInvitationsRequest {
    return {};
  },

  toJSON(_: GetInvitationsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetInvitationsRequest>, I>>(base?: I): GetInvitationsRequest {
    return GetInvitationsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetInvitationsRequest>, I>>(_: I): GetInvitationsRequest {
    const message = createBaseGetInvitationsRequest();
    return message;
  },
};

function createBaseGetInvitationsResponse(): GetInvitationsResponse {
  return { invitations: [] };
}

export const GetInvitationsResponse: MessageFns<GetInvitationsResponse> = {
  encode(message: GetInvitationsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.invitations) {
      Invitation.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetInvitationsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetInvitationsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.invitations.push(Invitation.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetInvitationsResponse {
    return {
      invitations: globalThis.Array.isArray(object?.invitations)
        ? object.invitations.map((e: any) => Invitation.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetInvitationsResponse): unknown {
    const obj: any = {};
    if (message.invitations?.length) {
      obj.invitations = message.invitations.map((e) => Invitation.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetInvitationsResponse>, I>>(base?: I): GetInvitationsResponse {
    return GetInvitationsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetInvitationsResponse>, I>>(object: I): GetInvitationsResponse {
    const message = createBaseGetInvitationsResponse();
    message.invitations = object.invitations?.map((e) => Invitation.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCliCommandParams(): CliCommandParams {
  return { cliParam: 0, value: "" };
}

export const CliCommandParams: MessageFns<CliCommandParams> = {
  encode(message: CliCommandParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cliParam !== 0) {
      writer.uint32(8).int32(message.cliParam);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CliCommandParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCliCommandParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.cliParam = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CliCommandParams {
    return {
      cliParam: isSet(object.cliParam) ? cliParamFromJSON(object.cliParam) : 0,
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: CliCommandParams): unknown {
    const obj: any = {};
    if (message.cliParam !== 0) {
      obj.cliParam = cliParamToJSON(message.cliParam);
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CliCommandParams>, I>>(base?: I): CliCommandParams {
    return CliCommandParams.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CliCommandParams>, I>>(object: I): CliCommandParams {
    const message = createBaseCliCommandParams();
    message.cliParam = object.cliParam ?? 0;
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseCliCommandRequest(): CliCommandRequest {
  return { command: "", action: 0, fabricId: "", resultFormat: 0, cursorPos: 0, initialCommand: "", deviceId: "" };
}

export const CliCommandRequest: MessageFns<CliCommandRequest> = {
  encode(message: CliCommandRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.command !== "") {
      writer.uint32(10).string(message.command);
    }
    if (message.action !== 0) {
      writer.uint32(16).int32(message.action);
    }
    if (message.fabricId !== "") {
      writer.uint32(26).string(message.fabricId);
    }
    if (message.resultFormat !== 0) {
      writer.uint32(32).int32(message.resultFormat);
    }
    if (message.cursorPos !== 0) {
      writer.uint32(40).int32(message.cursorPos);
    }
    if (message.initialCommand !== "") {
      writer.uint32(58).string(message.initialCommand);
    }
    if (message.deviceId !== "") {
      writer.uint32(66).string(message.deviceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CliCommandRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCliCommandRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.command = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.action = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.resultFormat = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.cursorPos = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.initialCommand = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CliCommandRequest {
    return {
      command: isSet(object.command) ? globalThis.String(object.command) : "",
      action: isSet(object.action) ? commandActionFromJSON(object.action) : 0,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      resultFormat: isSet(object.resultFormat) ? resultFormatFromJSON(object.resultFormat) : 0,
      cursorPos: isSet(object.cursorPos) ? globalThis.Number(object.cursorPos) : 0,
      initialCommand: isSet(object.initialCommand) ? globalThis.String(object.initialCommand) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
    };
  },

  toJSON(message: CliCommandRequest): unknown {
    const obj: any = {};
    if (message.command !== "") {
      obj.command = message.command;
    }
    if (message.action !== 0) {
      obj.action = commandActionToJSON(message.action);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.resultFormat !== 0) {
      obj.resultFormat = resultFormatToJSON(message.resultFormat);
    }
    if (message.cursorPos !== 0) {
      obj.cursorPos = Math.round(message.cursorPos);
    }
    if (message.initialCommand !== "") {
      obj.initialCommand = message.initialCommand;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CliCommandRequest>, I>>(base?: I): CliCommandRequest {
    return CliCommandRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CliCommandRequest>, I>>(object: I): CliCommandRequest {
    const message = createBaseCliCommandRequest();
    message.command = object.command ?? "";
    message.action = object.action ?? 0;
    message.fabricId = object.fabricId ?? "";
    message.resultFormat = object.resultFormat ?? 0;
    message.cursorPos = object.cursorPos ?? 0;
    message.initialCommand = object.initialCommand ?? "";
    message.deviceId = object.deviceId ?? "";
    return message;
  },
};

function createBaseStopCliCommandRequest(): StopCliCommandRequest {
  return { deviceId: "", sessionId: "" };
}

export const StopCliCommandRequest: MessageFns<StopCliCommandRequest> = {
  encode(message: StopCliCommandRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.sessionId !== "") {
      writer.uint32(18).string(message.sessionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopCliCommandRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopCliCommandRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sessionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopCliCommandRequest {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      sessionId: isSet(object.sessionId) ? globalThis.String(object.sessionId) : "",
    };
  },

  toJSON(message: StopCliCommandRequest): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.sessionId !== "") {
      obj.sessionId = message.sessionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StopCliCommandRequest>, I>>(base?: I): StopCliCommandRequest {
    return StopCliCommandRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StopCliCommandRequest>, I>>(object: I): StopCliCommandRequest {
    const message = createBaseStopCliCommandRequest();
    message.deviceId = object.deviceId ?? "";
    message.sessionId = object.sessionId ?? "";
    return message;
  },
};

function createBaseCliCommandCompletion(): CliCommandCompletion {
  return { keyword: "", helpString: "" };
}

export const CliCommandCompletion: MessageFns<CliCommandCompletion> = {
  encode(message: CliCommandCompletion, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.keyword !== "") {
      writer.uint32(10).string(message.keyword);
    }
    if (message.helpString !== "") {
      writer.uint32(18).string(message.helpString);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CliCommandCompletion {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCliCommandCompletion();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.keyword = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.helpString = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CliCommandCompletion {
    return {
      keyword: isSet(object.keyword) ? globalThis.String(object.keyword) : "",
      helpString: isSet(object.helpString) ? globalThis.String(object.helpString) : "",
    };
  },

  toJSON(message: CliCommandCompletion): unknown {
    const obj: any = {};
    if (message.keyword !== "") {
      obj.keyword = message.keyword;
    }
    if (message.helpString !== "") {
      obj.helpString = message.helpString;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CliCommandCompletion>, I>>(base?: I): CliCommandCompletion {
    return CliCommandCompletion.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CliCommandCompletion>, I>>(object: I): CliCommandCompletion {
    const message = createBaseCliCommandCompletion();
    message.keyword = object.keyword ?? "";
    message.helpString = object.helpString ?? "";
    return message;
  },
};

function createBaseCliCommandResponse(): CliCommandResponse {
  return {
    cmdAction: 0,
    command: "",
    executionResults: "",
    commandCompletions: [],
    resultFormat: 0,
    cursorPos: 0,
    validCommand: false,
    longestCommonSubstring: "",
    error: "",
    sessionId: "",
    deviceId: "",
  };
}

export const CliCommandResponse: MessageFns<CliCommandResponse> = {
  encode(message: CliCommandResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cmdAction !== 0) {
      writer.uint32(8).int32(message.cmdAction);
    }
    if (message.command !== "") {
      writer.uint32(18).string(message.command);
    }
    if (message.executionResults !== "") {
      writer.uint32(26).string(message.executionResults);
    }
    for (const v of message.commandCompletions) {
      CliCommandCompletion.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.resultFormat !== 0) {
      writer.uint32(40).int32(message.resultFormat);
    }
    if (message.cursorPos !== 0) {
      writer.uint32(56).int32(message.cursorPos);
    }
    if (message.validCommand !== false) {
      writer.uint32(64).bool(message.validCommand);
    }
    if (message.longestCommonSubstring !== "") {
      writer.uint32(74).string(message.longestCommonSubstring);
    }
    if (message.error !== "") {
      writer.uint32(82).string(message.error);
    }
    if (message.sessionId !== "") {
      writer.uint32(90).string(message.sessionId);
    }
    if (message.deviceId !== "") {
      writer.uint32(98).string(message.deviceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CliCommandResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCliCommandResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.cmdAction = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.command = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.executionResults = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.commandCompletions.push(CliCommandCompletion.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.resultFormat = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.cursorPos = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.validCommand = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.longestCommonSubstring = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.error = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.sessionId = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CliCommandResponse {
    return {
      cmdAction: isSet(object.cmdAction) ? commandActionFromJSON(object.cmdAction) : 0,
      command: isSet(object.command) ? globalThis.String(object.command) : "",
      executionResults: isSet(object.executionResults) ? globalThis.String(object.executionResults) : "",
      commandCompletions: globalThis.Array.isArray(object?.commandCompletions)
        ? object.commandCompletions.map((e: any) => CliCommandCompletion.fromJSON(e))
        : [],
      resultFormat: isSet(object.resultFormat) ? resultFormatFromJSON(object.resultFormat) : 0,
      cursorPos: isSet(object.cursorPos) ? globalThis.Number(object.cursorPos) : 0,
      validCommand: isSet(object.validCommand) ? globalThis.Boolean(object.validCommand) : false,
      longestCommonSubstring: isSet(object.longestCommonSubstring)
        ? globalThis.String(object.longestCommonSubstring)
        : "",
      error: isSet(object.error) ? globalThis.String(object.error) : "",
      sessionId: isSet(object.sessionId) ? globalThis.String(object.sessionId) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
    };
  },

  toJSON(message: CliCommandResponse): unknown {
    const obj: any = {};
    if (message.cmdAction !== 0) {
      obj.cmdAction = commandActionToJSON(message.cmdAction);
    }
    if (message.command !== "") {
      obj.command = message.command;
    }
    if (message.executionResults !== "") {
      obj.executionResults = message.executionResults;
    }
    if (message.commandCompletions?.length) {
      obj.commandCompletions = message.commandCompletions.map((e) => CliCommandCompletion.toJSON(e));
    }
    if (message.resultFormat !== 0) {
      obj.resultFormat = resultFormatToJSON(message.resultFormat);
    }
    if (message.cursorPos !== 0) {
      obj.cursorPos = Math.round(message.cursorPos);
    }
    if (message.validCommand !== false) {
      obj.validCommand = message.validCommand;
    }
    if (message.longestCommonSubstring !== "") {
      obj.longestCommonSubstring = message.longestCommonSubstring;
    }
    if (message.error !== "") {
      obj.error = message.error;
    }
    if (message.sessionId !== "") {
      obj.sessionId = message.sessionId;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CliCommandResponse>, I>>(base?: I): CliCommandResponse {
    return CliCommandResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CliCommandResponse>, I>>(object: I): CliCommandResponse {
    const message = createBaseCliCommandResponse();
    message.cmdAction = object.cmdAction ?? 0;
    message.command = object.command ?? "";
    message.executionResults = object.executionResults ?? "";
    message.commandCompletions = object.commandCompletions?.map((e) => CliCommandCompletion.fromPartial(e)) || [];
    message.resultFormat = object.resultFormat ?? 0;
    message.cursorPos = object.cursorPos ?? 0;
    message.validCommand = object.validCommand ?? false;
    message.longestCommonSubstring = object.longestCommonSubstring ?? "";
    message.error = object.error ?? "";
    message.sessionId = object.sessionId ?? "";
    message.deviceId = object.deviceId ?? "";
    return message;
  },
};

function createBaseCablingRemotePort(): CablingRemotePort {
  return { nodeId: "", port: undefined };
}

export const CablingRemotePort: MessageFns<CablingRemotePort> = {
  encode(message: CablingRemotePort, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nodeId !== "") {
      writer.uint32(10).string(message.nodeId);
    }
    if (message.port !== undefined) {
      CablingPort.encode(message.port, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CablingRemotePort {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCablingRemotePort();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.port = CablingPort.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CablingRemotePort {
    return {
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      port: isSet(object.port) ? CablingPort.fromJSON(object.port) : undefined,
    };
  },

  toJSON(message: CablingRemotePort): unknown {
    const obj: any = {};
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.port !== undefined) {
      obj.port = CablingPort.toJSON(message.port);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CablingRemotePort>, I>>(base?: I): CablingRemotePort {
    return CablingRemotePort.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CablingRemotePort>, I>>(object: I): CablingRemotePort {
    const message = createBaseCablingRemotePort();
    message.nodeId = object.nodeId ?? "";
    message.port = (object.port !== undefined && object.port !== null)
      ? CablingPort.fromPartial(object.port)
      : undefined;
    return message;
  },
};

function createBaseCablingPort(): CablingPort {
  return {
    lineCard: 0,
    port: 0,
    breakout: 0,
    portSpeed: 0,
    portMaxSpeed: 0,
    expectedCableType: 0,
    cableSpeed: 0,
    cableType: 0,
  };
}

export const CablingPort: MessageFns<CablingPort> = {
  encode(message: CablingPort, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.lineCard !== 0) {
      writer.uint32(16).uint32(message.lineCard);
    }
    if (message.port !== 0) {
      writer.uint32(24).uint32(message.port);
    }
    if (message.breakout !== 0) {
      writer.uint32(32).uint32(message.breakout);
    }
    if (message.portSpeed !== 0) {
      writer.uint32(40).uint32(message.portSpeed);
    }
    if (message.portMaxSpeed !== 0) {
      writer.uint32(48).uint32(message.portMaxSpeed);
    }
    if (message.expectedCableType !== 0) {
      writer.uint32(56).int32(message.expectedCableType);
    }
    if (message.cableSpeed !== 0) {
      writer.uint32(64).uint32(message.cableSpeed);
    }
    if (message.cableType !== 0) {
      writer.uint32(72).uint32(message.cableType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CablingPort {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCablingPort();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.lineCard = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.port = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.breakout = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.portSpeed = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.portMaxSpeed = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.expectedCableType = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.cableSpeed = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.cableType = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CablingPort {
    return {
      lineCard: isSet(object.lineCard) ? globalThis.Number(object.lineCard) : 0,
      port: isSet(object.port) ? globalThis.Number(object.port) : 0,
      breakout: isSet(object.breakout) ? globalThis.Number(object.breakout) : 0,
      portSpeed: isSet(object.portSpeed) ? globalThis.Number(object.portSpeed) : 0,
      portMaxSpeed: isSet(object.portMaxSpeed) ? globalThis.Number(object.portMaxSpeed) : 0,
      expectedCableType: isSet(object.expectedCableType) ? cableTypeFromJSON(object.expectedCableType) : 0,
      cableSpeed: isSet(object.cableSpeed) ? globalThis.Number(object.cableSpeed) : 0,
      cableType: isSet(object.cableType) ? globalThis.Number(object.cableType) : 0,
    };
  },

  toJSON(message: CablingPort): unknown {
    const obj: any = {};
    if (message.lineCard !== 0) {
      obj.lineCard = Math.round(message.lineCard);
    }
    if (message.port !== 0) {
      obj.port = Math.round(message.port);
    }
    if (message.breakout !== 0) {
      obj.breakout = Math.round(message.breakout);
    }
    if (message.portSpeed !== 0) {
      obj.portSpeed = Math.round(message.portSpeed);
    }
    if (message.portMaxSpeed !== 0) {
      obj.portMaxSpeed = Math.round(message.portMaxSpeed);
    }
    if (message.expectedCableType !== 0) {
      obj.expectedCableType = cableTypeToJSON(message.expectedCableType);
    }
    if (message.cableSpeed !== 0) {
      obj.cableSpeed = Math.round(message.cableSpeed);
    }
    if (message.cableType !== 0) {
      obj.cableType = Math.round(message.cableType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CablingPort>, I>>(base?: I): CablingPort {
    return CablingPort.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CablingPort>, I>>(object: I): CablingPort {
    const message = createBaseCablingPort();
    message.lineCard = object.lineCard ?? 0;
    message.port = object.port ?? 0;
    message.breakout = object.breakout ?? 0;
    message.portSpeed = object.portSpeed ?? 0;
    message.portMaxSpeed = object.portMaxSpeed ?? 0;
    message.expectedCableType = object.expectedCableType ?? 0;
    message.cableSpeed = object.cableSpeed ?? 0;
    message.cableType = object.cableType ?? 0;
    return message;
  },
};

function createBaseCablingConnection(): CablingConnection {
  return { from: undefined, to: undefined };
}

export const CablingConnection: MessageFns<CablingConnection> = {
  encode(message: CablingConnection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.from !== undefined) {
      CablingPort.encode(message.from, writer.uint32(10).fork()).join();
    }
    if (message.to !== undefined) {
      CablingRemotePort.encode(message.to, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CablingConnection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCablingConnection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.from = CablingPort.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.to = CablingRemotePort.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CablingConnection {
    return {
      from: isSet(object.from) ? CablingPort.fromJSON(object.from) : undefined,
      to: isSet(object.to) ? CablingRemotePort.fromJSON(object.to) : undefined,
    };
  },

  toJSON(message: CablingConnection): unknown {
    const obj: any = {};
    if (message.from !== undefined) {
      obj.from = CablingPort.toJSON(message.from);
    }
    if (message.to !== undefined) {
      obj.to = CablingRemotePort.toJSON(message.to);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CablingConnection>, I>>(base?: I): CablingConnection {
    return CablingConnection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CablingConnection>, I>>(object: I): CablingConnection {
    const message = createBaseCablingConnection();
    message.from = (object.from !== undefined && object.from !== null)
      ? CablingPort.fromPartial(object.from)
      : undefined;
    message.to = (object.to !== undefined && object.to !== null) ? CablingRemotePort.fromPartial(object.to) : undefined;
    return message;
  },
};

function createBaseCablingDevice(): CablingDevice {
  return { deviceType: 0, nodeId: "", FabricPorts: [], AdditionalPorts: [], connections: [], deviceId: "" };
}

export const CablingDevice: MessageFns<CablingDevice> = {
  encode(message: CablingDevice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceType !== 0) {
      writer.uint32(8).int32(message.deviceType);
    }
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    for (const v of message.FabricPorts) {
      CablingPort.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.AdditionalPorts) {
      CablingPort.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.connections) {
      CablingConnection.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.deviceId !== "") {
      writer.uint32(50).string(message.deviceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CablingDevice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCablingDevice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.FabricPorts.push(CablingPort.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.AdditionalPorts.push(CablingPort.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.connections.push(CablingConnection.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CablingDevice {
    return {
      deviceType: isSet(object.deviceType) ? cablingDeviceTypeFromJSON(object.deviceType) : 0,
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      FabricPorts: globalThis.Array.isArray(object?.FabricPorts)
        ? object.FabricPorts.map((e: any) => CablingPort.fromJSON(e))
        : [],
      AdditionalPorts: globalThis.Array.isArray(object?.AdditionalPorts)
        ? object.AdditionalPorts.map((e: any) => CablingPort.fromJSON(e))
        : [],
      connections: globalThis.Array.isArray(object?.connections)
        ? object.connections.map((e: any) => CablingConnection.fromJSON(e))
        : [],
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
    };
  },

  toJSON(message: CablingDevice): unknown {
    const obj: any = {};
    if (message.deviceType !== 0) {
      obj.deviceType = cablingDeviceTypeToJSON(message.deviceType);
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.FabricPorts?.length) {
      obj.FabricPorts = message.FabricPorts.map((e) => CablingPort.toJSON(e));
    }
    if (message.AdditionalPorts?.length) {
      obj.AdditionalPorts = message.AdditionalPorts.map((e) => CablingPort.toJSON(e));
    }
    if (message.connections?.length) {
      obj.connections = message.connections.map((e) => CablingConnection.toJSON(e));
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CablingDevice>, I>>(base?: I): CablingDevice {
    return CablingDevice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CablingDevice>, I>>(object: I): CablingDevice {
    const message = createBaseCablingDevice();
    message.deviceType = object.deviceType ?? 0;
    message.nodeId = object.nodeId ?? "";
    message.FabricPorts = object.FabricPorts?.map((e) => CablingPort.fromPartial(e)) || [];
    message.AdditionalPorts = object.AdditionalPorts?.map((e) => CablingPort.fromPartial(e)) || [];
    message.connections = object.connections?.map((e) => CablingConnection.fromPartial(e)) || [];
    message.deviceId = object.deviceId ?? "";
    return message;
  },
};

function createBaseCablingRequest(): CablingRequest {
  return {
    fabricId: "",
    leafs: [],
    spines: [],
    order: 0,
    dryRun: false,
    failFast: false,
    includeCablingPlan: false,
    design: undefined,
    orgId: "",
    nodeData: [],
    excludeObservedStateDataInResponse: false,
  };
}

export const CablingRequest: MessageFns<CablingRequest> = {
  encode(message: CablingRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.leafs) {
      CablingDevice.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.spines) {
      CablingDevice.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.order !== 0) {
      writer.uint32(32).uint32(message.order);
    }
    if (message.dryRun !== false) {
      writer.uint32(40).bool(message.dryRun);
    }
    if (message.failFast !== false) {
      writer.uint32(48).bool(message.failFast);
    }
    if (message.includeCablingPlan !== false) {
      writer.uint32(56).bool(message.includeCablingPlan);
    }
    if (message.design !== undefined) {
      FabricDesign.encode(message.design, writer.uint32(66).fork()).join();
    }
    if (message.orgId !== "") {
      writer.uint32(74).string(message.orgId);
    }
    for (const v of message.nodeData) {
      DesignNodeData.encode(v!, writer.uint32(82).fork()).join();
    }
    if (message.excludeObservedStateDataInResponse !== false) {
      writer.uint32(88).bool(message.excludeObservedStateDataInResponse);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CablingRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCablingRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.leafs.push(CablingDevice.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.spines.push(CablingDevice.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.order = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.dryRun = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.failFast = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.includeCablingPlan = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.design = FabricDesign.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.nodeData.push(DesignNodeData.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.excludeObservedStateDataInResponse = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CablingRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      leafs: globalThis.Array.isArray(object?.leafs) ? object.leafs.map((e: any) => CablingDevice.fromJSON(e)) : [],
      spines: globalThis.Array.isArray(object?.spines) ? object.spines.map((e: any) => CablingDevice.fromJSON(e)) : [],
      order: isSet(object.order) ? globalThis.Number(object.order) : 0,
      dryRun: isSet(object.dryRun) ? globalThis.Boolean(object.dryRun) : false,
      failFast: isSet(object.failFast) ? globalThis.Boolean(object.failFast) : false,
      includeCablingPlan: isSet(object.includeCablingPlan) ? globalThis.Boolean(object.includeCablingPlan) : false,
      design: isSet(object.design) ? FabricDesign.fromJSON(object.design) : undefined,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      nodeData: globalThis.Array.isArray(object?.nodeData)
        ? object.nodeData.map((e: any) => DesignNodeData.fromJSON(e))
        : [],
      excludeObservedStateDataInResponse: isSet(object.excludeObservedStateDataInResponse)
        ? globalThis.Boolean(object.excludeObservedStateDataInResponse)
        : false,
    };
  },

  toJSON(message: CablingRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.leafs?.length) {
      obj.leafs = message.leafs.map((e) => CablingDevice.toJSON(e));
    }
    if (message.spines?.length) {
      obj.spines = message.spines.map((e) => CablingDevice.toJSON(e));
    }
    if (message.order !== 0) {
      obj.order = Math.round(message.order);
    }
    if (message.dryRun !== false) {
      obj.dryRun = message.dryRun;
    }
    if (message.failFast !== false) {
      obj.failFast = message.failFast;
    }
    if (message.includeCablingPlan !== false) {
      obj.includeCablingPlan = message.includeCablingPlan;
    }
    if (message.design !== undefined) {
      obj.design = FabricDesign.toJSON(message.design);
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.nodeData?.length) {
      obj.nodeData = message.nodeData.map((e) => DesignNodeData.toJSON(e));
    }
    if (message.excludeObservedStateDataInResponse !== false) {
      obj.excludeObservedStateDataInResponse = message.excludeObservedStateDataInResponse;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CablingRequest>, I>>(base?: I): CablingRequest {
    return CablingRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CablingRequest>, I>>(object: I): CablingRequest {
    const message = createBaseCablingRequest();
    message.fabricId = object.fabricId ?? "";
    message.leafs = object.leafs?.map((e) => CablingDevice.fromPartial(e)) || [];
    message.spines = object.spines?.map((e) => CablingDevice.fromPartial(e)) || [];
    message.order = object.order ?? 0;
    message.dryRun = object.dryRun ?? false;
    message.failFast = object.failFast ?? false;
    message.includeCablingPlan = object.includeCablingPlan ?? false;
    message.design = (object.design !== undefined && object.design !== null)
      ? FabricDesign.fromPartial(object.design)
      : undefined;
    message.orgId = object.orgId ?? "";
    message.nodeData = object.nodeData?.map((e) => DesignNodeData.fromPartial(e)) || [];
    message.excludeObservedStateDataInResponse = object.excludeObservedStateDataInResponse ?? false;
    return message;
  },
};

function createBaseCablingResponse(): CablingResponse {
  return { leafs: [], spines: [], connections: [], execStatus: 0, exceptions: [], observedConnections: [] };
}

export const CablingResponse: MessageFns<CablingResponse> = {
  encode(message: CablingResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.leafs) {
      CablingDevice.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.spines) {
      CablingDevice.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.connections) {
      CablingConnection1.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.execStatus !== 0) {
      writer.uint32(32).int32(message.execStatus);
    }
    for (const v of message.exceptions) {
      RuleExecutionException.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.observedConnections) {
      CablingConnection1.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CablingResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCablingResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.leafs.push(CablingDevice.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.spines.push(CablingDevice.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.connections.push(CablingConnection1.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.execStatus = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.exceptions.push(RuleExecutionException.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.observedConnections.push(CablingConnection1.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CablingResponse {
    return {
      leafs: globalThis.Array.isArray(object?.leafs) ? object.leafs.map((e: any) => CablingDevice.fromJSON(e)) : [],
      spines: globalThis.Array.isArray(object?.spines) ? object.spines.map((e: any) => CablingDevice.fromJSON(e)) : [],
      connections: globalThis.Array.isArray(object?.connections)
        ? object.connections.map((e: any) => CablingConnection1.fromJSON(e))
        : [],
      execStatus: isSet(object.execStatus) ? cablingPlanStatusFromJSON(object.execStatus) : 0,
      exceptions: globalThis.Array.isArray(object?.exceptions)
        ? object.exceptions.map((e: any) => RuleExecutionException.fromJSON(e))
        : [],
      observedConnections: globalThis.Array.isArray(object?.observedConnections)
        ? object.observedConnections.map((e: any) => CablingConnection1.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CablingResponse): unknown {
    const obj: any = {};
    if (message.leafs?.length) {
      obj.leafs = message.leafs.map((e) => CablingDevice.toJSON(e));
    }
    if (message.spines?.length) {
      obj.spines = message.spines.map((e) => CablingDevice.toJSON(e));
    }
    if (message.connections?.length) {
      obj.connections = message.connections.map((e) => CablingConnection1.toJSON(e));
    }
    if (message.execStatus !== 0) {
      obj.execStatus = cablingPlanStatusToJSON(message.execStatus);
    }
    if (message.exceptions?.length) {
      obj.exceptions = message.exceptions.map((e) => RuleExecutionException.toJSON(e));
    }
    if (message.observedConnections?.length) {
      obj.observedConnections = message.observedConnections.map((e) => CablingConnection1.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CablingResponse>, I>>(base?: I): CablingResponse {
    return CablingResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CablingResponse>, I>>(object: I): CablingResponse {
    const message = createBaseCablingResponse();
    message.leafs = object.leafs?.map((e) => CablingDevice.fromPartial(e)) || [];
    message.spines = object.spines?.map((e) => CablingDevice.fromPartial(e)) || [];
    message.connections = object.connections?.map((e) => CablingConnection1.fromPartial(e)) || [];
    message.execStatus = object.execStatus ?? 0;
    message.exceptions = object.exceptions?.map((e) => RuleExecutionException.fromPartial(e)) || [];
    message.observedConnections = object.observedConnections?.map((e) => CablingConnection1.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetImageTargetsRequest(): GetImageTargetsRequest {
  return { lookbackDays: 0, releaseTypes: [], sortField: 0, fabricId: "" };
}

export const GetImageTargetsRequest: MessageFns<GetImageTargetsRequest> = {
  encode(message: GetImageTargetsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.lookbackDays !== 0) {
      writer.uint32(8).uint32(message.lookbackDays);
    }
    for (const v of message.releaseTypes) {
      writer.uint32(18).string(v!);
    }
    if (message.sortField !== 0) {
      writer.uint32(24).int32(message.sortField);
    }
    if (message.fabricId !== "") {
      writer.uint32(34).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetImageTargetsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetImageTargetsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.lookbackDays = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.releaseTypes.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.sortField = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetImageTargetsRequest {
    return {
      lookbackDays: isSet(object.lookbackDays) ? globalThis.Number(object.lookbackDays) : 0,
      releaseTypes: globalThis.Array.isArray(object?.releaseTypes)
        ? object.releaseTypes.map((e: any) => globalThis.String(e))
        : [],
      sortField: isSet(object.sortField) ? fabricImageSortFieldFromJSON(object.sortField) : 0,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
    };
  },

  toJSON(message: GetImageTargetsRequest): unknown {
    const obj: any = {};
    if (message.lookbackDays !== 0) {
      obj.lookbackDays = Math.round(message.lookbackDays);
    }
    if (message.releaseTypes?.length) {
      obj.releaseTypes = message.releaseTypes;
    }
    if (message.sortField !== 0) {
      obj.sortField = fabricImageSortFieldToJSON(message.sortField);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetImageTargetsRequest>, I>>(base?: I): GetImageTargetsRequest {
    return GetImageTargetsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetImageTargetsRequest>, I>>(object: I): GetImageTargetsRequest {
    const message = createBaseGetImageTargetsRequest();
    message.lookbackDays = object.lookbackDays ?? 0;
    message.releaseTypes = object.releaseTypes?.map((e) => e) || [];
    message.sortField = object.sortField ?? 0;
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

function createBaseGetImageTargetsResponse(): GetImageTargetsResponse {
  return { latest: undefined, fabricImages: [], otherImages: [] };
}

export const GetImageTargetsResponse: MessageFns<GetImageTargetsResponse> = {
  encode(message: GetImageTargetsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.latest !== undefined) {
      ReleaseImageInfo.encode(message.latest, writer.uint32(10).fork()).join();
    }
    for (const v of message.fabricImages) {
      FabricImageInfo.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.otherImages) {
      ReleaseImageInfo.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetImageTargetsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetImageTargetsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.latest = ReleaseImageInfo.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricImages.push(FabricImageInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.otherImages.push(ReleaseImageInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetImageTargetsResponse {
    return {
      latest: isSet(object.latest) ? ReleaseImageInfo.fromJSON(object.latest) : undefined,
      fabricImages: globalThis.Array.isArray(object?.fabricImages)
        ? object.fabricImages.map((e: any) => FabricImageInfo.fromJSON(e))
        : [],
      otherImages: globalThis.Array.isArray(object?.otherImages)
        ? object.otherImages.map((e: any) => ReleaseImageInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetImageTargetsResponse): unknown {
    const obj: any = {};
    if (message.latest !== undefined) {
      obj.latest = ReleaseImageInfo.toJSON(message.latest);
    }
    if (message.fabricImages?.length) {
      obj.fabricImages = message.fabricImages.map((e) => FabricImageInfo.toJSON(e));
    }
    if (message.otherImages?.length) {
      obj.otherImages = message.otherImages.map((e) => ReleaseImageInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetImageTargetsResponse>, I>>(base?: I): GetImageTargetsResponse {
    return GetImageTargetsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetImageTargetsResponse>, I>>(object: I): GetImageTargetsResponse {
    const message = createBaseGetImageTargetsResponse();
    message.latest = (object.latest !== undefined && object.latest !== null)
      ? ReleaseImageInfo.fromPartial(object.latest)
      : undefined;
    message.fabricImages = object.fabricImages?.map((e) => FabricImageInfo.fromPartial(e)) || [];
    message.otherImages = object.otherImages?.map((e) => ReleaseImageInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFabricImageInfo(): FabricImageInfo {
  return { fabricId: "", fabricName: "", tag: "", releaseAt: undefined, expireAt: undefined, docLink: "" };
}

export const FabricImageInfo: MessageFns<FabricImageInfo> = {
  encode(message: FabricImageInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.fabricName !== "") {
      writer.uint32(18).string(message.fabricName);
    }
    if (message.tag !== "") {
      writer.uint32(26).string(message.tag);
    }
    if (message.releaseAt !== undefined) {
      Timestamp.encode(toTimestamp(message.releaseAt), writer.uint32(34).fork()).join();
    }
    if (message.expireAt !== undefined) {
      Timestamp.encode(toTimestamp(message.expireAt), writer.uint32(42).fork()).join();
    }
    if (message.docLink !== "") {
      writer.uint32(50).string(message.docLink);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricImageInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricImageInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tag = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.releaseAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.expireAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.docLink = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricImageInfo {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      fabricName: isSet(object.fabricName) ? globalThis.String(object.fabricName) : "",
      tag: isSet(object.tag) ? globalThis.String(object.tag) : "",
      releaseAt: isSet(object.releaseAt) ? fromJsonTimestamp(object.releaseAt) : undefined,
      expireAt: isSet(object.expireAt) ? fromJsonTimestamp(object.expireAt) : undefined,
      docLink: isSet(object.docLink) ? globalThis.String(object.docLink) : "",
    };
  },

  toJSON(message: FabricImageInfo): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.fabricName !== "") {
      obj.fabricName = message.fabricName;
    }
    if (message.tag !== "") {
      obj.tag = message.tag;
    }
    if (message.releaseAt !== undefined) {
      obj.releaseAt = message.releaseAt.toISOString();
    }
    if (message.expireAt !== undefined) {
      obj.expireAt = message.expireAt.toISOString();
    }
    if (message.docLink !== "") {
      obj.docLink = message.docLink;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricImageInfo>, I>>(base?: I): FabricImageInfo {
    return FabricImageInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricImageInfo>, I>>(object: I): FabricImageInfo {
    const message = createBaseFabricImageInfo();
    message.fabricId = object.fabricId ?? "";
    message.fabricName = object.fabricName ?? "";
    message.tag = object.tag ?? "";
    message.releaseAt = object.releaseAt ?? undefined;
    message.expireAt = object.expireAt ?? undefined;
    message.docLink = object.docLink ?? "";
    return message;
  },
};

function createBaseSwitchGroupImageInfo(): SwitchGroupImageInfo {
  return {
    fabricId: "",
    switchGroupId: "",
    name: "",
    shortName: "",
    targetTag: "",
    deployAt: undefined,
    expireAt: undefined,
    boundPlatform: "",
    images: [],
  };
}

export const SwitchGroupImageInfo: MessageFns<SwitchGroupImageInfo> = {
  encode(message: SwitchGroupImageInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.switchGroupId !== "") {
      writer.uint32(18).string(message.switchGroupId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.shortName !== "") {
      writer.uint32(34).string(message.shortName);
    }
    if (message.targetTag !== "") {
      writer.uint32(42).string(message.targetTag);
    }
    if (message.deployAt !== undefined) {
      Timestamp.encode(toTimestamp(message.deployAt), writer.uint32(50).fork()).join();
    }
    if (message.expireAt !== undefined) {
      Timestamp.encode(toTimestamp(message.expireAt), writer.uint32(58).fork()).join();
    }
    if (message.boundPlatform !== "") {
      writer.uint32(66).string(message.boundPlatform);
    }
    for (const v of message.images) {
      ReleaseImageInfo.encode(v!, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SwitchGroupImageInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwitchGroupImageInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.switchGroupId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.shortName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.targetTag = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.deployAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.expireAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.boundPlatform = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.images.push(ReleaseImageInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SwitchGroupImageInfo {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      switchGroupId: isSet(object.switchGroupId) ? globalThis.String(object.switchGroupId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
      targetTag: isSet(object.targetTag) ? globalThis.String(object.targetTag) : "",
      deployAt: isSet(object.deployAt) ? fromJsonTimestamp(object.deployAt) : undefined,
      expireAt: isSet(object.expireAt) ? fromJsonTimestamp(object.expireAt) : undefined,
      boundPlatform: isSet(object.boundPlatform) ? globalThis.String(object.boundPlatform) : "",
      images: globalThis.Array.isArray(object?.images)
        ? object.images.map((e: any) => ReleaseImageInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SwitchGroupImageInfo): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.switchGroupId !== "") {
      obj.switchGroupId = message.switchGroupId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.shortName !== "") {
      obj.shortName = message.shortName;
    }
    if (message.targetTag !== "") {
      obj.targetTag = message.targetTag;
    }
    if (message.deployAt !== undefined) {
      obj.deployAt = message.deployAt.toISOString();
    }
    if (message.expireAt !== undefined) {
      obj.expireAt = message.expireAt.toISOString();
    }
    if (message.boundPlatform !== "") {
      obj.boundPlatform = message.boundPlatform;
    }
    if (message.images?.length) {
      obj.images = message.images.map((e) => ReleaseImageInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SwitchGroupImageInfo>, I>>(base?: I): SwitchGroupImageInfo {
    return SwitchGroupImageInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SwitchGroupImageInfo>, I>>(object: I): SwitchGroupImageInfo {
    const message = createBaseSwitchGroupImageInfo();
    message.fabricId = object.fabricId ?? "";
    message.switchGroupId = object.switchGroupId ?? "";
    message.name = object.name ?? "";
    message.shortName = object.shortName ?? "";
    message.targetTag = object.targetTag ?? "";
    message.deployAt = object.deployAt ?? undefined;
    message.expireAt = object.expireAt ?? undefined;
    message.boundPlatform = object.boundPlatform ?? "";
    message.images = object.images?.map((e) => ReleaseImageInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseReleaseImageInfo(): ReleaseImageInfo {
  return { tag: "", releaseAt: undefined, expireAt: undefined, docLink: "" };
}

export const ReleaseImageInfo: MessageFns<ReleaseImageInfo> = {
  encode(message: ReleaseImageInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tag !== "") {
      writer.uint32(10).string(message.tag);
    }
    if (message.releaseAt !== undefined) {
      Timestamp.encode(toTimestamp(message.releaseAt), writer.uint32(18).fork()).join();
    }
    if (message.expireAt !== undefined) {
      Timestamp.encode(toTimestamp(message.expireAt), writer.uint32(26).fork()).join();
    }
    if (message.docLink !== "") {
      writer.uint32(34).string(message.docLink);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReleaseImageInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReleaseImageInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tag = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.releaseAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.expireAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.docLink = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReleaseImageInfo {
    return {
      tag: isSet(object.tag) ? globalThis.String(object.tag) : "",
      releaseAt: isSet(object.releaseAt) ? fromJsonTimestamp(object.releaseAt) : undefined,
      expireAt: isSet(object.expireAt) ? fromJsonTimestamp(object.expireAt) : undefined,
      docLink: isSet(object.docLink) ? globalThis.String(object.docLink) : "",
    };
  },

  toJSON(message: ReleaseImageInfo): unknown {
    const obj: any = {};
    if (message.tag !== "") {
      obj.tag = message.tag;
    }
    if (message.releaseAt !== undefined) {
      obj.releaseAt = message.releaseAt.toISOString();
    }
    if (message.expireAt !== undefined) {
      obj.expireAt = message.expireAt.toISOString();
    }
    if (message.docLink !== "") {
      obj.docLink = message.docLink;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReleaseImageInfo>, I>>(base?: I): ReleaseImageInfo {
    return ReleaseImageInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReleaseImageInfo>, I>>(object: I): ReleaseImageInfo {
    const message = createBaseReleaseImageInfo();
    message.tag = object.tag ?? "";
    message.releaseAt = object.releaseAt ?? undefined;
    message.expireAt = object.expireAt ?? undefined;
    message.docLink = object.docLink ?? "";
    return message;
  },
};

function createBaseGetSwitchGroupImageTargetsRequest(): GetSwitchGroupImageTargetsRequest {
  return { fabricId: "", switchGroupIds: [], releaseTypes: [], lookbackDays: 0 };
}

export const GetSwitchGroupImageTargetsRequest: MessageFns<GetSwitchGroupImageTargetsRequest> = {
  encode(message: GetSwitchGroupImageTargetsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.switchGroupIds) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.releaseTypes) {
      writer.uint32(26).string(v!);
    }
    if (message.lookbackDays !== 0) {
      writer.uint32(32).uint32(message.lookbackDays);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSwitchGroupImageTargetsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSwitchGroupImageTargetsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.switchGroupIds.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.releaseTypes.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.lookbackDays = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSwitchGroupImageTargetsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      switchGroupIds: globalThis.Array.isArray(object?.switchGroupIds)
        ? object.switchGroupIds.map((e: any) => globalThis.String(e))
        : [],
      releaseTypes: globalThis.Array.isArray(object?.releaseTypes)
        ? object.releaseTypes.map((e: any) => globalThis.String(e))
        : [],
      lookbackDays: isSet(object.lookbackDays) ? globalThis.Number(object.lookbackDays) : 0,
    };
  },

  toJSON(message: GetSwitchGroupImageTargetsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.switchGroupIds?.length) {
      obj.switchGroupIds = message.switchGroupIds;
    }
    if (message.releaseTypes?.length) {
      obj.releaseTypes = message.releaseTypes;
    }
    if (message.lookbackDays !== 0) {
      obj.lookbackDays = Math.round(message.lookbackDays);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSwitchGroupImageTargetsRequest>, I>>(
    base?: I,
  ): GetSwitchGroupImageTargetsRequest {
    return GetSwitchGroupImageTargetsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSwitchGroupImageTargetsRequest>, I>>(
    object: I,
  ): GetSwitchGroupImageTargetsRequest {
    const message = createBaseGetSwitchGroupImageTargetsRequest();
    message.fabricId = object.fabricId ?? "";
    message.switchGroupIds = object.switchGroupIds?.map((e) => e) || [];
    message.releaseTypes = object.releaseTypes?.map((e) => e) || [];
    message.lookbackDays = object.lookbackDays ?? 0;
    return message;
  },
};

function createBaseGetSwitchGroupImageTargetsResponse(): GetSwitchGroupImageTargetsResponse {
  return { switchGroupImages: [] };
}

export const GetSwitchGroupImageTargetsResponse: MessageFns<GetSwitchGroupImageTargetsResponse> = {
  encode(message: GetSwitchGroupImageTargetsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.switchGroupImages) {
      SwitchGroupImageInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSwitchGroupImageTargetsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSwitchGroupImageTargetsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.switchGroupImages.push(SwitchGroupImageInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSwitchGroupImageTargetsResponse {
    return {
      switchGroupImages: globalThis.Array.isArray(object?.switchGroupImages)
        ? object.switchGroupImages.map((e: any) => SwitchGroupImageInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetSwitchGroupImageTargetsResponse): unknown {
    const obj: any = {};
    if (message.switchGroupImages?.length) {
      obj.switchGroupImages = message.switchGroupImages.map((e) => SwitchGroupImageInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSwitchGroupImageTargetsResponse>, I>>(
    base?: I,
  ): GetSwitchGroupImageTargetsResponse {
    return GetSwitchGroupImageTargetsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSwitchGroupImageTargetsResponse>, I>>(
    object: I,
  ): GetSwitchGroupImageTargetsResponse {
    const message = createBaseGetSwitchGroupImageTargetsResponse();
    message.switchGroupImages = object.switchGroupImages?.map((e) => SwitchGroupImageInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetDevicesForOrgRequest(): GetDevicesForOrgRequest {
  return {};
}

export const GetDevicesForOrgRequest: MessageFns<GetDevicesForOrgRequest> = {
  encode(_: GetDevicesForOrgRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDevicesForOrgRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDevicesForOrgRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetDevicesForOrgRequest {
    return {};
  },

  toJSON(_: GetDevicesForOrgRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDevicesForOrgRequest>, I>>(base?: I): GetDevicesForOrgRequest {
    return GetDevicesForOrgRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDevicesForOrgRequest>, I>>(_: I): GetDevicesForOrgRequest {
    const message = createBaseGetDevicesForOrgRequest();
    return message;
  },
};

function createBaseGetDevicesForOrgResponse(): GetDevicesForOrgResponse {
  return { devices: [], error: undefined };
}

export const GetDevicesForOrgResponse: MessageFns<GetDevicesForOrgResponse> = {
  encode(message: GetDevicesForOrgResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.devices) {
      Device.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      RestError.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDevicesForOrgResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDevicesForOrgResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.devices.push(Device.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = RestError.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDevicesForOrgResponse {
    return {
      devices: globalThis.Array.isArray(object?.devices) ? object.devices.map((e: any) => Device.fromJSON(e)) : [],
      error: isSet(object.error) ? RestError.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: GetDevicesForOrgResponse): unknown {
    const obj: any = {};
    if (message.devices?.length) {
      obj.devices = message.devices.map((e) => Device.toJSON(e));
    }
    if (message.error !== undefined) {
      obj.error = RestError.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDevicesForOrgResponse>, I>>(base?: I): GetDevicesForOrgResponse {
    return GetDevicesForOrgResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDevicesForOrgResponse>, I>>(object: I): GetDevicesForOrgResponse {
    const message = createBaseGetDevicesForOrgResponse();
    message.devices = object.devices?.map((e) => Device.fromPartial(e)) || [];
    message.error = (object.error !== undefined && object.error !== null)
      ? RestError.fromPartial(object.error)
      : undefined;
    return message;
  },
};

function createBaseDevice(): Device {
  return {
    deviceId: "",
    nodeId: "",
    serialNumber: "",
    modelName: "",
    fabricId: "",
    roles: [],
    name: "",
    nodeType: 0,
    fabricName: "",
    claimedAt: undefined,
  };
}

export const Device: MessageFns<Device> = {
  encode(message: Device, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    if (message.serialNumber !== "") {
      writer.uint32(26).string(message.serialNumber);
    }
    if (message.modelName !== "") {
      writer.uint32(34).string(message.modelName);
    }
    if (message.fabricId !== "") {
      writer.uint32(42).string(message.fabricId);
    }
    writer.uint32(66).fork();
    for (const v of message.roles) {
      writer.int32(v);
    }
    writer.join();
    if (message.name !== "") {
      writer.uint32(74).string(message.name);
    }
    if (message.nodeType !== 0) {
      writer.uint32(80).int32(message.nodeType);
    }
    if (message.fabricName !== "") {
      writer.uint32(90).string(message.fabricName);
    }
    if (message.claimedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.claimedAt), writer.uint32(98).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Device {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDevice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 8: {
          if (tag === 64) {
            message.roles.push(reader.int32() as any);

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.roles.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.nodeType = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.fabricName = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.claimedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Device {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      roles: globalThis.Array.isArray(object?.roles) ? object.roles.map((e: any) => nodeRoleFromJSON(e)) : [],
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      nodeType: isSet(object.nodeType) ? nodeTypeFromJSON(object.nodeType) : 0,
      fabricName: isSet(object.fabricName) ? globalThis.String(object.fabricName) : "",
      claimedAt: isSet(object.claimedAt) ? fromJsonTimestamp(object.claimedAt) : undefined,
    };
  },

  toJSON(message: Device): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.roles?.length) {
      obj.roles = message.roles.map((e) => nodeRoleToJSON(e));
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.nodeType !== 0) {
      obj.nodeType = nodeTypeToJSON(message.nodeType);
    }
    if (message.fabricName !== "") {
      obj.fabricName = message.fabricName;
    }
    if (message.claimedAt !== undefined) {
      obj.claimedAt = message.claimedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Device>, I>>(base?: I): Device {
    return Device.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Device>, I>>(object: I): Device {
    const message = createBaseDevice();
    message.deviceId = object.deviceId ?? "";
    message.nodeId = object.nodeId ?? "";
    message.serialNumber = object.serialNumber ?? "";
    message.modelName = object.modelName ?? "";
    message.fabricId = object.fabricId ?? "";
    message.roles = object.roles?.map((e) => e) || [];
    message.name = object.name ?? "";
    message.nodeType = object.nodeType ?? 0;
    message.fabricName = object.fabricName ?? "";
    message.claimedAt = object.claimedAt ?? undefined;
    return message;
  },
};

function createBaseGetDiscoveredDevicesRequest(): GetDiscoveredDevicesRequest {
  return {};
}

export const GetDiscoveredDevicesRequest: MessageFns<GetDiscoveredDevicesRequest> = {
  encode(_: GetDiscoveredDevicesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDiscoveredDevicesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDiscoveredDevicesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetDiscoveredDevicesRequest {
    return {};
  },

  toJSON(_: GetDiscoveredDevicesRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDiscoveredDevicesRequest>, I>>(base?: I): GetDiscoveredDevicesRequest {
    return GetDiscoveredDevicesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDiscoveredDevicesRequest>, I>>(_: I): GetDiscoveredDevicesRequest {
    const message = createBaseGetDiscoveredDevicesRequest();
    return message;
  },
};

function createBaseGetDiscoveredDevicesResponse(): GetDiscoveredDevicesResponse {
  return { devices: [] };
}

export const GetDiscoveredDevicesResponse: MessageFns<GetDiscoveredDevicesResponse> = {
  encode(message: GetDiscoveredDevicesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.devices) {
      DiscoveredDevice.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDiscoveredDevicesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDiscoveredDevicesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.devices.push(DiscoveredDevice.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDiscoveredDevicesResponse {
    return {
      devices: globalThis.Array.isArray(object?.devices)
        ? object.devices.map((e: any) => DiscoveredDevice.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetDiscoveredDevicesResponse): unknown {
    const obj: any = {};
    if (message.devices?.length) {
      obj.devices = message.devices.map((e) => DiscoveredDevice.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDiscoveredDevicesResponse>, I>>(base?: I): GetDiscoveredDevicesResponse {
    return GetDiscoveredDevicesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDiscoveredDevicesResponse>, I>>(object: I): GetDiscoveredDevicesResponse {
    const message = createBaseGetDiscoveredDevicesResponse();
    message.devices = object.devices?.map((e) => DiscoveredDevice.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFan(): Fan {
  return {
    deviceId: "",
    speed: 0,
    name: "",
    status: 0,
    ledStatus: 0,
    drawer: "",
    collectedAt: undefined,
    direction: 0,
    serial: "",
    model: "",
  };
}

export const Fan: MessageFns<Fan> = {
  encode(message: Fan, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.speed !== 0) {
      writer.uint32(24).uint32(message.speed);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.status !== 0) {
      writer.uint32(48).int32(message.status);
    }
    if (message.ledStatus !== 0) {
      writer.uint32(56).int32(message.ledStatus);
    }
    if (message.drawer !== "") {
      writer.uint32(66).string(message.drawer);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(74).fork()).join();
    }
    if (message.direction !== 0) {
      writer.uint32(80).int32(message.direction);
    }
    if (message.serial !== "") {
      writer.uint32(90).string(message.serial);
    }
    if (message.model !== "") {
      writer.uint32(98).string(message.model);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Fan {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFan();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.speed = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.ledStatus = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.drawer = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.direction = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.model = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Fan {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      speed: isSet(object.speed) ? globalThis.Number(object.speed) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      status: isSet(object.status) ? envStatusFromJSON(object.status) : 0,
      ledStatus: isSet(object.ledStatus) ? envLedStatusFromJSON(object.ledStatus) : 0,
      drawer: isSet(object.drawer) ? globalThis.String(object.drawer) : "",
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      direction: isSet(object.direction) ? fanDirectionFromJSON(object.direction) : 0,
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      model: isSet(object.model) ? globalThis.String(object.model) : "",
    };
  },

  toJSON(message: Fan): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.speed !== 0) {
      obj.speed = Math.round(message.speed);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.status !== 0) {
      obj.status = envStatusToJSON(message.status);
    }
    if (message.ledStatus !== 0) {
      obj.ledStatus = envLedStatusToJSON(message.ledStatus);
    }
    if (message.drawer !== "") {
      obj.drawer = message.drawer;
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.direction !== 0) {
      obj.direction = fanDirectionToJSON(message.direction);
    }
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.model !== "") {
      obj.model = message.model;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Fan>, I>>(base?: I): Fan {
    return Fan.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Fan>, I>>(object: I): Fan {
    const message = createBaseFan();
    message.deviceId = object.deviceId ?? "";
    message.speed = object.speed ?? 0;
    message.name = object.name ?? "";
    message.status = object.status ?? 0;
    message.ledStatus = object.ledStatus ?? 0;
    message.drawer = object.drawer ?? "";
    message.collectedAt = object.collectedAt ?? undefined;
    message.direction = object.direction ?? 0;
    message.serial = object.serial ?? "";
    message.model = object.model ?? "";
    return message;
  },
};

function createBasePsu(): Psu {
  return {
    deviceId: "",
    watts: 0,
    fanSpeed: 0,
    name: "",
    status: 0,
    ledStatus: 0,
    model: "",
    serial: "",
    voltage: 0,
    current: 0,
  };
}

export const Psu: MessageFns<Psu> = {
  encode(message: Psu, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.watts !== 0) {
      writer.uint32(16).uint32(message.watts);
    }
    if (message.fanSpeed !== 0) {
      writer.uint32(24).uint32(message.fanSpeed);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.status !== 0) {
      writer.uint32(40).int32(message.status);
    }
    if (message.ledStatus !== 0) {
      writer.uint32(48).int32(message.ledStatus);
    }
    if (message.model !== "") {
      writer.uint32(58).string(message.model);
    }
    if (message.serial !== "") {
      writer.uint32(66).string(message.serial);
    }
    if (message.voltage !== 0) {
      writer.uint32(77).float(message.voltage);
    }
    if (message.current !== 0) {
      writer.uint32(85).float(message.current);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Psu {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePsu();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.watts = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.fanSpeed = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.ledStatus = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.voltage = reader.float();
          continue;
        }
        case 10: {
          if (tag !== 85) {
            break;
          }

          message.current = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Psu {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      watts: isSet(object.watts) ? globalThis.Number(object.watts) : 0,
      fanSpeed: isSet(object.fanSpeed) ? globalThis.Number(object.fanSpeed) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      status: isSet(object.status) ? envStatusFromJSON(object.status) : 0,
      ledStatus: isSet(object.ledStatus) ? envLedStatusFromJSON(object.ledStatus) : 0,
      model: isSet(object.model) ? globalThis.String(object.model) : "",
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      voltage: isSet(object.voltage) ? globalThis.Number(object.voltage) : 0,
      current: isSet(object.current) ? globalThis.Number(object.current) : 0,
    };
  },

  toJSON(message: Psu): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.watts !== 0) {
      obj.watts = Math.round(message.watts);
    }
    if (message.fanSpeed !== 0) {
      obj.fanSpeed = Math.round(message.fanSpeed);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.status !== 0) {
      obj.status = envStatusToJSON(message.status);
    }
    if (message.ledStatus !== 0) {
      obj.ledStatus = envLedStatusToJSON(message.ledStatus);
    }
    if (message.model !== "") {
      obj.model = message.model;
    }
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.voltage !== 0) {
      obj.voltage = message.voltage;
    }
    if (message.current !== 0) {
      obj.current = message.current;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Psu>, I>>(base?: I): Psu {
    return Psu.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Psu>, I>>(object: I): Psu {
    const message = createBasePsu();
    message.deviceId = object.deviceId ?? "";
    message.watts = object.watts ?? 0;
    message.fanSpeed = object.fanSpeed ?? 0;
    message.name = object.name ?? "";
    message.status = object.status ?? 0;
    message.ledStatus = object.ledStatus ?? 0;
    message.model = object.model ?? "";
    message.serial = object.serial ?? "";
    message.voltage = object.voltage ?? 0;
    message.current = object.current ?? 0;
    return message;
  },
};

function createBaseQsfpInfo(): QsfpInfo {
  return {
    deviceId: "",
    activeApselHostlane1: false,
    activeApselHostlane2: false,
    activeApselHostlane3: false,
    activeApselHostlane4: false,
    activeApselHostlane5: false,
    activeApselHostlane6: false,
    activeApselHostlane7: false,
    activeApselHostlane8: false,
    activeFirmware: "",
    applicationAdvertisement: "",
    cableLength: 0,
    cableType: "",
    cmisRev: 0,
    connector: "",
    domCapability: "",
    encoding: "",
    extIdentifier: "",
    extRateselectCompliance: "",
    hardwareRev: 0,
    hostElectricalInterface: "",
    hostLaneAssignmentOption: 0,
    hostLaneCount: 0,
    inactiveFirmware: "",
    isReplaceable: false,
    manufacturer: "",
    mediaInterfaceCode: "",
    mediaInterfaceTechnology: "",
    mediaLaneAssignmentOption: 0,
    mediaLaneCount: 0,
    model: "",
    nominalBitRate: 0,
    serial: "",
    specificationCompliance: "",
    supportedMaxLaserFreq: 0,
    supportedMaxTxPower: 0,
    supportedMinLaserFreq: 0,
    supportedMinTxPower: 0,
    type: "",
    vendorDate: undefined,
    vendorOui: "",
    vendorRev: "",
    transceiverModule: 0,
    pid: "",
    interfaceName: "",
    neighborType: 0,
    collectedAt: undefined,
    duplex: 0,
    advertisedAutoNegotiation: 0,
    transceiver: 0,
    phyAd: 0,
    wakeOn: "",
    advertisedFec: 0,
    advertisedPauseFrameUse: "",
    autoNegotiation: 0,
    portAlias: "",
    lot: "",
  };
}

export const QsfpInfo: MessageFns<QsfpInfo> = {
  encode(message: QsfpInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.activeApselHostlane1 !== false) {
      writer.uint32(16).bool(message.activeApselHostlane1);
    }
    if (message.activeApselHostlane2 !== false) {
      writer.uint32(24).bool(message.activeApselHostlane2);
    }
    if (message.activeApselHostlane3 !== false) {
      writer.uint32(32).bool(message.activeApselHostlane3);
    }
    if (message.activeApselHostlane4 !== false) {
      writer.uint32(40).bool(message.activeApselHostlane4);
    }
    if (message.activeApselHostlane5 !== false) {
      writer.uint32(48).bool(message.activeApselHostlane5);
    }
    if (message.activeApselHostlane6 !== false) {
      writer.uint32(56).bool(message.activeApselHostlane6);
    }
    if (message.activeApselHostlane7 !== false) {
      writer.uint32(64).bool(message.activeApselHostlane7);
    }
    if (message.activeApselHostlane8 !== false) {
      writer.uint32(72).bool(message.activeApselHostlane8);
    }
    if (message.activeFirmware !== "") {
      writer.uint32(82).string(message.activeFirmware);
    }
    if (message.applicationAdvertisement !== "") {
      writer.uint32(90).string(message.applicationAdvertisement);
    }
    if (message.cableLength !== 0) {
      writer.uint32(101).float(message.cableLength);
    }
    if (message.cableType !== "") {
      writer.uint32(106).string(message.cableType);
    }
    if (message.cmisRev !== 0) {
      writer.uint32(117).float(message.cmisRev);
    }
    if (message.connector !== "") {
      writer.uint32(122).string(message.connector);
    }
    if (message.domCapability !== "") {
      writer.uint32(130).string(message.domCapability);
    }
    if (message.encoding !== "") {
      writer.uint32(138).string(message.encoding);
    }
    if (message.extIdentifier !== "") {
      writer.uint32(146).string(message.extIdentifier);
    }
    if (message.extRateselectCompliance !== "") {
      writer.uint32(154).string(message.extRateselectCompliance);
    }
    if (message.hardwareRev !== 0) {
      writer.uint32(165).float(message.hardwareRev);
    }
    if (message.hostElectricalInterface !== "") {
      writer.uint32(170).string(message.hostElectricalInterface);
    }
    if (message.hostLaneAssignmentOption !== 0) {
      writer.uint32(176).int32(message.hostLaneAssignmentOption);
    }
    if (message.hostLaneCount !== 0) {
      writer.uint32(184).int32(message.hostLaneCount);
    }
    if (message.inactiveFirmware !== "") {
      writer.uint32(194).string(message.inactiveFirmware);
    }
    if (message.isReplaceable !== false) {
      writer.uint32(200).bool(message.isReplaceable);
    }
    if (message.manufacturer !== "") {
      writer.uint32(210).string(message.manufacturer);
    }
    if (message.mediaInterfaceCode !== "") {
      writer.uint32(218).string(message.mediaInterfaceCode);
    }
    if (message.mediaInterfaceTechnology !== "") {
      writer.uint32(226).string(message.mediaInterfaceTechnology);
    }
    if (message.mediaLaneAssignmentOption !== 0) {
      writer.uint32(232).int32(message.mediaLaneAssignmentOption);
    }
    if (message.mediaLaneCount !== 0) {
      writer.uint32(240).int32(message.mediaLaneCount);
    }
    if (message.model !== "") {
      writer.uint32(250).string(message.model);
    }
    if (message.nominalBitRate !== 0) {
      writer.uint32(261).float(message.nominalBitRate);
    }
    if (message.serial !== "") {
      writer.uint32(266).string(message.serial);
    }
    if (message.specificationCompliance !== "") {
      writer.uint32(274).string(message.specificationCompliance);
    }
    if (message.supportedMaxLaserFreq !== 0) {
      writer.uint32(285).float(message.supportedMaxLaserFreq);
    }
    if (message.supportedMaxTxPower !== 0) {
      writer.uint32(293).float(message.supportedMaxTxPower);
    }
    if (message.supportedMinLaserFreq !== 0) {
      writer.uint32(301).float(message.supportedMinLaserFreq);
    }
    if (message.supportedMinTxPower !== 0) {
      writer.uint32(309).float(message.supportedMinTxPower);
    }
    if (message.type !== "") {
      writer.uint32(314).string(message.type);
    }
    if (message.vendorDate !== undefined) {
      Timestamp.encode(toTimestamp(message.vendorDate), writer.uint32(322).fork()).join();
    }
    if (message.vendorOui !== "") {
      writer.uint32(330).string(message.vendorOui);
    }
    if (message.vendorRev !== "") {
      writer.uint32(338).string(message.vendorRev);
    }
    if (message.transceiverModule !== 0) {
      writer.uint32(344).int32(message.transceiverModule);
    }
    if (message.pid !== "") {
      writer.uint32(354).string(message.pid);
    }
    if (message.interfaceName !== "") {
      writer.uint32(362).string(message.interfaceName);
    }
    if (message.neighborType !== 0) {
      writer.uint32(368).int32(message.neighborType);
    }
    if (message.collectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.collectedAt), writer.uint32(378).fork()).join();
    }
    if (message.duplex !== 0) {
      writer.uint32(384).int32(message.duplex);
    }
    if (message.advertisedAutoNegotiation !== 0) {
      writer.uint32(392).int32(message.advertisedAutoNegotiation);
    }
    if (message.transceiver !== 0) {
      writer.uint32(400).int32(message.transceiver);
    }
    if (message.phyAd !== 0) {
      writer.uint32(408).uint32(message.phyAd);
    }
    if (message.wakeOn !== "") {
      writer.uint32(418).string(message.wakeOn);
    }
    if (message.advertisedFec !== 0) {
      writer.uint32(424).int32(message.advertisedFec);
    }
    if (message.advertisedPauseFrameUse !== "") {
      writer.uint32(434).string(message.advertisedPauseFrameUse);
    }
    if (message.autoNegotiation !== 0) {
      writer.uint32(440).int32(message.autoNegotiation);
    }
    if (message.portAlias !== "") {
      writer.uint32(450).string(message.portAlias);
    }
    if (message.lot !== "") {
      writer.uint32(458).string(message.lot);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QsfpInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQsfpInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.activeApselHostlane1 = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.activeApselHostlane2 = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.activeApselHostlane3 = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.activeApselHostlane4 = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.activeApselHostlane5 = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.activeApselHostlane6 = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.activeApselHostlane7 = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.activeApselHostlane8 = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.activeFirmware = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.applicationAdvertisement = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 101) {
            break;
          }

          message.cableLength = reader.float();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.cableType = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 117) {
            break;
          }

          message.cmisRev = reader.float();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.connector = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.domCapability = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.encoding = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.extIdentifier = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.extRateselectCompliance = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 165) {
            break;
          }

          message.hardwareRev = reader.float();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.hostElectricalInterface = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.hostLaneAssignmentOption = reader.int32();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.hostLaneCount = reader.int32();
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.inactiveFirmware = reader.string();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.isReplaceable = reader.bool();
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.manufacturer = reader.string();
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.mediaInterfaceCode = reader.string();
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.mediaInterfaceTechnology = reader.string();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.mediaLaneAssignmentOption = reader.int32();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.mediaLaneCount = reader.int32();
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 32: {
          if (tag !== 261) {
            break;
          }

          message.nominalBitRate = reader.float();
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.specificationCompliance = reader.string();
          continue;
        }
        case 35: {
          if (tag !== 285) {
            break;
          }

          message.supportedMaxLaserFreq = reader.float();
          continue;
        }
        case 36: {
          if (tag !== 293) {
            break;
          }

          message.supportedMaxTxPower = reader.float();
          continue;
        }
        case 37: {
          if (tag !== 301) {
            break;
          }

          message.supportedMinLaserFreq = reader.float();
          continue;
        }
        case 38: {
          if (tag !== 309) {
            break;
          }

          message.supportedMinTxPower = reader.float();
          continue;
        }
        case 39: {
          if (tag !== 314) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.vendorDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 41: {
          if (tag !== 330) {
            break;
          }

          message.vendorOui = reader.string();
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.vendorRev = reader.string();
          continue;
        }
        case 43: {
          if (tag !== 344) {
            break;
          }

          message.transceiverModule = reader.int32() as any;
          continue;
        }
        case 44: {
          if (tag !== 354) {
            break;
          }

          message.pid = reader.string();
          continue;
        }
        case 45: {
          if (tag !== 362) {
            break;
          }

          message.interfaceName = reader.string();
          continue;
        }
        case 46: {
          if (tag !== 368) {
            break;
          }

          message.neighborType = reader.int32() as any;
          continue;
        }
        case 47: {
          if (tag !== 378) {
            break;
          }

          message.collectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 48: {
          if (tag !== 384) {
            break;
          }

          message.duplex = reader.int32() as any;
          continue;
        }
        case 49: {
          if (tag !== 392) {
            break;
          }

          message.advertisedAutoNegotiation = reader.int32() as any;
          continue;
        }
        case 50: {
          if (tag !== 400) {
            break;
          }

          message.transceiver = reader.int32() as any;
          continue;
        }
        case 51: {
          if (tag !== 408) {
            break;
          }

          message.phyAd = reader.uint32();
          continue;
        }
        case 52: {
          if (tag !== 418) {
            break;
          }

          message.wakeOn = reader.string();
          continue;
        }
        case 53: {
          if (tag !== 424) {
            break;
          }

          message.advertisedFec = reader.int32() as any;
          continue;
        }
        case 54: {
          if (tag !== 434) {
            break;
          }

          message.advertisedPauseFrameUse = reader.string();
          continue;
        }
        case 55: {
          if (tag !== 440) {
            break;
          }

          message.autoNegotiation = reader.int32() as any;
          continue;
        }
        case 56: {
          if (tag !== 450) {
            break;
          }

          message.portAlias = reader.string();
          continue;
        }
        case 57: {
          if (tag !== 458) {
            break;
          }

          message.lot = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QsfpInfo {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      activeApselHostlane1: isSet(object.activeApselHostlane1)
        ? globalThis.Boolean(object.activeApselHostlane1)
        : false,
      activeApselHostlane2: isSet(object.activeApselHostlane2)
        ? globalThis.Boolean(object.activeApselHostlane2)
        : false,
      activeApselHostlane3: isSet(object.activeApselHostlane3)
        ? globalThis.Boolean(object.activeApselHostlane3)
        : false,
      activeApselHostlane4: isSet(object.activeApselHostlane4)
        ? globalThis.Boolean(object.activeApselHostlane4)
        : false,
      activeApselHostlane5: isSet(object.activeApselHostlane5)
        ? globalThis.Boolean(object.activeApselHostlane5)
        : false,
      activeApselHostlane6: isSet(object.activeApselHostlane6)
        ? globalThis.Boolean(object.activeApselHostlane6)
        : false,
      activeApselHostlane7: isSet(object.activeApselHostlane7)
        ? globalThis.Boolean(object.activeApselHostlane7)
        : false,
      activeApselHostlane8: isSet(object.activeApselHostlane8)
        ? globalThis.Boolean(object.activeApselHostlane8)
        : false,
      activeFirmware: isSet(object.activeFirmware) ? globalThis.String(object.activeFirmware) : "",
      applicationAdvertisement: isSet(object.applicationAdvertisement)
        ? globalThis.String(object.applicationAdvertisement)
        : "",
      cableLength: isSet(object.cableLength) ? globalThis.Number(object.cableLength) : 0,
      cableType: isSet(object.cableType) ? globalThis.String(object.cableType) : "",
      cmisRev: isSet(object.cmisRev) ? globalThis.Number(object.cmisRev) : 0,
      connector: isSet(object.connector) ? globalThis.String(object.connector) : "",
      domCapability: isSet(object.domCapability) ? globalThis.String(object.domCapability) : "",
      encoding: isSet(object.encoding) ? globalThis.String(object.encoding) : "",
      extIdentifier: isSet(object.extIdentifier) ? globalThis.String(object.extIdentifier) : "",
      extRateselectCompliance: isSet(object.extRateselectCompliance)
        ? globalThis.String(object.extRateselectCompliance)
        : "",
      hardwareRev: isSet(object.hardwareRev) ? globalThis.Number(object.hardwareRev) : 0,
      hostElectricalInterface: isSet(object.hostElectricalInterface)
        ? globalThis.String(object.hostElectricalInterface)
        : "",
      hostLaneAssignmentOption: isSet(object.hostLaneAssignmentOption)
        ? globalThis.Number(object.hostLaneAssignmentOption)
        : 0,
      hostLaneCount: isSet(object.hostLaneCount) ? globalThis.Number(object.hostLaneCount) : 0,
      inactiveFirmware: isSet(object.inactiveFirmware) ? globalThis.String(object.inactiveFirmware) : "",
      isReplaceable: isSet(object.isReplaceable) ? globalThis.Boolean(object.isReplaceable) : false,
      manufacturer: isSet(object.manufacturer) ? globalThis.String(object.manufacturer) : "",
      mediaInterfaceCode: isSet(object.mediaInterfaceCode) ? globalThis.String(object.mediaInterfaceCode) : "",
      mediaInterfaceTechnology: isSet(object.mediaInterfaceTechnology)
        ? globalThis.String(object.mediaInterfaceTechnology)
        : "",
      mediaLaneAssignmentOption: isSet(object.mediaLaneAssignmentOption)
        ? globalThis.Number(object.mediaLaneAssignmentOption)
        : 0,
      mediaLaneCount: isSet(object.mediaLaneCount) ? globalThis.Number(object.mediaLaneCount) : 0,
      model: isSet(object.model) ? globalThis.String(object.model) : "",
      nominalBitRate: isSet(object.nominalBitRate) ? globalThis.Number(object.nominalBitRate) : 0,
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      specificationCompliance: isSet(object.specificationCompliance)
        ? globalThis.String(object.specificationCompliance)
        : "",
      supportedMaxLaserFreq: isSet(object.supportedMaxLaserFreq) ? globalThis.Number(object.supportedMaxLaserFreq) : 0,
      supportedMaxTxPower: isSet(object.supportedMaxTxPower) ? globalThis.Number(object.supportedMaxTxPower) : 0,
      supportedMinLaserFreq: isSet(object.supportedMinLaserFreq) ? globalThis.Number(object.supportedMinLaserFreq) : 0,
      supportedMinTxPower: isSet(object.supportedMinTxPower) ? globalThis.Number(object.supportedMinTxPower) : 0,
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      vendorDate: isSet(object.vendorDate) ? fromJsonTimestamp(object.vendorDate) : undefined,
      vendorOui: isSet(object.vendorOui) ? globalThis.String(object.vendorOui) : "",
      vendorRev: isSet(object.vendorRev) ? globalThis.String(object.vendorRev) : "",
      transceiverModule: isSet(object.transceiverModule) ? qsfpTransceiverModuleFromJSON(object.transceiverModule) : 0,
      pid: isSet(object.pid) ? globalThis.String(object.pid) : "",
      interfaceName: isSet(object.interfaceName) ? globalThis.String(object.interfaceName) : "",
      neighborType: isSet(object.neighborType) ? neighborTypeFromJSON(object.neighborType) : 0,
      collectedAt: isSet(object.collectedAt) ? fromJsonTimestamp(object.collectedAt) : undefined,
      duplex: isSet(object.duplex) ? qsfpDuplexFromJSON(object.duplex) : 0,
      advertisedAutoNegotiation: isSet(object.advertisedAutoNegotiation)
        ? qsfpAdvertisedAutoNegotiationFromJSON(object.advertisedAutoNegotiation)
        : 0,
      transceiver: isSet(object.transceiver) ? qsfpTransceiverFromJSON(object.transceiver) : 0,
      phyAd: isSet(object.phyAd) ? globalThis.Number(object.phyAd) : 0,
      wakeOn: isSet(object.wakeOn) ? globalThis.String(object.wakeOn) : "",
      advertisedFec: isSet(object.advertisedFec) ? fecTypeFromJSON(object.advertisedFec) : 0,
      advertisedPauseFrameUse: isSet(object.advertisedPauseFrameUse)
        ? globalThis.String(object.advertisedPauseFrameUse)
        : "",
      autoNegotiation: isSet(object.autoNegotiation) ? qsfpAutoNegotiationFromJSON(object.autoNegotiation) : 0,
      portAlias: isSet(object.portAlias) ? globalThis.String(object.portAlias) : "",
      lot: isSet(object.lot) ? globalThis.String(object.lot) : "",
    };
  },

  toJSON(message: QsfpInfo): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.activeApselHostlane1 !== false) {
      obj.activeApselHostlane1 = message.activeApselHostlane1;
    }
    if (message.activeApselHostlane2 !== false) {
      obj.activeApselHostlane2 = message.activeApselHostlane2;
    }
    if (message.activeApselHostlane3 !== false) {
      obj.activeApselHostlane3 = message.activeApselHostlane3;
    }
    if (message.activeApselHostlane4 !== false) {
      obj.activeApselHostlane4 = message.activeApselHostlane4;
    }
    if (message.activeApselHostlane5 !== false) {
      obj.activeApselHostlane5 = message.activeApselHostlane5;
    }
    if (message.activeApselHostlane6 !== false) {
      obj.activeApselHostlane6 = message.activeApselHostlane6;
    }
    if (message.activeApselHostlane7 !== false) {
      obj.activeApselHostlane7 = message.activeApselHostlane7;
    }
    if (message.activeApselHostlane8 !== false) {
      obj.activeApselHostlane8 = message.activeApselHostlane8;
    }
    if (message.activeFirmware !== "") {
      obj.activeFirmware = message.activeFirmware;
    }
    if (message.applicationAdvertisement !== "") {
      obj.applicationAdvertisement = message.applicationAdvertisement;
    }
    if (message.cableLength !== 0) {
      obj.cableLength = message.cableLength;
    }
    if (message.cableType !== "") {
      obj.cableType = message.cableType;
    }
    if (message.cmisRev !== 0) {
      obj.cmisRev = message.cmisRev;
    }
    if (message.connector !== "") {
      obj.connector = message.connector;
    }
    if (message.domCapability !== "") {
      obj.domCapability = message.domCapability;
    }
    if (message.encoding !== "") {
      obj.encoding = message.encoding;
    }
    if (message.extIdentifier !== "") {
      obj.extIdentifier = message.extIdentifier;
    }
    if (message.extRateselectCompliance !== "") {
      obj.extRateselectCompliance = message.extRateselectCompliance;
    }
    if (message.hardwareRev !== 0) {
      obj.hardwareRev = message.hardwareRev;
    }
    if (message.hostElectricalInterface !== "") {
      obj.hostElectricalInterface = message.hostElectricalInterface;
    }
    if (message.hostLaneAssignmentOption !== 0) {
      obj.hostLaneAssignmentOption = Math.round(message.hostLaneAssignmentOption);
    }
    if (message.hostLaneCount !== 0) {
      obj.hostLaneCount = Math.round(message.hostLaneCount);
    }
    if (message.inactiveFirmware !== "") {
      obj.inactiveFirmware = message.inactiveFirmware;
    }
    if (message.isReplaceable !== false) {
      obj.isReplaceable = message.isReplaceable;
    }
    if (message.manufacturer !== "") {
      obj.manufacturer = message.manufacturer;
    }
    if (message.mediaInterfaceCode !== "") {
      obj.mediaInterfaceCode = message.mediaInterfaceCode;
    }
    if (message.mediaInterfaceTechnology !== "") {
      obj.mediaInterfaceTechnology = message.mediaInterfaceTechnology;
    }
    if (message.mediaLaneAssignmentOption !== 0) {
      obj.mediaLaneAssignmentOption = Math.round(message.mediaLaneAssignmentOption);
    }
    if (message.mediaLaneCount !== 0) {
      obj.mediaLaneCount = Math.round(message.mediaLaneCount);
    }
    if (message.model !== "") {
      obj.model = message.model;
    }
    if (message.nominalBitRate !== 0) {
      obj.nominalBitRate = message.nominalBitRate;
    }
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.specificationCompliance !== "") {
      obj.specificationCompliance = message.specificationCompliance;
    }
    if (message.supportedMaxLaserFreq !== 0) {
      obj.supportedMaxLaserFreq = message.supportedMaxLaserFreq;
    }
    if (message.supportedMaxTxPower !== 0) {
      obj.supportedMaxTxPower = message.supportedMaxTxPower;
    }
    if (message.supportedMinLaserFreq !== 0) {
      obj.supportedMinLaserFreq = message.supportedMinLaserFreq;
    }
    if (message.supportedMinTxPower !== 0) {
      obj.supportedMinTxPower = message.supportedMinTxPower;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.vendorDate !== undefined) {
      obj.vendorDate = message.vendorDate.toISOString();
    }
    if (message.vendorOui !== "") {
      obj.vendorOui = message.vendorOui;
    }
    if (message.vendorRev !== "") {
      obj.vendorRev = message.vendorRev;
    }
    if (message.transceiverModule !== 0) {
      obj.transceiverModule = qsfpTransceiverModuleToJSON(message.transceiverModule);
    }
    if (message.pid !== "") {
      obj.pid = message.pid;
    }
    if (message.interfaceName !== "") {
      obj.interfaceName = message.interfaceName;
    }
    if (message.neighborType !== 0) {
      obj.neighborType = neighborTypeToJSON(message.neighborType);
    }
    if (message.collectedAt !== undefined) {
      obj.collectedAt = message.collectedAt.toISOString();
    }
    if (message.duplex !== 0) {
      obj.duplex = qsfpDuplexToJSON(message.duplex);
    }
    if (message.advertisedAutoNegotiation !== 0) {
      obj.advertisedAutoNegotiation = qsfpAdvertisedAutoNegotiationToJSON(message.advertisedAutoNegotiation);
    }
    if (message.transceiver !== 0) {
      obj.transceiver = qsfpTransceiverToJSON(message.transceiver);
    }
    if (message.phyAd !== 0) {
      obj.phyAd = Math.round(message.phyAd);
    }
    if (message.wakeOn !== "") {
      obj.wakeOn = message.wakeOn;
    }
    if (message.advertisedFec !== 0) {
      obj.advertisedFec = fecTypeToJSON(message.advertisedFec);
    }
    if (message.advertisedPauseFrameUse !== "") {
      obj.advertisedPauseFrameUse = message.advertisedPauseFrameUse;
    }
    if (message.autoNegotiation !== 0) {
      obj.autoNegotiation = qsfpAutoNegotiationToJSON(message.autoNegotiation);
    }
    if (message.portAlias !== "") {
      obj.portAlias = message.portAlias;
    }
    if (message.lot !== "") {
      obj.lot = message.lot;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QsfpInfo>, I>>(base?: I): QsfpInfo {
    return QsfpInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QsfpInfo>, I>>(object: I): QsfpInfo {
    const message = createBaseQsfpInfo();
    message.deviceId = object.deviceId ?? "";
    message.activeApselHostlane1 = object.activeApselHostlane1 ?? false;
    message.activeApselHostlane2 = object.activeApselHostlane2 ?? false;
    message.activeApselHostlane3 = object.activeApselHostlane3 ?? false;
    message.activeApselHostlane4 = object.activeApselHostlane4 ?? false;
    message.activeApselHostlane5 = object.activeApselHostlane5 ?? false;
    message.activeApselHostlane6 = object.activeApselHostlane6 ?? false;
    message.activeApselHostlane7 = object.activeApselHostlane7 ?? false;
    message.activeApselHostlane8 = object.activeApselHostlane8 ?? false;
    message.activeFirmware = object.activeFirmware ?? "";
    message.applicationAdvertisement = object.applicationAdvertisement ?? "";
    message.cableLength = object.cableLength ?? 0;
    message.cableType = object.cableType ?? "";
    message.cmisRev = object.cmisRev ?? 0;
    message.connector = object.connector ?? "";
    message.domCapability = object.domCapability ?? "";
    message.encoding = object.encoding ?? "";
    message.extIdentifier = object.extIdentifier ?? "";
    message.extRateselectCompliance = object.extRateselectCompliance ?? "";
    message.hardwareRev = object.hardwareRev ?? 0;
    message.hostElectricalInterface = object.hostElectricalInterface ?? "";
    message.hostLaneAssignmentOption = object.hostLaneAssignmentOption ?? 0;
    message.hostLaneCount = object.hostLaneCount ?? 0;
    message.inactiveFirmware = object.inactiveFirmware ?? "";
    message.isReplaceable = object.isReplaceable ?? false;
    message.manufacturer = object.manufacturer ?? "";
    message.mediaInterfaceCode = object.mediaInterfaceCode ?? "";
    message.mediaInterfaceTechnology = object.mediaInterfaceTechnology ?? "";
    message.mediaLaneAssignmentOption = object.mediaLaneAssignmentOption ?? 0;
    message.mediaLaneCount = object.mediaLaneCount ?? 0;
    message.model = object.model ?? "";
    message.nominalBitRate = object.nominalBitRate ?? 0;
    message.serial = object.serial ?? "";
    message.specificationCompliance = object.specificationCompliance ?? "";
    message.supportedMaxLaserFreq = object.supportedMaxLaserFreq ?? 0;
    message.supportedMaxTxPower = object.supportedMaxTxPower ?? 0;
    message.supportedMinLaserFreq = object.supportedMinLaserFreq ?? 0;
    message.supportedMinTxPower = object.supportedMinTxPower ?? 0;
    message.type = object.type ?? "";
    message.vendorDate = object.vendorDate ?? undefined;
    message.vendorOui = object.vendorOui ?? "";
    message.vendorRev = object.vendorRev ?? "";
    message.transceiverModule = object.transceiverModule ?? 0;
    message.pid = object.pid ?? "";
    message.interfaceName = object.interfaceName ?? "";
    message.neighborType = object.neighborType ?? 0;
    message.collectedAt = object.collectedAt ?? undefined;
    message.duplex = object.duplex ?? 0;
    message.advertisedAutoNegotiation = object.advertisedAutoNegotiation ?? 0;
    message.transceiver = object.transceiver ?? 0;
    message.phyAd = object.phyAd ?? 0;
    message.wakeOn = object.wakeOn ?? "";
    message.advertisedFec = object.advertisedFec ?? 0;
    message.advertisedPauseFrameUse = object.advertisedPauseFrameUse ?? "";
    message.autoNegotiation = object.autoNegotiation ?? 0;
    message.portAlias = object.portAlias ?? "";
    message.lot = object.lot ?? "";
    return message;
  },
};

function createBaseGetAllFansRequest(): GetAllFansRequest {
  return {};
}

export const GetAllFansRequest: MessageFns<GetAllFansRequest> = {
  encode(_: GetAllFansRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllFansRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllFansRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetAllFansRequest {
    return {};
  },

  toJSON(_: GetAllFansRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllFansRequest>, I>>(base?: I): GetAllFansRequest {
    return GetAllFansRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllFansRequest>, I>>(_: I): GetAllFansRequest {
    const message = createBaseGetAllFansRequest();
    return message;
  },
};

function createBaseGetAllFansResponse(): GetAllFansResponse {
  return { fans: [] };
}

export const GetAllFansResponse: MessageFns<GetAllFansResponse> = {
  encode(message: GetAllFansResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.fans) {
      Fan.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllFansResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllFansResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fans.push(Fan.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllFansResponse {
    return { fans: globalThis.Array.isArray(object?.fans) ? object.fans.map((e: any) => Fan.fromJSON(e)) : [] };
  },

  toJSON(message: GetAllFansResponse): unknown {
    const obj: any = {};
    if (message.fans?.length) {
      obj.fans = message.fans.map((e) => Fan.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllFansResponse>, I>>(base?: I): GetAllFansResponse {
    return GetAllFansResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllFansResponse>, I>>(object: I): GetAllFansResponse {
    const message = createBaseGetAllFansResponse();
    message.fans = object.fans?.map((e) => Fan.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetAllPsusRequest(): GetAllPsusRequest {
  return {};
}

export const GetAllPsusRequest: MessageFns<GetAllPsusRequest> = {
  encode(_: GetAllPsusRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllPsusRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllPsusRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetAllPsusRequest {
    return {};
  },

  toJSON(_: GetAllPsusRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllPsusRequest>, I>>(base?: I): GetAllPsusRequest {
    return GetAllPsusRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllPsusRequest>, I>>(_: I): GetAllPsusRequest {
    const message = createBaseGetAllPsusRequest();
    return message;
  },
};

function createBaseGetAllPsusResponse(): GetAllPsusResponse {
  return { psus: [] };
}

export const GetAllPsusResponse: MessageFns<GetAllPsusResponse> = {
  encode(message: GetAllPsusResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.psus) {
      Psu.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllPsusResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllPsusResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.psus.push(Psu.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllPsusResponse {
    return { psus: globalThis.Array.isArray(object?.psus) ? object.psus.map((e: any) => Psu.fromJSON(e)) : [] };
  },

  toJSON(message: GetAllPsusResponse): unknown {
    const obj: any = {};
    if (message.psus?.length) {
      obj.psus = message.psus.map((e) => Psu.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllPsusResponse>, I>>(base?: I): GetAllPsusResponse {
    return GetAllPsusResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllPsusResponse>, I>>(object: I): GetAllPsusResponse {
    const message = createBaseGetAllPsusResponse();
    message.psus = object.psus?.map((e) => Psu.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetAllPluggablesRequest(): GetAllPluggablesRequest {
  return {};
}

export const GetAllPluggablesRequest: MessageFns<GetAllPluggablesRequest> = {
  encode(_: GetAllPluggablesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllPluggablesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllPluggablesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetAllPluggablesRequest {
    return {};
  },

  toJSON(_: GetAllPluggablesRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllPluggablesRequest>, I>>(base?: I): GetAllPluggablesRequest {
    return GetAllPluggablesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllPluggablesRequest>, I>>(_: I): GetAllPluggablesRequest {
    const message = createBaseGetAllPluggablesRequest();
    return message;
  },
};

function createBaseGetAllPluggablesResponse(): GetAllPluggablesResponse {
  return { pluggables: [] };
}

export const GetAllPluggablesResponse: MessageFns<GetAllPluggablesResponse> = {
  encode(message: GetAllPluggablesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.pluggables) {
      QsfpInfo.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllPluggablesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllPluggablesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pluggables.push(QsfpInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllPluggablesResponse {
    return {
      pluggables: globalThis.Array.isArray(object?.pluggables)
        ? object.pluggables.map((e: any) => QsfpInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetAllPluggablesResponse): unknown {
    const obj: any = {};
    if (message.pluggables?.length) {
      obj.pluggables = message.pluggables.map((e) => QsfpInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllPluggablesResponse>, I>>(base?: I): GetAllPluggablesResponse {
    return GetAllPluggablesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllPluggablesResponse>, I>>(object: I): GetAllPluggablesResponse {
    const message = createBaseGetAllPluggablesResponse();
    message.pluggables = object.pluggables?.map((e) => QsfpInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseInventoryCount(): InventoryCount {
  return { name: "", count: 0 };
}

export const InventoryCount: MessageFns<InventoryCount> = {
  encode(message: InventoryCount, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.count !== 0) {
      writer.uint32(16).int32(message.count);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InventoryCount {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInventoryCount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.count = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InventoryCount {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      count: isSet(object.count) ? globalThis.Number(object.count) : 0,
    };
  },

  toJSON(message: InventoryCount): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.count !== 0) {
      obj.count = Math.round(message.count);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InventoryCount>, I>>(base?: I): InventoryCount {
    return InventoryCount.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InventoryCount>, I>>(object: I): InventoryCount {
    const message = createBaseInventoryCount();
    message.name = object.name ?? "";
    message.count = object.count ?? 0;
    return message;
  },
};

function createBaseGetInventoryCountsRequest(): GetInventoryCountsRequest {
  return {};
}

export const GetInventoryCountsRequest: MessageFns<GetInventoryCountsRequest> = {
  encode(_: GetInventoryCountsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetInventoryCountsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetInventoryCountsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetInventoryCountsRequest {
    return {};
  },

  toJSON(_: GetInventoryCountsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetInventoryCountsRequest>, I>>(base?: I): GetInventoryCountsRequest {
    return GetInventoryCountsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetInventoryCountsRequest>, I>>(_: I): GetInventoryCountsRequest {
    const message = createBaseGetInventoryCountsRequest();
    return message;
  },
};

function createBaseGetInventoryCountsResponse(): GetInventoryCountsResponse {
  return { fanCounts: [], psuCounts: [], pluggableCounts: [] };
}

export const GetInventoryCountsResponse: MessageFns<GetInventoryCountsResponse> = {
  encode(message: GetInventoryCountsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.fanCounts) {
      InventoryCount.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.psuCounts) {
      InventoryCount.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.pluggableCounts) {
      InventoryCount.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetInventoryCountsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetInventoryCountsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fanCounts.push(InventoryCount.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.psuCounts.push(InventoryCount.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.pluggableCounts.push(InventoryCount.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetInventoryCountsResponse {
    return {
      fanCounts: globalThis.Array.isArray(object?.fanCounts)
        ? object.fanCounts.map((e: any) => InventoryCount.fromJSON(e))
        : [],
      psuCounts: globalThis.Array.isArray(object?.psuCounts)
        ? object.psuCounts.map((e: any) => InventoryCount.fromJSON(e))
        : [],
      pluggableCounts: globalThis.Array.isArray(object?.pluggableCounts)
        ? object.pluggableCounts.map((e: any) => InventoryCount.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetInventoryCountsResponse): unknown {
    const obj: any = {};
    if (message.fanCounts?.length) {
      obj.fanCounts = message.fanCounts.map((e) => InventoryCount.toJSON(e));
    }
    if (message.psuCounts?.length) {
      obj.psuCounts = message.psuCounts.map((e) => InventoryCount.toJSON(e));
    }
    if (message.pluggableCounts?.length) {
      obj.pluggableCounts = message.pluggableCounts.map((e) => InventoryCount.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetInventoryCountsResponse>, I>>(base?: I): GetInventoryCountsResponse {
    return GetInventoryCountsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetInventoryCountsResponse>, I>>(object: I): GetInventoryCountsResponse {
    const message = createBaseGetInventoryCountsResponse();
    message.fanCounts = object.fanCounts?.map((e) => InventoryCount.fromPartial(e)) || [];
    message.psuCounts = object.psuCounts?.map((e) => InventoryCount.fromPartial(e)) || [];
    message.pluggableCounts = object.pluggableCounts?.map((e) => InventoryCount.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStreamOrgDataRequest(): StreamOrgDataRequest {
  return {};
}

export const StreamOrgDataRequest: MessageFns<StreamOrgDataRequest> = {
  encode(_: StreamOrgDataRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StreamOrgDataRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStreamOrgDataRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): StreamOrgDataRequest {
    return {};
  },

  toJSON(_: StreamOrgDataRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<StreamOrgDataRequest>, I>>(base?: I): StreamOrgDataRequest {
    return StreamOrgDataRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StreamOrgDataRequest>, I>>(_: I): StreamOrgDataRequest {
    const message = createBaseStreamOrgDataRequest();
    return message;
  },
};

function createBaseGetFabricConfigDiffRequest(): GetFabricConfigDiffRequest {
  return { fabricId: "", noTenants: false };
}

export const GetFabricConfigDiffRequest: MessageFns<GetFabricConfigDiffRequest> = {
  encode(message: GetFabricConfigDiffRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.noTenants !== false) {
      writer.uint32(16).bool(message.noTenants);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricConfigDiffRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricConfigDiffRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.noTenants = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricConfigDiffRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      noTenants: isSet(object.noTenants) ? globalThis.Boolean(object.noTenants) : false,
    };
  },

  toJSON(message: GetFabricConfigDiffRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.noTenants !== false) {
      obj.noTenants = message.noTenants;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricConfigDiffRequest>, I>>(base?: I): GetFabricConfigDiffRequest {
    return GetFabricConfigDiffRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricConfigDiffRequest>, I>>(object: I): GetFabricConfigDiffRequest {
    const message = createBaseGetFabricConfigDiffRequest();
    message.fabricId = object.fabricId ?? "";
    message.noTenants = object.noTenants ?? false;
    return message;
  },
};

function createBaseGetFabricConfigDiffResponse(): GetFabricConfigDiffResponse {
  return { fabricId: "", diffContent: "" };
}

export const GetFabricConfigDiffResponse: MessageFns<GetFabricConfigDiffResponse> = {
  encode(message: GetFabricConfigDiffResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.diffContent !== "") {
      writer.uint32(18).string(message.diffContent);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricConfigDiffResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricConfigDiffResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.diffContent = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricConfigDiffResponse {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      diffContent: isSet(object.diffContent) ? globalThis.String(object.diffContent) : "",
    };
  },

  toJSON(message: GetFabricConfigDiffResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.diffContent !== "") {
      obj.diffContent = message.diffContent;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricConfigDiffResponse>, I>>(base?: I): GetFabricConfigDiffResponse {
    return GetFabricConfigDiffResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricConfigDiffResponse>, I>>(object: I): GetFabricConfigDiffResponse {
    const message = createBaseGetFabricConfigDiffResponse();
    message.fabricId = object.fabricId ?? "";
    message.diffContent = object.diffContent ?? "";
    return message;
  },
};

function createBaseGetDciConfigDiffRequest(): GetDciConfigDiffRequest {
  return { dciId: "" };
}

export const GetDciConfigDiffRequest: MessageFns<GetDciConfigDiffRequest> = {
  encode(message: GetDciConfigDiffRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dciId !== "") {
      writer.uint32(10).string(message.dciId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDciConfigDiffRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDciConfigDiffRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dciId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDciConfigDiffRequest {
    return { dciId: isSet(object.dciId) ? globalThis.String(object.dciId) : "" };
  },

  toJSON(message: GetDciConfigDiffRequest): unknown {
    const obj: any = {};
    if (message.dciId !== "") {
      obj.dciId = message.dciId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDciConfigDiffRequest>, I>>(base?: I): GetDciConfigDiffRequest {
    return GetDciConfigDiffRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDciConfigDiffRequest>, I>>(object: I): GetDciConfigDiffRequest {
    const message = createBaseGetDciConfigDiffRequest();
    message.dciId = object.dciId ?? "";
    return message;
  },
};

function createBaseGetDciConfigDiffResponse(): GetDciConfigDiffResponse {
  return { dciId: "", diffContent: "" };
}

export const GetDciConfigDiffResponse: MessageFns<GetDciConfigDiffResponse> = {
  encode(message: GetDciConfigDiffResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dciId !== "") {
      writer.uint32(10).string(message.dciId);
    }
    if (message.diffContent !== "") {
      writer.uint32(18).string(message.diffContent);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDciConfigDiffResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDciConfigDiffResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dciId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.diffContent = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDciConfigDiffResponse {
    return {
      dciId: isSet(object.dciId) ? globalThis.String(object.dciId) : "",
      diffContent: isSet(object.diffContent) ? globalThis.String(object.diffContent) : "",
    };
  },

  toJSON(message: GetDciConfigDiffResponse): unknown {
    const obj: any = {};
    if (message.dciId !== "") {
      obj.dciId = message.dciId;
    }
    if (message.diffContent !== "") {
      obj.diffContent = message.diffContent;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDciConfigDiffResponse>, I>>(base?: I): GetDciConfigDiffResponse {
    return GetDciConfigDiffResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDciConfigDiffResponse>, I>>(object: I): GetDciConfigDiffResponse {
    const message = createBaseGetDciConfigDiffResponse();
    message.dciId = object.dciId ?? "";
    message.diffContent = object.diffContent ?? "";
    return message;
  },
};

function createBaseGetFabricConfigRevisionDiffRequest(): GetFabricConfigRevisionDiffRequest {
  return { fabricId: "", revisionId: "0", fromRevisionId: "0" };
}

export const GetFabricConfigRevisionDiffRequest: MessageFns<GetFabricConfigRevisionDiffRequest> = {
  encode(message: GetFabricConfigRevisionDiffRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.revisionId !== "0") {
      writer.uint32(16).int64(message.revisionId);
    }
    if (message.fromRevisionId !== "0") {
      writer.uint32(24).int64(message.fromRevisionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricConfigRevisionDiffRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricConfigRevisionDiffRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.revisionId = reader.int64().toString();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.fromRevisionId = reader.int64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricConfigRevisionDiffRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      revisionId: isSet(object.revisionId) ? globalThis.String(object.revisionId) : "0",
      fromRevisionId: isSet(object.fromRevisionId) ? globalThis.String(object.fromRevisionId) : "0",
    };
  },

  toJSON(message: GetFabricConfigRevisionDiffRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.revisionId !== "0") {
      obj.revisionId = message.revisionId;
    }
    if (message.fromRevisionId !== "0") {
      obj.fromRevisionId = message.fromRevisionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricConfigRevisionDiffRequest>, I>>(
    base?: I,
  ): GetFabricConfigRevisionDiffRequest {
    return GetFabricConfigRevisionDiffRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricConfigRevisionDiffRequest>, I>>(
    object: I,
  ): GetFabricConfigRevisionDiffRequest {
    const message = createBaseGetFabricConfigRevisionDiffRequest();
    message.fabricId = object.fabricId ?? "";
    message.revisionId = object.revisionId ?? "0";
    message.fromRevisionId = object.fromRevisionId ?? "0";
    return message;
  },
};

function createBaseGetFabricConfigRevisionDiffResponse(): GetFabricConfigRevisionDiffResponse {
  return { fabricId: "", diffContent: "" };
}

export const GetFabricConfigRevisionDiffResponse: MessageFns<GetFabricConfigRevisionDiffResponse> = {
  encode(message: GetFabricConfigRevisionDiffResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.diffContent !== "") {
      writer.uint32(18).string(message.diffContent);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricConfigRevisionDiffResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricConfigRevisionDiffResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.diffContent = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricConfigRevisionDiffResponse {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      diffContent: isSet(object.diffContent) ? globalThis.String(object.diffContent) : "",
    };
  },

  toJSON(message: GetFabricConfigRevisionDiffResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.diffContent !== "") {
      obj.diffContent = message.diffContent;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricConfigRevisionDiffResponse>, I>>(
    base?: I,
  ): GetFabricConfigRevisionDiffResponse {
    return GetFabricConfigRevisionDiffResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricConfigRevisionDiffResponse>, I>>(
    object: I,
  ): GetFabricConfigRevisionDiffResponse {
    const message = createBaseGetFabricConfigRevisionDiffResponse();
    message.fabricId = object.fabricId ?? "";
    message.diffContent = object.diffContent ?? "";
    return message;
  },
};

function createBaseJsonRpcRequest(): JsonRpcRequest {
  return { payload: undefined };
}

export const JsonRpcRequest: MessageFns<JsonRpcRequest> = {
  encode(message: JsonRpcRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.payload !== undefined) {
      Struct.encode(Struct.wrap(message.payload), writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JsonRpcRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJsonRpcRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.payload = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JsonRpcRequest {
    return { payload: isObject(object.payload) ? object.payload : undefined };
  },

  toJSON(message: JsonRpcRequest): unknown {
    const obj: any = {};
    if (message.payload !== undefined) {
      obj.payload = message.payload;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JsonRpcRequest>, I>>(base?: I): JsonRpcRequest {
    return JsonRpcRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JsonRpcRequest>, I>>(object: I): JsonRpcRequest {
    const message = createBaseJsonRpcRequest();
    message.payload = object.payload ?? undefined;
    return message;
  },
};

function createBaseJsonRpcResponse(): JsonRpcResponse {
  return { payload: undefined };
}

export const JsonRpcResponse: MessageFns<JsonRpcResponse> = {
  encode(message: JsonRpcResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.payload !== undefined) {
      Struct.encode(Struct.wrap(message.payload), writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JsonRpcResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJsonRpcResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.payload = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JsonRpcResponse {
    return { payload: isObject(object.payload) ? object.payload : undefined };
  },

  toJSON(message: JsonRpcResponse): unknown {
    const obj: any = {};
    if (message.payload !== undefined) {
      obj.payload = message.payload;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JsonRpcResponse>, I>>(base?: I): JsonRpcResponse {
    return JsonRpcResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JsonRpcResponse>, I>>(object: I): JsonRpcResponse {
    const message = createBaseJsonRpcResponse();
    message.payload = object.payload ?? undefined;
    return message;
  },
};

function createBaseDiscoverTopologyRequest(): DiscoverTopologyRequest {
  return { excludeDeviceIds: [], clusterOverrides: [], deviceOverrides: [], hostnameRoleHints: [] };
}

export const DiscoverTopologyRequest: MessageFns<DiscoverTopologyRequest> = {
  encode(message: DiscoverTopologyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.excludeDeviceIds) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.clusterOverrides) {
      ClusterOverride.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.deviceOverrides) {
      DeviceOverride.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.hostnameRoleHints) {
      HostnameRoleHint.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DiscoverTopologyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDiscoverTopologyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.excludeDeviceIds.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.clusterOverrides.push(ClusterOverride.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deviceOverrides.push(DeviceOverride.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.hostnameRoleHints.push(HostnameRoleHint.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DiscoverTopologyRequest {
    return {
      excludeDeviceIds: globalThis.Array.isArray(object?.excludeDeviceIds)
        ? object.excludeDeviceIds.map((e: any) => globalThis.String(e))
        : [],
      clusterOverrides: globalThis.Array.isArray(object?.clusterOverrides)
        ? object.clusterOverrides.map((e: any) => ClusterOverride.fromJSON(e))
        : [],
      deviceOverrides: globalThis.Array.isArray(object?.deviceOverrides)
        ? object.deviceOverrides.map((e: any) => DeviceOverride.fromJSON(e))
        : [],
      hostnameRoleHints: globalThis.Array.isArray(object?.hostnameRoleHints)
        ? object.hostnameRoleHints.map((e: any) => HostnameRoleHint.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DiscoverTopologyRequest): unknown {
    const obj: any = {};
    if (message.excludeDeviceIds?.length) {
      obj.excludeDeviceIds = message.excludeDeviceIds;
    }
    if (message.clusterOverrides?.length) {
      obj.clusterOverrides = message.clusterOverrides.map((e) => ClusterOverride.toJSON(e));
    }
    if (message.deviceOverrides?.length) {
      obj.deviceOverrides = message.deviceOverrides.map((e) => DeviceOverride.toJSON(e));
    }
    if (message.hostnameRoleHints?.length) {
      obj.hostnameRoleHints = message.hostnameRoleHints.map((e) => HostnameRoleHint.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DiscoverTopologyRequest>, I>>(base?: I): DiscoverTopologyRequest {
    return DiscoverTopologyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DiscoverTopologyRequest>, I>>(object: I): DiscoverTopologyRequest {
    const message = createBaseDiscoverTopologyRequest();
    message.excludeDeviceIds = object.excludeDeviceIds?.map((e) => e) || [];
    message.clusterOverrides = object.clusterOverrides?.map((e) => ClusterOverride.fromPartial(e)) || [];
    message.deviceOverrides = object.deviceOverrides?.map((e) => DeviceOverride.fromPartial(e)) || [];
    message.hostnameRoleHints = object.hostnameRoleHints?.map((e) => HostnameRoleHint.fromPartial(e)) || [];
    return message;
  },
};

function createBaseClusterOverride(): ClusterOverride {
  return { clusterId: "", topologyType: 0, tierCount: 0 };
}

export const ClusterOverride: MessageFns<ClusterOverride> = {
  encode(message: ClusterOverride, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.clusterId !== "") {
      writer.uint32(10).string(message.clusterId);
    }
    if (message.topologyType !== 0) {
      writer.uint32(16).int32(message.topologyType);
    }
    if (message.tierCount !== 0) {
      writer.uint32(24).uint32(message.tierCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClusterOverride {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClusterOverride();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.clusterId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.topologyType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.tierCount = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClusterOverride {
    return {
      clusterId: isSet(object.clusterId) ? globalThis.String(object.clusterId) : "",
      topologyType: isSet(object.topologyType) ? fabricTopologyFromJSON(object.topologyType) : 0,
      tierCount: isSet(object.tierCount) ? globalThis.Number(object.tierCount) : 0,
    };
  },

  toJSON(message: ClusterOverride): unknown {
    const obj: any = {};
    if (message.clusterId !== "") {
      obj.clusterId = message.clusterId;
    }
    if (message.topologyType !== 0) {
      obj.topologyType = fabricTopologyToJSON(message.topologyType);
    }
    if (message.tierCount !== 0) {
      obj.tierCount = Math.round(message.tierCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClusterOverride>, I>>(base?: I): ClusterOverride {
    return ClusterOverride.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClusterOverride>, I>>(object: I): ClusterOverride {
    const message = createBaseClusterOverride();
    message.clusterId = object.clusterId ?? "";
    message.topologyType = object.topologyType ?? 0;
    message.tierCount = object.tierCount ?? 0;
    return message;
  },
};

function createBaseDeviceOverride(): DeviceOverride {
  return { deviceId: "", role: 0 };
}

export const DeviceOverride: MessageFns<DeviceOverride> = {
  encode(message: DeviceOverride, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.role !== 0) {
      writer.uint32(16).int32(message.role);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceOverride {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceOverride();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.role = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceOverride {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      role: isSet(object.role) ? nodeRoleFromJSON(object.role) : 0,
    };
  },

  toJSON(message: DeviceOverride): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.role !== 0) {
      obj.role = nodeRoleToJSON(message.role);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceOverride>, I>>(base?: I): DeviceOverride {
    return DeviceOverride.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceOverride>, I>>(object: I): DeviceOverride {
    const message = createBaseDeviceOverride();
    message.deviceId = object.deviceId ?? "";
    message.role = object.role ?? 0;
    return message;
  },
};

function createBaseHostnameRoleHint(): HostnameRoleHint {
  return { pattern: "", role: 0 };
}

export const HostnameRoleHint: MessageFns<HostnameRoleHint> = {
  encode(message: HostnameRoleHint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pattern !== "") {
      writer.uint32(10).string(message.pattern);
    }
    if (message.role !== 0) {
      writer.uint32(16).int32(message.role);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HostnameRoleHint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHostnameRoleHint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pattern = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.role = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HostnameRoleHint {
    return {
      pattern: isSet(object.pattern) ? globalThis.String(object.pattern) : "",
      role: isSet(object.role) ? nodeRoleFromJSON(object.role) : 0,
    };
  },

  toJSON(message: HostnameRoleHint): unknown {
    const obj: any = {};
    if (message.pattern !== "") {
      obj.pattern = message.pattern;
    }
    if (message.role !== 0) {
      obj.role = nodeRoleToJSON(message.role);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HostnameRoleHint>, I>>(base?: I): HostnameRoleHint {
    return HostnameRoleHint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HostnameRoleHint>, I>>(object: I): HostnameRoleHint {
    const message = createBaseHostnameRoleHint();
    message.pattern = object.pattern ?? "";
    message.role = object.role ?? 0;
    return message;
  },
};

function createBaseDiscoverTopologyResponse(): DiscoverTopologyResponse {
  return { clusters: [], unknownNeighbors: [], borderLinks: [], determinations: [] };
}

export const DiscoverTopologyResponse: MessageFns<DiscoverTopologyResponse> = {
  encode(message: DiscoverTopologyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.clusters) {
      TopologyCluster.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.unknownNeighbors) {
      TopologyUnknownNeighbor.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.borderLinks) {
      TopologyBorderLink.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.determinations) {
      TopologyDetermination.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DiscoverTopologyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDiscoverTopologyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.clusters.push(TopologyCluster.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.unknownNeighbors.push(TopologyUnknownNeighbor.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.borderLinks.push(TopologyBorderLink.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.determinations.push(TopologyDetermination.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DiscoverTopologyResponse {
    return {
      clusters: globalThis.Array.isArray(object?.clusters)
        ? object.clusters.map((e: any) => TopologyCluster.fromJSON(e))
        : [],
      unknownNeighbors: globalThis.Array.isArray(object?.unknownNeighbors)
        ? object.unknownNeighbors.map((e: any) => TopologyUnknownNeighbor.fromJSON(e))
        : [],
      borderLinks: globalThis.Array.isArray(object?.borderLinks)
        ? object.borderLinks.map((e: any) => TopologyBorderLink.fromJSON(e))
        : [],
      determinations: globalThis.Array.isArray(object?.determinations)
        ? object.determinations.map((e: any) => TopologyDetermination.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DiscoverTopologyResponse): unknown {
    const obj: any = {};
    if (message.clusters?.length) {
      obj.clusters = message.clusters.map((e) => TopologyCluster.toJSON(e));
    }
    if (message.unknownNeighbors?.length) {
      obj.unknownNeighbors = message.unknownNeighbors.map((e) => TopologyUnknownNeighbor.toJSON(e));
    }
    if (message.borderLinks?.length) {
      obj.borderLinks = message.borderLinks.map((e) => TopologyBorderLink.toJSON(e));
    }
    if (message.determinations?.length) {
      obj.determinations = message.determinations.map((e) => TopologyDetermination.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DiscoverTopologyResponse>, I>>(base?: I): DiscoverTopologyResponse {
    return DiscoverTopologyResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DiscoverTopologyResponse>, I>>(object: I): DiscoverTopologyResponse {
    const message = createBaseDiscoverTopologyResponse();
    message.clusters = object.clusters?.map((e) => TopologyCluster.fromPartial(e)) || [];
    message.unknownNeighbors = object.unknownNeighbors?.map((e) => TopologyUnknownNeighbor.fromPartial(e)) || [];
    message.borderLinks = object.borderLinks?.map((e) => TopologyBorderLink.fromPartial(e)) || [];
    message.determinations = object.determinations?.map((e) => TopologyDetermination.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTopologyCluster(): TopologyCluster {
  return {
    clusterId: "",
    topologyType: 0,
    tiers: [],
    asNumbers: [],
    connectivityRules: [],
    missingDevices: [],
    fabricLinks: [],
  };
}

export const TopologyCluster: MessageFns<TopologyCluster> = {
  encode(message: TopologyCluster, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.clusterId !== "") {
      writer.uint32(10).string(message.clusterId);
    }
    if (message.topologyType !== 0) {
      writer.uint32(16).int32(message.topologyType);
    }
    for (const v of message.tiers) {
      TopologyTier.encode(v!, writer.uint32(26).fork()).join();
    }
    writer.uint32(34).fork();
    for (const v of message.asNumbers) {
      writer.uint32(v);
    }
    writer.join();
    for (const v of message.connectivityRules) {
      TopologyConnectivityRule.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.missingDevices) {
      TopologyMissingDevice.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.fabricLinks) {
      TopologyFabricLink.encode(v!, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopologyCluster {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopologyCluster();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.clusterId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.topologyType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tiers.push(TopologyTier.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag === 32) {
            message.asNumbers.push(reader.uint32());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.asNumbers.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.connectivityRules.push(TopologyConnectivityRule.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.missingDevices.push(TopologyMissingDevice.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fabricLinks.push(TopologyFabricLink.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopologyCluster {
    return {
      clusterId: isSet(object.clusterId) ? globalThis.String(object.clusterId) : "",
      topologyType: isSet(object.topologyType) ? fabricTopologyFromJSON(object.topologyType) : 0,
      tiers: globalThis.Array.isArray(object?.tiers) ? object.tiers.map((e: any) => TopologyTier.fromJSON(e)) : [],
      asNumbers: globalThis.Array.isArray(object?.asNumbers)
        ? object.asNumbers.map((e: any) => globalThis.Number(e))
        : [],
      connectivityRules: globalThis.Array.isArray(object?.connectivityRules)
        ? object.connectivityRules.map((e: any) => TopologyConnectivityRule.fromJSON(e))
        : [],
      missingDevices: globalThis.Array.isArray(object?.missingDevices)
        ? object.missingDevices.map((e: any) => TopologyMissingDevice.fromJSON(e))
        : [],
      fabricLinks: globalThis.Array.isArray(object?.fabricLinks)
        ? object.fabricLinks.map((e: any) => TopologyFabricLink.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TopologyCluster): unknown {
    const obj: any = {};
    if (message.clusterId !== "") {
      obj.clusterId = message.clusterId;
    }
    if (message.topologyType !== 0) {
      obj.topologyType = fabricTopologyToJSON(message.topologyType);
    }
    if (message.tiers?.length) {
      obj.tiers = message.tiers.map((e) => TopologyTier.toJSON(e));
    }
    if (message.asNumbers?.length) {
      obj.asNumbers = message.asNumbers.map((e) => Math.round(e));
    }
    if (message.connectivityRules?.length) {
      obj.connectivityRules = message.connectivityRules.map((e) => TopologyConnectivityRule.toJSON(e));
    }
    if (message.missingDevices?.length) {
      obj.missingDevices = message.missingDevices.map((e) => TopologyMissingDevice.toJSON(e));
    }
    if (message.fabricLinks?.length) {
      obj.fabricLinks = message.fabricLinks.map((e) => TopologyFabricLink.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TopologyCluster>, I>>(base?: I): TopologyCluster {
    return TopologyCluster.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TopologyCluster>, I>>(object: I): TopologyCluster {
    const message = createBaseTopologyCluster();
    message.clusterId = object.clusterId ?? "";
    message.topologyType = object.topologyType ?? 0;
    message.tiers = object.tiers?.map((e) => TopologyTier.fromPartial(e)) || [];
    message.asNumbers = object.asNumbers?.map((e) => e) || [];
    message.connectivityRules = object.connectivityRules?.map((e) => TopologyConnectivityRule.fromPartial(e)) || [];
    message.missingDevices = object.missingDevices?.map((e) => TopologyMissingDevice.fromPartial(e)) || [];
    message.fabricLinks = object.fabricLinks?.map((e) => TopologyFabricLink.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTopologyTier(): TopologyTier {
  return { name: "", role: 0, position: 0, switchGroups: [] };
}

export const TopologyTier: MessageFns<TopologyTier> = {
  encode(message: TopologyTier, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.role !== 0) {
      writer.uint32(16).int32(message.role);
    }
    if (message.position !== 0) {
      writer.uint32(24).uint32(message.position);
    }
    for (const v of message.switchGroups) {
      TopologySwitchGroup.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopologyTier {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopologyTier();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.role = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.position = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.switchGroups.push(TopologySwitchGroup.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopologyTier {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      role: isSet(object.role) ? nodeRoleFromJSON(object.role) : 0,
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      switchGroups: globalThis.Array.isArray(object?.switchGroups)
        ? object.switchGroups.map((e: any) => TopologySwitchGroup.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TopologyTier): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.role !== 0) {
      obj.role = nodeRoleToJSON(message.role);
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.switchGroups?.length) {
      obj.switchGroups = message.switchGroups.map((e) => TopologySwitchGroup.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TopologyTier>, I>>(base?: I): TopologyTier {
    return TopologyTier.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TopologyTier>, I>>(object: I): TopologyTier {
    const message = createBaseTopologyTier();
    message.name = object.name ?? "";
    message.role = object.role ?? 0;
    message.position = object.position ?? 0;
    message.switchGroups = object.switchGroups?.map((e) => TopologySwitchGroup.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTopologySwitchGroup(): TopologySwitchGroup {
  return { name: "", position: 0, modelName: "", deviceIds: [], hardwareSets: [], osType: 0 };
}

export const TopologySwitchGroup: MessageFns<TopologySwitchGroup> = {
  encode(message: TopologySwitchGroup, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.position !== 0) {
      writer.uint32(16).uint32(message.position);
    }
    if (message.modelName !== "") {
      writer.uint32(26).string(message.modelName);
    }
    for (const v of message.deviceIds) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.hardwareSets) {
      TopologyHardwareSet.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.osType !== 0) {
      writer.uint32(48).int32(message.osType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopologySwitchGroup {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopologySwitchGroup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.position = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.deviceIds.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.hardwareSets.push(TopologyHardwareSet.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.osType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopologySwitchGroup {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      deviceIds: globalThis.Array.isArray(object?.deviceIds)
        ? object.deviceIds.map((e: any) => globalThis.String(e))
        : [],
      hardwareSets: globalThis.Array.isArray(object?.hardwareSets)
        ? object.hardwareSets.map((e: any) => TopologyHardwareSet.fromJSON(e))
        : [],
      osType: isSet(object.osType) ? osTypeFromJSON(object.osType) : 0,
    };
  },

  toJSON(message: TopologySwitchGroup): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.deviceIds?.length) {
      obj.deviceIds = message.deviceIds;
    }
    if (message.hardwareSets?.length) {
      obj.hardwareSets = message.hardwareSets.map((e) => TopologyHardwareSet.toJSON(e));
    }
    if (message.osType !== 0) {
      obj.osType = osTypeToJSON(message.osType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TopologySwitchGroup>, I>>(base?: I): TopologySwitchGroup {
    return TopologySwitchGroup.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TopologySwitchGroup>, I>>(object: I): TopologySwitchGroup {
    const message = createBaseTopologySwitchGroup();
    message.name = object.name ?? "";
    message.position = object.position ?? 0;
    message.modelName = object.modelName ?? "";
    message.deviceIds = object.deviceIds?.map((e) => e) || [];
    message.hardwareSets = object.hardwareSets?.map((e) => TopologyHardwareSet.fromPartial(e)) || [];
    message.osType = object.osType ?? 0;
    return message;
  },
};

function createBaseTopologyHardwareSet(): TopologyHardwareSet {
  return { psuModel: "", airflow: 0, deviceIds: [] };
}

export const TopologyHardwareSet: MessageFns<TopologyHardwareSet> = {
  encode(message: TopologyHardwareSet, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.psuModel !== "") {
      writer.uint32(10).string(message.psuModel);
    }
    if (message.airflow !== 0) {
      writer.uint32(16).int32(message.airflow);
    }
    for (const v of message.deviceIds) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopologyHardwareSet {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopologyHardwareSet();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.psuModel = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.airflow = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deviceIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopologyHardwareSet {
    return {
      psuModel: isSet(object.psuModel) ? globalThis.String(object.psuModel) : "",
      airflow: isSet(object.airflow) ? airflowTypeFromJSON(object.airflow) : 0,
      deviceIds: globalThis.Array.isArray(object?.deviceIds)
        ? object.deviceIds.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: TopologyHardwareSet): unknown {
    const obj: any = {};
    if (message.psuModel !== "") {
      obj.psuModel = message.psuModel;
    }
    if (message.airflow !== 0) {
      obj.airflow = airflowTypeToJSON(message.airflow);
    }
    if (message.deviceIds?.length) {
      obj.deviceIds = message.deviceIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TopologyHardwareSet>, I>>(base?: I): TopologyHardwareSet {
    return TopologyHardwareSet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TopologyHardwareSet>, I>>(object: I): TopologyHardwareSet {
    const message = createBaseTopologyHardwareSet();
    message.psuModel = object.psuModel ?? "";
    message.airflow = object.airflow ?? 0;
    message.deviceIds = object.deviceIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseTopologyConnectivityRule(): TopologyConnectivityRule {
  return { srcGroup: "", dstGroup: "", linksPerPair: 0 };
}

export const TopologyConnectivityRule: MessageFns<TopologyConnectivityRule> = {
  encode(message: TopologyConnectivityRule, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.srcGroup !== "") {
      writer.uint32(10).string(message.srcGroup);
    }
    if (message.dstGroup !== "") {
      writer.uint32(18).string(message.dstGroup);
    }
    if (message.linksPerPair !== 0) {
      writer.uint32(24).uint32(message.linksPerPair);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopologyConnectivityRule {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopologyConnectivityRule();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.srcGroup = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.dstGroup = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.linksPerPair = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopologyConnectivityRule {
    return {
      srcGroup: isSet(object.srcGroup) ? globalThis.String(object.srcGroup) : "",
      dstGroup: isSet(object.dstGroup) ? globalThis.String(object.dstGroup) : "",
      linksPerPair: isSet(object.linksPerPair) ? globalThis.Number(object.linksPerPair) : 0,
    };
  },

  toJSON(message: TopologyConnectivityRule): unknown {
    const obj: any = {};
    if (message.srcGroup !== "") {
      obj.srcGroup = message.srcGroup;
    }
    if (message.dstGroup !== "") {
      obj.dstGroup = message.dstGroup;
    }
    if (message.linksPerPair !== 0) {
      obj.linksPerPair = Math.round(message.linksPerPair);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TopologyConnectivityRule>, I>>(base?: I): TopologyConnectivityRule {
    return TopologyConnectivityRule.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TopologyConnectivityRule>, I>>(object: I): TopologyConnectivityRule {
    const message = createBaseTopologyConnectivityRule();
    message.srcGroup = object.srcGroup ?? "";
    message.dstGroup = object.dstGroup ?? "";
    message.linksPerPair = object.linksPerPair ?? 0;
    return message;
  },
};

function createBaseTopologyMissingDevice(): TopologyMissingDevice {
  return { deviceId: "", remoteId: "", reportedBy: [], inferredModel: "", remoteSysName: "" };
}

export const TopologyMissingDevice: MessageFns<TopologyMissingDevice> = {
  encode(message: TopologyMissingDevice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.remoteId !== "") {
      writer.uint32(18).string(message.remoteId);
    }
    for (const v of message.reportedBy) {
      writer.uint32(26).string(v!);
    }
    if (message.inferredModel !== "") {
      writer.uint32(34).string(message.inferredModel);
    }
    if (message.remoteSysName !== "") {
      writer.uint32(42).string(message.remoteSysName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopologyMissingDevice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopologyMissingDevice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.remoteId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.reportedBy.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.inferredModel = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.remoteSysName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopologyMissingDevice {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      remoteId: isSet(object.remoteId) ? globalThis.String(object.remoteId) : "",
      reportedBy: globalThis.Array.isArray(object?.reportedBy)
        ? object.reportedBy.map((e: any) => globalThis.String(e))
        : [],
      inferredModel: isSet(object.inferredModel) ? globalThis.String(object.inferredModel) : "",
      remoteSysName: isSet(object.remoteSysName) ? globalThis.String(object.remoteSysName) : "",
    };
  },

  toJSON(message: TopologyMissingDevice): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.remoteId !== "") {
      obj.remoteId = message.remoteId;
    }
    if (message.reportedBy?.length) {
      obj.reportedBy = message.reportedBy;
    }
    if (message.inferredModel !== "") {
      obj.inferredModel = message.inferredModel;
    }
    if (message.remoteSysName !== "") {
      obj.remoteSysName = message.remoteSysName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TopologyMissingDevice>, I>>(base?: I): TopologyMissingDevice {
    return TopologyMissingDevice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TopologyMissingDevice>, I>>(object: I): TopologyMissingDevice {
    const message = createBaseTopologyMissingDevice();
    message.deviceId = object.deviceId ?? "";
    message.remoteId = object.remoteId ?? "";
    message.reportedBy = object.reportedBy?.map((e) => e) || [];
    message.inferredModel = object.inferredModel ?? "";
    message.remoteSysName = object.remoteSysName ?? "";
    return message;
  },
};

function createBaseTopologyFabricLink(): TopologyFabricLink {
  return { remoteDeviceId: "", fabricId: "", reportedBy: [] };
}

export const TopologyFabricLink: MessageFns<TopologyFabricLink> = {
  encode(message: TopologyFabricLink, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.remoteDeviceId !== "") {
      writer.uint32(10).string(message.remoteDeviceId);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    for (const v of message.reportedBy) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopologyFabricLink {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopologyFabricLink();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.remoteDeviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.reportedBy.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopologyFabricLink {
    return {
      remoteDeviceId: isSet(object.remoteDeviceId) ? globalThis.String(object.remoteDeviceId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      reportedBy: globalThis.Array.isArray(object?.reportedBy)
        ? object.reportedBy.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: TopologyFabricLink): unknown {
    const obj: any = {};
    if (message.remoteDeviceId !== "") {
      obj.remoteDeviceId = message.remoteDeviceId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.reportedBy?.length) {
      obj.reportedBy = message.reportedBy;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TopologyFabricLink>, I>>(base?: I): TopologyFabricLink {
    return TopologyFabricLink.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TopologyFabricLink>, I>>(object: I): TopologyFabricLink {
    const message = createBaseTopologyFabricLink();
    message.remoteDeviceId = object.remoteDeviceId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.reportedBy = object.reportedBy?.map((e) => e) || [];
    return message;
  },
};

function createBaseTopologyUnknownNeighbor(): TopologyUnknownNeighbor {
  return { remoteDeviceId: "", remoteSysName: "", seenByDeviceIds: [], remoteSysDescription: "" };
}

export const TopologyUnknownNeighbor: MessageFns<TopologyUnknownNeighbor> = {
  encode(message: TopologyUnknownNeighbor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.remoteDeviceId !== "") {
      writer.uint32(10).string(message.remoteDeviceId);
    }
    if (message.remoteSysName !== "") {
      writer.uint32(18).string(message.remoteSysName);
    }
    for (const v of message.seenByDeviceIds) {
      writer.uint32(26).string(v!);
    }
    if (message.remoteSysDescription !== "") {
      writer.uint32(34).string(message.remoteSysDescription);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopologyUnknownNeighbor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopologyUnknownNeighbor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.remoteDeviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.remoteSysName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.seenByDeviceIds.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.remoteSysDescription = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopologyUnknownNeighbor {
    return {
      remoteDeviceId: isSet(object.remoteDeviceId) ? globalThis.String(object.remoteDeviceId) : "",
      remoteSysName: isSet(object.remoteSysName) ? globalThis.String(object.remoteSysName) : "",
      seenByDeviceIds: globalThis.Array.isArray(object?.seenByDeviceIds)
        ? object.seenByDeviceIds.map((e: any) => globalThis.String(e))
        : [],
      remoteSysDescription: isSet(object.remoteSysDescription) ? globalThis.String(object.remoteSysDescription) : "",
    };
  },

  toJSON(message: TopologyUnknownNeighbor): unknown {
    const obj: any = {};
    if (message.remoteDeviceId !== "") {
      obj.remoteDeviceId = message.remoteDeviceId;
    }
    if (message.remoteSysName !== "") {
      obj.remoteSysName = message.remoteSysName;
    }
    if (message.seenByDeviceIds?.length) {
      obj.seenByDeviceIds = message.seenByDeviceIds;
    }
    if (message.remoteSysDescription !== "") {
      obj.remoteSysDescription = message.remoteSysDescription;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TopologyUnknownNeighbor>, I>>(base?: I): TopologyUnknownNeighbor {
    return TopologyUnknownNeighbor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TopologyUnknownNeighbor>, I>>(object: I): TopologyUnknownNeighbor {
    const message = createBaseTopologyUnknownNeighbor();
    message.remoteDeviceId = object.remoteDeviceId ?? "";
    message.remoteSysName = object.remoteSysName ?? "";
    message.seenByDeviceIds = object.seenByDeviceIds?.map((e) => e) || [];
    message.remoteSysDescription = object.remoteSysDescription ?? "";
    return message;
  },
};

function createBaseTopologyBorderLink(): TopologyBorderLink {
  return { localDeviceId: "", localAs: 0, remoteAs: 0, peerHostname: "" };
}

export const TopologyBorderLink: MessageFns<TopologyBorderLink> = {
  encode(message: TopologyBorderLink, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.localDeviceId !== "") {
      writer.uint32(10).string(message.localDeviceId);
    }
    if (message.localAs !== 0) {
      writer.uint32(16).uint32(message.localAs);
    }
    if (message.remoteAs !== 0) {
      writer.uint32(24).uint32(message.remoteAs);
    }
    if (message.peerHostname !== "") {
      writer.uint32(34).string(message.peerHostname);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopologyBorderLink {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopologyBorderLink();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.localDeviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.localAs = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.remoteAs = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.peerHostname = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopologyBorderLink {
    return {
      localDeviceId: isSet(object.localDeviceId) ? globalThis.String(object.localDeviceId) : "",
      localAs: isSet(object.localAs) ? globalThis.Number(object.localAs) : 0,
      remoteAs: isSet(object.remoteAs) ? globalThis.Number(object.remoteAs) : 0,
      peerHostname: isSet(object.peerHostname) ? globalThis.String(object.peerHostname) : "",
    };
  },

  toJSON(message: TopologyBorderLink): unknown {
    const obj: any = {};
    if (message.localDeviceId !== "") {
      obj.localDeviceId = message.localDeviceId;
    }
    if (message.localAs !== 0) {
      obj.localAs = Math.round(message.localAs);
    }
    if (message.remoteAs !== 0) {
      obj.remoteAs = Math.round(message.remoteAs);
    }
    if (message.peerHostname !== "") {
      obj.peerHostname = message.peerHostname;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TopologyBorderLink>, I>>(base?: I): TopologyBorderLink {
    return TopologyBorderLink.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TopologyBorderLink>, I>>(object: I): TopologyBorderLink {
    const message = createBaseTopologyBorderLink();
    message.localDeviceId = object.localDeviceId ?? "";
    message.localAs = object.localAs ?? 0;
    message.remoteAs = object.remoteAs ?? 0;
    message.peerHostname = object.peerHostname ?? "";
    return message;
  },
};

function createBaseTopologyDetermination(): TopologyDetermination {
  return {
    deviceId: "",
    hostname: "",
    status: 0,
    message: "",
    phase: 0,
    switchGroup: "",
    bindingOrder: 0,
    missingReportedBy: [],
  };
}

export const TopologyDetermination: MessageFns<TopologyDetermination> = {
  encode(message: TopologyDetermination, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.hostname !== "") {
      writer.uint32(18).string(message.hostname);
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status);
    }
    if (message.message !== "") {
      writer.uint32(34).string(message.message);
    }
    if (message.phase !== 0) {
      writer.uint32(40).int32(message.phase);
    }
    if (message.switchGroup !== "") {
      writer.uint32(50).string(message.switchGroup);
    }
    if (message.bindingOrder !== 0) {
      writer.uint32(56).uint32(message.bindingOrder);
    }
    for (const v of message.missingReportedBy) {
      writer.uint32(66).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopologyDetermination {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopologyDetermination();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.hostname = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.phase = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.switchGroup = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.bindingOrder = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.missingReportedBy.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopologyDetermination {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      hostname: isSet(object.hostname) ? globalThis.String(object.hostname) : "",
      status: isSet(object.status) ? determinationStatusFromJSON(object.status) : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      phase: isSet(object.phase) ? determinationPhaseFromJSON(object.phase) : 0,
      switchGroup: isSet(object.switchGroup) ? globalThis.String(object.switchGroup) : "",
      bindingOrder: isSet(object.bindingOrder) ? globalThis.Number(object.bindingOrder) : 0,
      missingReportedBy: globalThis.Array.isArray(object?.missingReportedBy)
        ? object.missingReportedBy.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: TopologyDetermination): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.hostname !== "") {
      obj.hostname = message.hostname;
    }
    if (message.status !== 0) {
      obj.status = determinationStatusToJSON(message.status);
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.phase !== 0) {
      obj.phase = determinationPhaseToJSON(message.phase);
    }
    if (message.switchGroup !== "") {
      obj.switchGroup = message.switchGroup;
    }
    if (message.bindingOrder !== 0) {
      obj.bindingOrder = Math.round(message.bindingOrder);
    }
    if (message.missingReportedBy?.length) {
      obj.missingReportedBy = message.missingReportedBy;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TopologyDetermination>, I>>(base?: I): TopologyDetermination {
    return TopologyDetermination.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TopologyDetermination>, I>>(object: I): TopologyDetermination {
    const message = createBaseTopologyDetermination();
    message.deviceId = object.deviceId ?? "";
    message.hostname = object.hostname ?? "";
    message.status = object.status ?? 0;
    message.message = object.message ?? "";
    message.phase = object.phase ?? 0;
    message.switchGroup = object.switchGroup ?? "";
    message.bindingOrder = object.bindingOrder ?? 0;
    message.missingReportedBy = object.missingReportedBy?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000).toString();
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
